const esEmojis = {
    '😀': {
        name: 'sonriendo',
        keywords: ['cara', 'divertido', 'feliz', 'sonrisa', 'cara sonriendo'],
    },
    '😃': {
        name: 'sonriente',
        keywords: ['cara', 'divertido', 'risa', 'sonriendo', 'cara sonriendo con ojos grandes'],
    },
    '😄': {
        name: 'sonrisa',
        keywords: ['abierta', 'cara', 'ojo', 'sonrisa', 'cara sonriendo con ojos sonrientes'],
    },
    '😁': {
        name: 'sonrisa_burlona',
        keywords: ['cara', 'ojo', 'risa', 'sonrisa', 'cara radiante con ojos sonrientes'],
    },
    '😆': {
        name: 'risa',
        keywords: ['abierta', 'boca', 'cara', 'risa', 'cara sonriendo con los ojos cerrados'],
    },
    '😅': {
        name: 'sonrisa_con_sudor',
        keywords: ['cara', 'frío', 'risa', 'sudor', 'cara sonriendo con sudor frío'],
    },
    '🤣': {
        name: 'muriéndose_de_risa',
        keywords: ['cara', 'carcajada', 'ojos cerrados', 'risa', 'cara revolviéndose de la risa'],
    },
    '😂': {
        name: 'alegría',
        keywords: ['cara', 'felicidad', 'lágrima', 'risa', 'cara llorando de risa'],
    },
    '🙂': {
        name: 'cara_ligeramente_sonriente',
        keywords: ['cara', 'sonrisa', 'cara sonriendo ligeramente'],
    },
    '🙃': {
        name: 'cara_boca_arriba',
        keywords: ['cara', 'revés', 'cara al revés'],
    },
    '😉': {
        name: 'guiño',
        keywords: ['cara', 'guiño', 'cara guiñando el ojo'],
    },
    '😊': {
        name: 'sonrojo',
        keywords: ['cara', 'ojo', 'rubor', 'sonrisa', 'cara feliz con ojos sonrientes'],
    },
    '😇': {
        name: 'inocente',
        keywords: ['ángel', 'cara', 'halo', 'sonrisa', 'cara sonriendo con aureola'],
    },
    '🥰': {
        name: 'cara_sonriendo_con_corazones',
        keywords: ['adorar', 'amor', 'corazones', 'enamorada', 'enamorado', 'cara sonriendo con corazones'],
    },
    '😍': {
        name: 'ojos_de_corazón',
        keywords: ['amor', 'cara', 'corazón', 'sonrisa', 'cara sonriendo con ojos de corazón'],
    },
    '🤩': {
        name: 'ojos_estrella',
        keywords: ['cara', 'estrellas', 'sonrisa', 'cara sonriendo con estrellas'],
    },
    '😘': {
        name: 'beso_de_corazón',
        keywords: ['beso', 'cara', 'cara lanzando un beso'],
    },
    '😗': {
        name: 'besos',
        keywords: ['beso', 'cara', 'cara besando'],
    },
    '☺️': {
        name: 'relajado',
        keywords: ['cara', 'contorno', 'relajado', 'sonrisa', 'cara sonriente'],
    },
    '😚': {
        name: 'beso_con_ojos_cerrados',
        keywords: ['beso', 'cara', 'cerrado', 'ojo', 'cara besando con los ojos cerrados'],
    },
    '😙': {
        name: 'besando_con_ojos_sonrientes',
        keywords: ['beso', 'cara', 'ojo', 'sonrisa', 'cara besando con ojos sonrientes'],
    },
    '🥲': {
        name: 'cara_sonriente_con_lágrima',
        keywords: ['agradecido', 'aliviado', 'emocionado', 'lágrima', 'orgulloso', 'sonrisa', 'cara sonriente con lágrima'],
    },
    '😋': {
        name: 'sabroso',
        keywords: ['cara', 'delicioso', 'hambre', 'rico', 'cara saboreando comida'],
    },
    '😛': {
        name: 'lengua_fuera',
        keywords: ['cara', 'lengua', 'cara sacando la lengua'],
    },
    '😜': {
        name: 'lengua_fuera_con_guiño_de_ojos',
        keywords: ['cara', 'guiño', 'lengua', 'ojo', 'cara sacando la lengua y guiñando un ojo'],
    },
    '🤪': {
        name: 'cara_loco',
        keywords: ['grande', 'ojo', 'pequeño', 'cara de loco'],
    },
    '😝': {
        name: 'lengua_fuera_con_ojos_cerrados',
        keywords: ['cara', 'lengua', 'ojo', 'sabor', 'cara con ojos cerrados y lengua fuera'],
    },
    '🤑': {
        name: 'cara_con_dinero_en_la_boca',
        keywords: ['boca', 'cara', 'dinero', 'cara con lengua de dinero'],
    },
    '🤗': {
        name: 'cara_abrazando',
        keywords: ['abrazo', 'cara', 'sonrisa', 'cara con manos abrazando'],
    },
    '🤭': {
        name: 'cara_con_mano_sobre_boca',
        keywords: ['ostras', 'uy', 'vaya', 'cara con mano sobre la boca'],
    },
    '🤫': {
        name: 'calla',
        keywords: ['callado', 'silencio', 'cara pidiendo silencio'],
    },
    '🤔': {
        name: 'cara_pensativa',
        keywords: ['cara', 'duda', 'pensando', 'cara pensativa'],
    },
    '🤐': {
        name: 'cara_con_boca_de_cremallera',
        keywords: ['boca', 'cara', 'cremallera', 'cara con la boca cerrada con cremallera'],
    },
    '🤨': {
        name: 'cara_con_ceja_levantada',
        keywords: ['desconfiado', 'escéptico', 'cara con ceja alzada'],
    },
    '😐': {
        name: 'cara_neutra',
        keywords: ['cara', 'inexpresivo', 'neutral'],
    },
    '😑': {
        name: 'inexpresivo',
        keywords: ['cara', 'inexpresión', 'inexpresiva', 'inexpresivo', 'cara sin expresión'],
    },
    '😶': {
        name: 'prohibido_hablar',
        keywords: ['boca', 'callado', 'cara', 'silencio', 'cara sin boca'],
    },
    '😶‍🌫️': {
        name: 'prohibido_hablar',
        keywords: ['atontado', 'cara', 'despistado', 'distraído', 'nubes', 'parra', 'cara en las nubes'],
    },
    '😏': {
        name: 'sonrisita',
        keywords: ['cara', 'listillo', 'superioridad', 'cara sonriendo con superioridad'],
    },
    '😒': {
        name: 'no_interesado',
        keywords: ['cara', 'insatisfacción', 'rechazo', 'cara de desaprobación'],
    },
    '🙄': {
        name: 'cara_con_ojos_en_blanco',
        keywords: ['cara', 'frustración', 'ojos', 'vueltos', 'cara con ojos en blanco'],
    },
    '😬': {
        name: 'muecas',
        keywords: ['cara', 'mueca', 'cara haciendo una mueca'],
    },
    '😮‍💨': {
        name: 'boca_abierta',
        keywords: ['cara', 'exhalar', 'resoplido', 'respirar', 'silbato', 'silbido', 'cara exhalando'],
    },
    '🤥': {
        name: 'cara_de_mentiroso',
        keywords: ['cara', 'mentiroso', 'nariz', 'pinocho', 'cara de mentiroso'],
    },
    '😌': {
        name: 'aliviado',
        keywords: ['aliviado', 'cara', 'cara de alivio'],
    },
    '😔': {
        name: 'pensativo',
        keywords: ['alicaído', 'cara', 'desanimado', 'pensativo', 'cara desanimada'],
    },
    '😪': {
        name: 'soñoliento',
        keywords: ['cara', 'dormir', 'sueño', 'cara de sueño'],
    },
    '🤤': {
        name: 'cara-babeando',
        keywords: ['baba', 'babeando', 'cara'],
    },
    '😴': {
        name: 'durmiendo',
        keywords: ['cara', 'dormido', 'sueño', 'zzz', 'cara durmiendo'],
    },
    '😷': {
        name: 'máscara',
        keywords: ['cara', 'enfermo', 'malo', 'máscara', 'cara con mascarilla médica'],
    },
    '🤒': {
        name: 'cara_con_termómetro',
        keywords: ['cara', 'enfermo', 'malo', 'termómetro', 'cara con termómetro'],
    },
    '🤕': {
        name: 'cara_con_la_cabeza_vendada',
        keywords: ['cara', 'dolor', 'herida', 'venda', 'cara con la cabeza vendada'],
    },
    '🤢': {
        name: 'cara_de_asco',
        keywords: ['cara', 'náuseas', 'vomitar', 'cara de náuseas'],
    },
    '🤮': {
        name: 'cara_vomitando',
        keywords: ['enfermo', 'malo', 'vomitar', 'cara vomitando'],
    },
    '🤧': {
        name: 'cara_estornudando',
        keywords: ['cara', 'estornudar', 'estornudo', 'pañuelo', 'cara estornudando'],
    },
    '🥵': {
        name: 'cara_con_calor',
        keywords: ['calor', 'cara roja', 'fiebre', 'golpe de calor', 'sudor', 'cara con calor'],
    },
    '🥶': {
        name: 'cara_con_frío',
        keywords: ['cara congelada', 'congelado', 'frío', 'helado', 'cara con frío'],
    },
    '🥴': {
        name: 'cara_de_grogui',
        keywords: ['atontado', 'entonado', 'grogui', 'intoxicado', 'mareado', 'cara de grogui'],
    },
    '😵': {
        name: 'cara_de_mareo',
        keywords: ['cara', 'mareo', 'cara mareada'],
    },
    '😵‍💫': {
        name: 'cara_de_mareo',
        keywords: ['alucinado', 'desmayado', 'hipnotizado', 'locura', 'mareado', 'problema', 'cara con ojos de espiral'],
    },
    '🤯': {
        name: 'cabeza_explotando',
        keywords: ['cabeza', 'explosión', 'cabeza explotando'],
    },
    '🤠': {
        name: 'cara_con_sombrero_vaquero',
        keywords: ['cara', 'sombrero', 'vaquera', 'vaquero', 'cara con sombrero de vaquero'],
    },
    '🥳': {
        name: 'cara_de_fiesta',
        keywords: ['capirote', 'celebración', 'fiesta', 'gorro', 'matasuegras', 'cara de fiesta'],
    },
    '🥸': {
        name: 'cara_disfrazada',
        keywords: ['careta', 'disfraz', 'disimulo', 'gafas', 'incógnito', 'nariz', 'cara disfrazada'],
    },
    '😎': {
        name: 'gafas_de_sol',
        keywords: ['cara', 'gafas', 'guay', 'sol', 'cara sonriendo con gafas de sol'],
    },
    '🤓': {
        name: 'cara_de_nerd',
        keywords: ['cara', 'empollón', 'friki', 'friqui', 'cara de empollón'],
    },
    '🧐': {
        name: 'cara_con_monóculo',
        keywords: ['aristocrático', 'estirado', 'cara con monóculo'],
    },
    '😕': {
        name: 'desconcertado',
        keywords: ['cara', 'confuso', 'cara de confusión'],
    },
    '😟': {
        name: 'preocupado',
        keywords: ['cara', 'preocupación', 'preocupado', 'cara preocupada'],
    },
    '🙁': {
        name: 'cara_con_el_ceño_ligeramente_fruncido',
        keywords: ['cara', 'ceño', 'fruncido', 'cara con el ceño ligeramente fruncido'],
    },
    '☹️': {
        name: 'cara_blanca_ceñuda',
        keywords: ['cara', 'ceño', 'fruncido', 'cara con el ceño fruncido'],
    },
    '😮': {
        name: 'boca_abierta',
        keywords: ['boca', 'cara', 'cara con la boca abierta'],
    },
    '😯': {
        name: 'silencioso',
        keywords: ['alucinado', 'cara', 'estupefacto', 'sorprendido', 'cara estupefacta'],
    },
    '😲': {
        name: 'asombrado',
        keywords: ['alucinado', 'asombrado', 'cara', 'pasmado', 'cara asombrada'],
    },
    '😳': {
        name: 'sonrojado',
        keywords: ['cara', 'colorado', 'sonrojado', 'cara sonrojada'],
    },
    '🥺': {
        name: 'cara_de_por_favor',
        keywords: ['implorar', 'ojos adorables', 'piedad', 'por favor', 'cara suplicante'],
    },
    '😦': {
        name: 'ceñudo',
        keywords: ['boca abierta', 'cara', 'ceño fruncido con boca abierta', 'cara con el ceño fruncido y la boca abierta'],
    },
    '😧': {
        name: 'angustiado',
        keywords: ['angustia', 'angustiado', 'cara', 'cara angustiada'],
    },
    '😨': {
        name: 'temeroso',
        keywords: ['asustado', 'cara', 'miedo', 'miedoso', 'cara asustada'],
    },
    '😰': {
        name: 'sudor_frío',
        keywords: ['ansiedad', 'cara', 'frío', 'sudor', 'cara con ansiedad y sudor'],
    },
    '😥': {
        name: 'decepcionado_aliviado',
        keywords: ['aliviado', 'cara', 'decepcionado', 'menos mal', 'cara triste pero aliviada'],
    },
    '😢': {
        name: 'lloros',
        keywords: ['cara', 'lágrima', 'llorar', 'triste', 'cara llorando'],
    },
    '😭': {
        name: 'sollozo',
        keywords: ['cara', 'lágrima', 'llorar', 'triste', 'cara llorando fuerte'],
    },
    '😱': {
        name: 'grito',
        keywords: ['asustado', 'cara', 'miedo', 'pánico', 'cara gritando de miedo'],
    },
    '😖': {
        name: 'aturdido',
        keywords: ['cara', 'frustrado', 'cara de frustración'],
    },
    '😣': {
        name: 'tenacidad',
        keywords: ['cara', 'desesperación', 'frustración', 'cara desesperada'],
    },
    '😞': {
        name: 'decepcionado',
        keywords: ['cara', 'decepción', 'decepcionado', 'cara decepcionada'],
    },
    '😓': {
        name: 'sudor',
        keywords: ['cara', 'frío', 'sudor', 'cara con sudor frío'],
    },
    '😩': {
        name: 'cansado',
        keywords: ['agotado', 'cansado', 'cara', 'cara agotada'],
    },
    '😫': {
        name: 'cara_cansada',
        keywords: ['cansado', 'cara', 'cara cansada'],
    },
    '🥱': {
        name: 'cara_de_bostezo',
        keywords: ['aburrido', 'bostezo', 'cansado', 'dormido', 'sueño', 'cara de bostezo'],
    },
    '😤': {
        name: 'triunfo',
        keywords: ['cabreo', 'cara', 'enfado', 'cara resoplando'],
    },
    '😡': {
        name: 'rabia',
        keywords: ['cabreo', 'cara', 'enfadado', 'furia', 'cara cabreada'],
    },
    '😠': {
        name: 'enfado',
        keywords: ['cara', 'enfadado', 'histérico', 'cara enfadada'],
    },
    '🤬': {
        name: 'cara_con_símbolos_en_boca',
        keywords: ['maldecir', 'palabrota', 'símbolo', 'cara con símbolos en la boca'],
    },
    '😈': {
        name: 'diablillo_sonriente',
        keywords: ['cara', 'cuernos', 'demonio', 'sonrisa', 'cara sonriendo con cuernos'],
    },
    '👿': {
        name: 'diablillo',
        keywords: ['cara', 'cuernos', 'demonio', 'diablo', 'cara enfadada con cuernos'],
    },
    '💀': {
        name: 'calavera',
        keywords: ['cara', 'cuento', 'monstruo', 'muerte', 'calavera'],
    },
    '☠️': {
        name: 'calavera_y_tibias_cruzadas',
        keywords: ['calavera', 'cara', 'huesos', 'muerte', 'calavera y huesos cruzados'],
    },
    '💩': {
        name: 'zurullo',
        keywords: ['caca', 'cómic', 'mierda', 'mojón', 'caca con ojos'],
    },
    '🤡': {
        name: 'cara_payaso',
        keywords: ['cara', 'payaso', 'cara de payaso'],
    },
    '👹': {
        name: 'ogro_japonés',
        keywords: ['cara', 'cuento', 'cuernos', 'sonrisa', 'demonio japonés oni'],
    },
    '👺': {
        name: 'duende_japonés',
        keywords: ['cara', 'cuento', 'fantasía', 'monstruo', 'tengu', 'demonio japonés tengu'],
    },
    '👻': {
        name: 'fantasma',
        keywords: ['cara', 'criatura', 'cuento', 'monstruo', 'fantasma'],
    },
    '👽': {
        name: 'extraterrestre',
        keywords: ['alien', 'cara', 'criatura', 'extraterrestre', 'ovni', 'alienígena'],
    },
    '👾': {
        name: 'invasor_del_espacio',
        keywords: ['alien', 'cara', 'criatura', 'extraterrestre', 'ovni', 'monstruo alienígena'],
    },
    '🤖': {
        name: 'cara_de_robot',
        keywords: ['cara', 'monstruo', 'robot'],
    },
    '😺': {
        name: 'gato_sonriente',
        keywords: ['cara', 'feliz', 'gato alegre', 'gato feliz', 'sonrisa', 'gato sonriendo'],
    },
    '😸': {
        name: 'gato_sonrisa',
        keywords: ['cara', 'gato', 'ojos', 'sonriente', 'sonrisa', 'gato sonriendo con ojos sonrientes'],
    },
    '😹': {
        name: 'gato_alegre',
        keywords: ['cara', 'gato', 'lágrima', 'risa', 'gato llorando de risa'],
    },
    '😻': {
        name: 'gato_con_ojos_de_corazón',
        keywords: ['cara', 'corazón', 'enamorado', 'gato', 'gato sonriendo con ojos de corazón'],
    },
    '😼': {
        name: 'gato_con_sonrisa_de_satisfacción',
        keywords: ['cara', 'gato', 'irónico', 'sonrisa', 'gato haciendo una mueca'],
    },
    '😽': {
        name: 'gato_besando',
        keywords: ['beso', 'cara', 'cariñoso', 'gato', 'gato besando'],
    },
    '🙀': {
        name: 'gato_gritando',
        keywords: ['cara', 'gato', 'pánico', 'preocupación', 'sorpresa', 'gato asustado'],
    },
    '😿': {
        name: 'cara_de_gato_lloroso',
        keywords: ['cara', 'gato', 'lágrima', 'pena', 'triste', 'gato llorando'],
    },
    '😾': {
        name: 'gato_enfadado',
        keywords: ['cara', 'enfadado', 'gato'],
    },
    '🙈': {
        name: 'mono_ojos_tapados',
        keywords: ['cara', 'mal', 'mono', 'prohibido', 'mono con los ojos tapados'],
    },
    '🙉': {
        name: 'mono_sordo',
        keywords: ['cara', 'mal', 'mono', 'prohibido', 'mono con los oídos tapados'],
    },
    '🙊': {
        name: 'no_decir_nada',
        keywords: ['cara', 'mal', 'mono', 'prohibido', 'mono con la boca tapada'],
    },
    '💋': {
        name: 'beso',
        keywords: ['beso', 'labios', 'romance', 'marca de beso'],
    },
    '💌': {
        name: 'carta_de_amor',
        keywords: ['amor', 'carta', 'corazón', 'correo', 'carta de amor'],
    },
    '💘': {
        name: 'cupido',
        keywords: ['amor', 'corazón', 'emoción', 'flecha', 'corazón con flecha'],
    },
    '💝': {
        name: 'corazón_de_regalo',
        keywords: ['corazón', 'emoción', 'lazo', 'san valentín', 'corazón con lazo'],
    },
    '💖': {
        name: 'corazón_refulgente',
        keywords: ['amor', 'brillante', 'emoción', 'corazón brillante'],
    },
    '💗': {
        name: 'ritmo_cardíaco',
        keywords: ['corazón', 'creciente', 'emocionado', 'latido', 'nervioso'],
    },
    '💓': {
        name: 'latido',
        keywords: ['amor', 'corazón', 'emoción', 'latido', 'corazón latiendo'],
    },
    '💞': {
        name: 'corazones_girando',
        keywords: ['corazón', 'giratorio', 'corazones giratorios'],
    },
    '💕': {
        name: 'dos_corazones',
        keywords: ['amantes', 'amor', 'corazón', 'dos corazones'],
    },
    '💟': {
        name: 'corazón_decorativo',
        keywords: ['corazón', 'adorno de corazón'],
    },
    '❣️': {
        name: 'signo_de_exclamación_en_forma_de_corazón_grueso',
        keywords: ['corazón', 'exclamación', 'puntuación', 'exclamación de corazón'],
    },
    '💔': {
        name: 'corazón_partido',
        keywords: ['corazón', 'emoción', 'partido', 'roto'],
    },
    '❤️‍🔥': {
        name: 'corazón',
        keywords: ['amor', 'corazón', 'fuego', 'llamas', 'lujuria', 'pasión', 'corazón en llamas'],
    },
    '❤️‍🩹': {
        name: 'corazón',
        keywords: ['bien', 'cura', 'mejor', 'mejora', 'recuperación', 'salud', 'corazón curándose'],
    },
    '❤️': {
        name: 'corazón',
        keywords: ['corazón', 'emoción', 'rojo'],
    },
    '🧡': {
        name: 'corazón_naranja',
        keywords: ['corazón', 'emoción', 'naranja'],
    },
    '💛': {
        name: 'corazón_amarillo',
        keywords: ['amarillo', 'corazón', 'emoción'],
    },
    '💚': {
        name: 'corazón_verde',
        keywords: ['corazón', 'emoción', 'verde'],
    },
    '💙': {
        name: 'corazón_azul',
        keywords: ['azul', 'corazón', 'emoción'],
    },
    '💜': {
        name: 'corazón_púrpura',
        keywords: ['corazón', 'emoción', 'morado'],
    },
    '🤎': {
        name: 'corazón_marrón',
        keywords: ['corazón', 'emoción', 'marrón'],
    },
    '🖤': {
        name: 'corazón_negro',
        keywords: ['corazón', 'negro'],
    },
    '🤍': {
        name: 'corazón_blanco',
        keywords: ['blanco', 'corazón', 'emoción'],
    },
    '💯': {
        name: '100',
        keywords: ['100', 'pleno', 'puntos', 'cien puntos'],
    },
    '💢': {
        name: 'ira',
        keywords: ['cómic', 'enfadado', 'enfado', 'símbolo de enfado'],
    },
    '💥': {
        name: 'bum',
        keywords: ['cómic', 'colisión'],
    },
    '💫': {
        name: 'mareado',
        keywords: ['cómic', 'emoción', 'estrella', 'mareo', 'símbolo de mareo'],
    },
    '💦': {
        name: 'gotas_de_sudor',
        keywords: ['cómic', 'emoción', 'sudor', 'gotas de sudor'],
    },
    '💨': {
        name: 'guión',
        keywords: ['carrera', 'cómic', 'correr', 'humo', 'salir corriendo'],
    },
    '🕳️': {
        name: 'agujero',
        keywords: ['orificio', 'agujero'],
    },
    '💣': {
        name: 'bomba',
        keywords: ['cómic', 'emoción', 'bomba'],
    },
    '💬': {
        name: 'bocadillo_de_diálogo',
        keywords: ['bocadillo', 'cómic', 'conversación', 'diálogo', 'bocadillo de diálogo'],
    },
    '👁️‍🗨️': {
        name: 'ojo-en-globo-de-texto',
        keywords: ['bocadillo de texto', 'ojo', 'testigo', 'ojo en bocadillo de texto'],
    },
    '🗨️': {
        name: 'bocadillo_a_la_izquierda',
        keywords: ['bocadillo', 'burbuja', 'conversación', 'diálogo', 'bocadillo de diálogo por la izquierda'],
    },
    '🗯️': {
        name: 'bocadillo_para_palabras_de_enfado',
        keywords: ['bocadillo', 'cabreo', 'enfado', 'rabia', 'bocadillo de enfado por la derecha'],
    },
    '💭': {
        name: 'bocadillo_para_pensamientos',
        keywords: ['bocadillo', 'burbuja', 'cómic', 'pensamiento', 'bocadillo de pensamiento'],
    },
    '💤': {
        name: 'zzz',
        keywords: ['cómic', 'dormir', 'sueño', 'zzz', 'símbolo de sueño'],
    },
    '👋': {
        name: 'hola',
        keywords: ['agitar', 'mano', 'saludar', 'saludo', 'mano saludando'],
    },
    '🤚': {
        name: 'palma_de_mano_levantada',
        keywords: ['dorso', 'levantado', 'mano', 'dorso de la mano'],
    },
    '🖐️': {
        name: 'mano_levantada_con_los_dedos_extendidos',
        keywords: ['abierta', 'dedo', 'mano'],
    },
    '✋': {
        name: 'mano',
        keywords: ['choca esos cinco', 'levantada', 'mano'],
    },
    '🖖': {
        name: 'saludo_de_spock',
        keywords: ['mano', 'saludo', 'spock', 'vulcano'],
    },
    '👌': {
        name: 'mano_con_signo_de_aprobación',
        keywords: ['aprobación', 'mano', 'ok', 'señal de aprobación con la mano'],
    },
    '🤌': {
        name: 'dedos_juntos_apuntando_hacia_arriba',
        keywords: ['dedos', 'gesto', 'italia', 'italiano', 'mano', 'sarcasmo', 'dedos juntos apuntando hacia arriba'],
    },
    '🤏': {
        name: 'mano_pellizcando',
        keywords: ['pellizco', 'poco', 'poquito', 'mano pellizcando'],
    },
    '✌️': {
        name: 'v',
        keywords: ['mano', 'señal de victoria', 'victoria', 'mano con señal de victoria'],
    },
    '🤞': {
        name: 'dedos_cruzados',
        keywords: ['cruzar', 'dedos', 'mano', 'suerte', 'dedos cruzados'],
    },
    '🤟': {
        name: 'te_amo_en_lenguaje_de_señas',
        keywords: ['mano', 'quiero', 'gesto de te quiero'],
    },
    '🤘': {
        name: 'los_cuernos',
        keywords: ['cuernos', 'dedo', 'mano', 'rock', 'mano haciendo el signo de cuernos'],
    },
    '🤙': {
        name: 'mano_llámame',
        keywords: ['llamar', 'mano', 'meñique', 'pulgar', 'mano haciendo el gesto de llamar'],
    },
    '👈': {
        name: 'apuntando_hacia_la_izquierda',
        keywords: ['dedo', 'índice', 'izquierda', 'mano', 'dorso de mano con índice a la izquierda'],
    },
    '👉': {
        name: 'apuntando_hacia_la_derecha',
        keywords: ['dedo', 'derecha', 'índice', 'mano', 'dorso de mano con índice a la derecha'],
    },
    '👆': {
        name: 'apuntando_hacia_arriba_2',
        keywords: ['apuntar', 'arriba', 'dedo', 'mano', 'dorso de mano con índice hacia arriba'],
    },
    '🖕': {
        name: 'dedo_corazón',
        keywords: ['corazón', 'dedo', 'mano', 'peineta', 'dedo corazón hacia arriba'],
    },
    '👇': {
        name: 'apuntando_hacia_abajo',
        keywords: ['abajo', 'apuntar', 'dedo', 'mano', 'dorso de mano con índice hacia abajo'],
    },
    '☝️': {
        name: 'apuntando_hacia_arriba',
        keywords: ['apuntar', 'arriba', 'dedo', 'mano', 'dedo índice hacia arriba'],
    },
    '👍': {
        name: '+1',
        keywords: ['arriba', 'mano', 'pulgar', 'señal', 'pulgar hacia arriba'],
    },
    '👎': {
        name: '-1',
        keywords: ['abajo', 'mano', 'pulgar', 'señal', 'pulgar hacia abajo'],
    },
    '✊': {
        name: 'puño',
        keywords: ['cerrado', 'mano', 'puñetazo', 'puño', 'puño en alto'],
    },
    '👊': {
        name: 'puñetazo',
        keywords: ['puñetazo', 'puño', 'puño cerrado'],
    },
    '🤛': {
        name: 'puño-hacia-izquierda',
        keywords: ['izquierda', 'puño', 'puño hacia la izquierda'],
    },
    '🤜': {
        name: 'puño_hacia_la_derecha',
        keywords: ['derecha', 'puño', 'puño hacia la derecha'],
    },
    '👏': {
        name: 'aplauso',
        keywords: ['aplaudir', 'manos', 'palmas', 'señal', 'manos aplaudiendo'],
    },
    '🙌': {
        name: 'manos_levantadas',
        keywords: ['celebración', 'gesto', 'hurra', 'mano', 'manos levantadas celebrando'],
    },
    '👐': {
        name: 'manos_abiertas',
        keywords: ['abiertas', 'manos'],
    },
    '🤲': {
        name: 'palmas_hacia_arriba_juntas',
        keywords: ['oración', 'palmas hacia arriba juntas'],
    },
    '🤝': {
        name: 'apretón-manos',
        keywords: ['acuerdo', 'apretón', 'manos', 'apretón de manos'],
    },
    '🙏': {
        name: 'rezo',
        keywords: ['gracias', 'mano', 'oración', 'orar', 'por favor', 'rezar', 'manos en oración'],
    },
    '✍️': {
        name: 'mano_escribiendo',
        keywords: ['escribir', 'lápiz', 'mano', 'mano escribiendo'],
    },
    '💅': {
        name: 'cuidado_de_las_uñas',
        keywords: ['cosmética', 'esmalte', 'manicura', 'uñas', 'pintarse las uñas'],
    },
    '🤳': {
        name: 'selfi',
        keywords: ['autofoto', 'cámara', 'selfie', 'teléfono', 'selfi'],
    },
    '💪': {
        name: 'músculo',
        keywords: ['bíceps', 'cómic', 'flexionado', 'fuerte', 'músculo'],
    },
    '🦾': {
        name: 'brazo_mecánico',
        keywords: ['accesibilidad', 'ortopedia', 'prótesis', 'brazo mecánico'],
    },
    '🦿': {
        name: 'pierna_mecánica',
        keywords: ['accesibilidad', 'ortopedia', 'prótesis', 'pierna mecánica'],
    },
    '🦵': {
        name: 'pierna',
        keywords: ['extremidad', 'patada', 'pierna'],
    },
    '🦶': {
        name: 'pie_humano',
        keywords: ['patada', 'pisotón', 'pie'],
    },
    '👂': {
        name: 'oreja',
        keywords: ['cuerpo', 'oreja'],
    },
    '🦻': {
        name: 'oreja_con_audifono',
        keywords: ['accesibilidad', 'audífono', 'prótesis auditiva', 'sordo', 'oreja con audífono'],
    },
    '👃': {
        name: 'nariz',
        keywords: ['cuerpo', 'nariz'],
    },
    '🧠': {
        name: 'cerebro',
        keywords: ['inteligente', 'cerebro'],
    },
    '🫀': {
        name: 'corazón_humano',
        keywords: ['cardiología', 'corazón', 'latido', 'órgano', 'pulso', 'anatomía', 'corazón humano'],
    },
    '🫁': {
        name: 'pulmones',
        keywords: ['exhalar', 'inhalar', 'órgano', 'respiración', 'respirar', 'pulmones'],
    },
    '🦷': {
        name: 'diente',
        keywords: ['dentista', 'molar', 'muela', 'diente'],
    },
    '🦴': {
        name: 'hueso',
        keywords: ['esqueleto', 'hueso'],
    },
    '👀': {
        name: 'ojos',
        keywords: ['cara', 'ojos'],
    },
    '👁️': {
        name: 'ojo',
        keywords: ['cuerpo', 'ojo'],
    },
    '👅': {
        name: 'lengua',
        keywords: ['cuerpo', 'lengua'],
    },
    '👄': {
        name: 'labios',
        keywords: ['labios', 'boca'],
    },
    '👶': {
        name: 'bebé',
        keywords: ['joven', 'niño', 'bebé'],
    },
    '🧒': {
        name: 'niño',
        keywords: ['crío', 'género', 'joven', 'neutro', 'infante'],
    },
    '👦': {
        name: 'chico',
        keywords: ['joven', 'niño'],
    },
    '👧': {
        name: 'niña',
        keywords: ['chica', 'joven', 'niña'],
    },
    '🧑': {
        name: 'adulto',
        keywords: ['género', 'neutro', 'persona adulta'],
    },
    '👱': {
        name: 'persona_rubia',
        keywords: ['rubia', 'rubias', 'rubio', 'rubios', 'persona adulta rubia'],
    },
    '👨': {
        name: 'hombre',
        keywords: ['adulto', 'hombre'],
    },
    '🧔': {
        name: 'persona_barba',
        keywords: ['barbas', 'barbudo', 'persona', 'persona con barba'],
    },
    '🧔‍♂️': {
        name: 'persona_barba',
        keywords: ['barba', 'hombre', 'hombre: barba'],
    },
    '🧔‍♀️': {
        name: 'persona_barba',
        keywords: ['barba', 'mujer', 'mujer: barba'],
    },
    '👨‍🦰': {
        name: 'hombre_pelirrojo',
        keywords: ['adulto', 'hombre', 'pelo pelirrojo'],
    },
    '👨‍🦱': {
        name: 'hombre_con_pelo_rizado',
        keywords: ['adulto', 'hombre', 'pelo rizado'],
    },
    '👨‍🦳': {
        name: 'hombre_con_pelo_blanco',
        keywords: ['adulto', 'hombre', 'pelo blanco'],
    },
    '👨‍🦲': {
        name: 'hombre_calvo',
        keywords: ['adulto', 'hombre', 'sin pelo'],
    },
    '👩': {
        name: 'mujer',
        keywords: ['adulta', 'mujer'],
    },
    '👩‍🦰': {
        name: 'mujer_pelirroja',
        keywords: ['adulta', 'mujer', 'pelo pelirrojo'],
    },
    '🧑‍🦰': {
        name: 'persona_pelirroja',
        keywords: ['género', 'neutro', 'pelo pelirrojo', 'persona adulta'],
    },
    '👩‍🦱': {
        name: 'mujer_de_pelo_rizado',
        keywords: ['adulta', 'mujer', 'pelo rizado'],
    },
    '🧑‍🦱': {
        name: 'persona_con_pelo_rizado',
        keywords: ['género', 'neutro', 'pelo rizado', 'persona adulta'],
    },
    '👩‍🦳': {
        name: 'mujer_con_pelo_blanco',
        keywords: ['adulta', 'mujer', 'pelo blanco'],
    },
    '🧑‍🦳': {
        name: 'persona_con_pelo_blanco',
        keywords: ['género', 'neutro', 'pelo blanco', 'persona adulta'],
    },
    '👩‍🦲': {
        name: 'mujer_calva',
        keywords: ['adulta', 'mujer', 'sin pelo'],
    },
    '🧑‍🦲': {
        name: 'persona_calva',
        keywords: ['género', 'neutro', 'persona adulta', 'sin pelo'],
    },
    '👱‍♀️': {
        name: 'mujer-pelo-rubio',
        keywords: ['mujer', 'rubia', 'rubiales'],
    },
    '👱‍♂️': {
        name: 'hombre-pelo-rubio',
        keywords: ['hombre', 'rubiales', 'rubio'],
    },
    '🧓': {
        name: 'adulto_mayor',
        keywords: ['adulto', 'género neutro', 'género no especificado', 'maduro', 'mayor', 'persona mayor'],
    },
    '👴': {
        name: 'hombre_mayor',
        keywords: ['hombre', 'mayor', 'anciano'],
    },
    '👵': {
        name: 'mujer_mayor',
        keywords: ['mayor', 'mujer', 'anciana'],
    },
    '🙍': {
        name: 'persona_con_el_ceño_fruncido',
        keywords: ['ceño', 'fruncido', 'gesto', 'persona', 'persona frunciendo el ceño'],
    },
    '🙍‍♂️': {
        name: 'hombre_con_ceño_fruncido',
        keywords: ['ceño', 'fruncido', 'gesto', 'hombre', 'hombre frunciendo el ceño'],
    },
    '🙍‍♀️': {
        name: 'mujer_con_ceño_fruncido',
        keywords: ['ceño', 'fruncido', 'gesto', 'mujer', 'mujer frunciendo el ceño'],
    },
    '🙎': {
        name: 'persona_haciendo_pucheros',
        keywords: ['gesto', 'persona', 'pucheros', 'persona haciendo pucheros'],
    },
    '🙎‍♂️': {
        name: 'hombre_enfadado',
        keywords: ['gesto', 'hombre', 'pucheros', 'hombre haciendo pucheros'],
    },
    '🙎‍♀️': {
        name: 'mujer_enfadada',
        keywords: ['gesto', 'mujer', 'pucheros', 'mujer haciendo pucheros'],
    },
    '🙅': {
        name: 'prohibido',
        keywords: ['gesto', 'mano', 'no', 'prohibido', 'persona haciendo el gesto de "no"'],
    },
    '🙅‍♂️': {
        name: 'hombre_gesticulando_no',
        keywords: ['gesto', 'hombre', 'mano', 'prohibido', 'hombre haciendo el gesto de "no"'],
    },
    '🙅‍♀️': {
        name: 'mujer_gesticulando_no',
        keywords: ['gesto', 'mano', 'mujer', 'prohibido', 'mujer haciendo el gesto de "no"'],
    },
    '🙆': {
        name: 'mujer_con_signo_de_aprobación',
        keywords: ['gesto', 'mano', 'OK', 'vale', 'persona haciendo el gesto de "de acuerdo"'],
    },
    '🙆‍♂️': {
        name: 'hombre_gesticulando_sí',
        keywords: ['gesto', 'mano', 'OK', 'vale', 'hombre haciendo el gesto de "de acuerdo"'],
    },
    '🙆‍♀️': {
        name: 'mujer_gesticulando_sí',
        keywords: ['gesto', 'mano', 'OK', 'vale', 'mujer haciendo el gesto de "de acuerdo"'],
    },
    '💁': {
        name: 'recepcionista_de_información',
        keywords: ['información', 'mano', 'mostrador', 'persona', 'persona de mostrador de información'],
    },
    '💁‍♂️': {
        name: 'hombre_con_palma_hacia_arriba',
        keywords: ['hombre', 'información', 'mano', 'mostrador', 'empleado de mostrador de información'],
    },
    '💁‍♀️': {
        name: 'mujer_con_palma_hacia_arriba',
        keywords: ['información', 'mano', 'mostrador', 'mujer', 'empleada de mostrador de información'],
    },
    '🙋': {
        name: 'levantando_la_mano',
        keywords: ['feliz', 'gesto', 'levantar', 'mano', 'persona con la mano levantada'],
    },
    '🙋‍♂️': {
        name: 'hombre_levantando_mano',
        keywords: ['gesto', 'hombre', 'levantar', 'mano', 'hombre con la mano levantada'],
    },
    '🙋‍♀️': {
        name: 'mujer_levantando_mano',
        keywords: ['gesto', 'levantar', 'mano', 'mujer', 'mujer con la mano levantada'],
    },
    '🧏': {
        name: 'persona_sorda',
        keywords: ['accesibilidad', 'escuchar', 'oído', 'oír', 'sordera', 'persona sorda'],
    },
    '🧏‍♂️': {
        name: 'hombre_sordo',
        keywords: ['hombre', 'sordera', 'sordo'],
    },
    '🧏‍♀️': {
        name: 'mujer_sorda',
        keywords: ['mujer', 'sorda', 'sordera'],
    },
    '🙇': {
        name: 'reverencia',
        keywords: ['disculpa', 'gesto', 'perdón', 'reverencia', 'persona haciendo una reverencia'],
    },
    '🙇‍♂️': {
        name: 'hombre_reverencia',
        keywords: ['disculpa', 'gesto', 'perdón', 'reverencia', 'hombre haciendo una reverencia'],
    },
    '🙇‍♀️': {
        name: 'mujer_reverencia',
        keywords: ['disculpa', 'gesto', 'perdón', 'reverencia', 'mujer haciendo una reverencia'],
    },
    '🤦': {
        name: 'mano_en_la_cara',
        keywords: ['facepalm', 'frente', 'incredulidad', 'mano', 'persona con la mano en la frente'],
    },
    '🤦‍♂️': {
        name: 'hombre_mano_en_la_cara',
        keywords: ['facepalm', 'frente', 'incredulidad', 'mano', 'hombre con la mano en la frente'],
    },
    '🤦‍♀️': {
        name: 'mujer_mano_en_la_cara',
        keywords: ['facepalm', 'frente', 'incredulidad', 'mano', 'mujer con la mano en la frente'],
    },
    '🤷': {
        name: 'encoger_los_hombros',
        keywords: ['duda', 'encogerse', 'hombros', 'indiferencia', 'persona encogida de hombros'],
    },
    '🤷‍♂️': {
        name: 'hombre_encogiéndose_de_hombros',
        keywords: ['duda', 'encogerse', 'hombros', 'indiferencia', 'hombre encogido de hombros'],
    },
    '🤷‍♀️': {
        name: 'mujer_encogiéndose_de_hombros',
        keywords: ['duda', 'encogerse', 'hombros', 'indiferencia', 'mujer encogida de hombros'],
    },
    '🧑‍⚕️': {
        name: 'profesional_sanitario',
        keywords: ['doctor', 'enfermero', 'médico', 'salud', 'terapeuta', 'profesional sanitario'],
    },
    '👨‍⚕️': {
        name: 'doctor',
        keywords: ['doctor', 'enfermero', 'médico', 'sanitario', 'terapeuta hombre', 'profesional sanitario hombre'],
    },
    '👩‍⚕️': {
        name: 'doctora',
        keywords: ['doctora', 'enfermera', 'médica', 'sanitaria', 'terapeuta mujer', 'profesional sanitario mujer'],
    },
    '🧑‍🎓': {
        name: 'estudiante',
        keywords: ['graduado', 'licenciado', 'universitario', 'estudiante'],
    },
    '👨‍🎓': {
        name: 'alumno',
        keywords: ['estudiante', 'graduado', 'hombre', 'licenciado', 'universitario'],
    },
    '👩‍🎓': {
        name: 'alumna',
        keywords: ['estudiante', 'graduada', 'licenciada', 'mujer', 'universitaria'],
    },
    '🧑‍🏫': {
        name: 'docente',
        keywords: ['educador', 'enseñanza', 'instructor', 'maestro', 'profesor', 'docente'],
    },
    '👨‍🏫': {
        name: 'profesor',
        keywords: ['educador', 'hombre', 'instructor', 'maestro', 'profesor', 'docente hombre'],
    },
    '👩‍🏫': {
        name: 'profesora',
        keywords: ['educadora', 'instructora', 'maestra', 'mujer', 'profesora', 'docente mujer'],
    },
    '🧑‍⚖️': {
        name: 'persona_juez',
        keywords: ['juez', 'juicio', 'magistrado', 'fiscal'],
    },
    '👨‍⚖️': {
        name: 'juez',
        keywords: ['hombre', 'juez', 'justicia', 'magistrado', 'fiscal hombre'],
    },
    '👩‍⚖️': {
        name: 'jueza',
        keywords: ['jueza', 'justicia', 'magistrada', 'mujer', 'fiscal mujer'],
    },
    '🧑‍🌾': {
        name: 'persona_agricultora',
        keywords: ['agricultor', 'cultivador', 'granjero', 'jardinero', 'labrador', 'profesional de la agricultura'],
    },
    '👨‍🌾': {
        name: 'agricultor',
        keywords: ['agricultor', 'campo', 'granjero', 'hombre', 'labrador', 'profesional de la agricultura hombre'],
    },
    '👩‍🌾': {
        name: 'agricultora',
        keywords: ['agricultora', 'campo', 'granjera', 'labradora', 'mujer', 'profesional de la agricultura mujer'],
    },
    '🧑‍🍳': {
        name: 'persona_cocinera',
        keywords: ['cocinero', 'cocinillas', 'guisandero', 'pinche', 'chef'],
    },
    '👨‍🍳': {
        name: 'cocinero',
        keywords: ['chef', 'cocinero', 'hombre', 'pinche'],
    },
    '👩‍🍳': {
        name: 'cocinera',
        keywords: ['chef', 'cocinera', 'mujer', 'pinche'],
    },
    '🧑‍🔧': {
        name: 'persona_mecánica',
        keywords: ['electricista', 'fontanero', 'mecánico', 'operario', 'técnico', 'profesional de la mecánica'],
    },
    '👨‍🔧': {
        name: 'mecánico',
        keywords: ['electricista', 'fontanero', 'hombre', 'mecánico', 'operario', 'profesional de la mecánica hombre'],
    },
    '👩‍🔧': {
        name: 'mecánica',
        keywords: ['electricista', 'fontanera', 'mecánica', 'mujer', 'operaria', 'profesional de la mecánica mujer'],
    },
    '🧑‍🏭': {
        name: 'profesional_industrial',
        keywords: ['fábrica', 'montaje', 'obrero', 'operario', 'trabajador', 'profesional industrial'],
    },
    '👨‍🏭': {
        name: 'trabajador',
        keywords: ['fábrica', 'montaje', 'obrero', 'operario', 'trabajador', 'profesional industrial hombre'],
    },
    '👩‍🏭': {
        name: 'trabajadora',
        keywords: ['fábrica', 'montaje', 'obrera', 'operaria', 'trabajadora', 'profesional industrial mujer'],
    },
    '🧑‍💼': {
        name: 'oficinista',
        keywords: ['arquitecto', 'director', 'ejecutivo', 'empresa', 'oficinista'],
    },
    '👨‍💼': {
        name: 'oficinista_hombre',
        keywords: ['director', 'ejecutivo', 'empresa', 'hombre', 'oficina', 'oficinista'],
    },
    '👩‍💼': {
        name: 'oficinista_mujer',
        keywords: ['directora', 'ejecutiva', 'empresa', 'mujer', 'oficina', 'oficinista'],
    },
    '🧑‍🔬': {
        name: 'persona_científica',
        keywords: ['biólogo', 'científico', 'físico', 'investigador', 'químico', 'profesional de la ciencia'],
    },
    '👨‍🔬': {
        name: 'científico',
        keywords: ['biólogo', 'científico', 'físico', 'hombre', 'químico', 'profesional de la ciencia hombre'],
    },
    '👩‍🔬': {
        name: 'científica',
        keywords: ['bióloga', 'científica', 'física', 'mujer', 'química', 'profesional de la ciencia mujer'],
    },
    '🧑‍💻': {
        name: 'persona_tecnóloga',
        keywords: ['desarrollador', 'informático', 'programador', 'software', 'tecnólogo', 'profesional de la tecnología'],
    },
    '👨‍💻': {
        name: 'tecnólogo',
        keywords: ['desarrollador', 'hombre', 'informático', 'programador', 'tecnólogo', 'profesional de la tecnología hombre'],
    },
    '👩‍💻': {
        name: 'tecnóloga',
        keywords: ['desarrolladora', 'informática', 'mujer', 'programadora', 'tecnóloga', 'profesional de la tecnología mujer'],
    },
    '🧑‍🎤': {
        name: 'cantante',
        keywords: ['artista', 'estrella', 'rock', 'cantante'],
    },
    '👨‍🎤': {
        name: 'cantante_hombre',
        keywords: ['artista', 'estrella', 'hombre', 'rock', 'cantante hombre'],
    },
    '👩‍🎤': {
        name: 'cantante_mujer',
        keywords: ['artista', 'estrella', 'mujer', 'rock', 'cantante mujer'],
    },
    '🧑‍🎨': {
        name: 'artista',
        keywords: ['paleta', 'pintor', 'pinturas', 'artista'],
    },
    '👨‍🎨': {
        name: 'artista_hombre',
        keywords: ['hombre', 'paleta', 'pintor', 'pinturas', 'artista hombre'],
    },
    '👩‍🎨': {
        name: 'artista_mujer',
        keywords: ['mujer', 'paleta', 'pintora', 'pinturas', 'artista mujer'],
    },
    '🧑‍✈️': {
        name: 'piloto',
        keywords: ['avión', 'capitán', 'vuelo', 'piloto'],
    },
    '👨‍✈️': {
        name: 'piloto_hombre',
        keywords: ['avión', 'capitán', 'hombre', 'piloto', 'vuelo'],
    },
    '👩‍✈️': {
        name: 'piloto_mujer',
        keywords: ['avión', 'capitana', 'mujer', 'piloto', 'vuelo'],
    },
    '🧑‍🚀': {
        name: 'astronauta',
        keywords: ['cohete', 'espacio', 'astronauta'],
    },
    '👨‍🚀': {
        name: 'astronauta_hombre',
        keywords: ['astronauta', 'cohete', 'espacio', 'hombre'],
    },
    '👩‍🚀': {
        name: 'astronauta_mujer',
        keywords: ['astronauta', 'cohete', 'espacio', 'mujer'],
    },
    '🧑‍🚒': {
        name: 'persona_bombero',
        keywords: ['camión', 'manguera', 'bombero'],
    },
    '👨‍🚒': {
        name: 'bombero',
        keywords: ['apagafuegos', 'bombero', 'camión', 'manguera', 'bombero hombre'],
    },
    '👩‍🚒': {
        name: 'bombera',
        keywords: ['apagafuegos', 'bombera mujera', 'camión', 'manguera', 'bombera'],
    },
    '👮': {
        name: 'policía',
        keywords: ['agente', 'personas', 'policía', 'agente de policía'],
    },
    '👮‍♂️': {
        name: 'policía_hombre',
        keywords: ['agente', 'hombre', 'poli', 'policía', 'agente de policía hombre'],
    },
    '👮‍♀️': {
        name: 'policía_mujer',
        keywords: ['agente', 'mujer', 'poli', 'policía', 'agente de policía mujer'],
    },
    '🕵️': {
        name: 'sabueso_o_espía',
        keywords: ['cara', 'espía', 'detective'],
    },
    '🕵️‍♂️': {
        name: 'detective_hombre',
        keywords: ['agente', 'detective', 'espía', 'hombre', 'investigador'],
    },
    '🕵️‍♀️': {
        name: 'detective_mujer',
        keywords: ['agente', 'detective', 'espía', 'investigadora', 'mujer'],
    },
    '💂': {
        name: 'guardia',
        keywords: ['guardia real británica', 'guardia'],
    },
    '💂‍♂️': {
        name: 'guardia_hombre',
        keywords: ['guardia', 'hombre', 'vigilante'],
    },
    '💂‍♀️': {
        name: 'guardia_mujer',
        keywords: ['guardia', 'mujer', 'vigilante'],
    },
    '🥷': {
        name: 'ninja',
        keywords: ['furtivo', 'guerrero', 'luchador', 'oculto', 'sigilo', 'ninja'],
    },
    '👷': {
        name: 'obrero_de_la_construcción',
        keywords: ['casco', 'construcción', 'obrero', 'trabajador', 'profesional de la construcción'],
    },
    '👷‍♂️': {
        name: 'obrero',
        keywords: ['albañil', 'construcción', 'hombre', 'obrero', 'trabajador', 'profesional de la construcción hombre'],
    },
    '👷‍♀️': {
        name: 'obrera',
        keywords: ['albañila', 'construcción', 'mujer', 'obrera', 'trabajadora', 'profesional de la construcción mujer'],
    },
    '🤴': {
        name: 'príncipe',
        keywords: ['corona', 'príncipe'],
    },
    '👸': {
        name: 'princesa',
        keywords: ['cuento', 'fantasía', 'hadas', 'princesa'],
    },
    '👳': {
        name: 'hombre_con_turbante',
        keywords: ['turbante', 'persona con turbante'],
    },
    '👳‍♂️': {
        name: 'hombre_que_lleva_turbante',
        keywords: ['hombre', 'turbante', 'hombre con turbante'],
    },
    '👳‍♀️': {
        name: 'mujer_que_lleva_turbante',
        keywords: ['mujer', 'turbante', 'mujer con turbante'],
    },
    '👲': {
        name: 'hombre_con_gorro_chino',
        keywords: ['gorro', 'gua', 'mao', 'persona', 'gua pi mao', 'persona con gorro chino'],
    },
    '🧕': {
        name: 'persona_con_velo',
        keywords: ['hiyab', 'pañuelo', 'mujer con hiyab'],
    },
    '🤵': {
        name: 'persona_en_esmoquin',
        keywords: ['esmoquin', 'novio', 'persona', 'persona con esmoquin'],
    },
    '🤵‍♂️': {
        name: 'hombre_con_esmoquin',
        keywords: ['esmoquin', 'hombre', 'hombre con esmoquin'],
    },
    '🤵‍♀️': {
        name: 'mujer_con_esmoquin',
        keywords: ['esmoquin', 'mujer', 'mujer con esmoquin'],
    },
    '👰': {
        name: 'novia_con_velo',
        keywords: ['boda', 'novia', 'persona', 'velo', 'persona con velo'],
    },
    '👰‍♂️': {
        name: 'hombre_con_velo',
        keywords: ['boda', 'hombre', 'novio', 'velo', 'hombre con velo'],
    },
    '👰‍♀️': {
        name: 'mujer_con_velo',
        keywords: ['boda', 'mujer', 'novia', 'velo', 'mujer con velo'],
    },
    '🤰': {
        name: 'embarazada',
        keywords: ['embarazada', 'mujer'],
    },
    '🤱': {
        name: 'amamantar',
        keywords: ['amamantar', 'bebé', 'dar pecho', 'pecho', 'lactancia materna'],
    },
    '👩‍🍼': {
        name: 'mujer_alimentando_a_bebé',
        keywords: ['alimentar', 'amamantar', 'bebé', 'lactancia', 'mujer', 'mujer alimentando a bebé'],
    },
    '👨‍🍼': {
        name: 'hombre_alimentando_a_bebé',
        keywords: ['alimentar', 'amamantar', 'bebé', 'hombre', 'lactancia', 'hombre alimentando a bebé'],
    },
    '🧑‍🍼': {
        name: 'persona_alimentando_a_bebé',
        keywords: ['alimentar', 'amamantar', 'bebé', 'lactancia', 'persona', 'persona alimentando a bebé'],
    },
    '👼': {
        name: 'ángel',
        keywords: ['ángel', 'bebé', 'cara', 'cuento'],
    },
    '🎅': {
        name: 'santa_claus',
        keywords: ['celebración', 'claus', 'Navidad', 'papá noel', 'Papá Noel', 'santa'],
    },
    '🤶': {
        name: 'sra_claus',
        keywords: ['abuela', 'mamá', 'Navidad', 'noel', 'Mamá Noel'],
    },
    '🧑‍🎄': {
        name: 'mx_claus',
        keywords: ['claus', 'christmas', 'mx claus'],
    },
    '🦸': {
        name: 'personaje_de_superhéroe',
        keywords: ['bien', 'héroe', 'heroína', 'superhéroe', 'superheroína', 'superpoder', 'personaje de superhéroe'],
    },
    '🦸‍♂️': {
        name: 'superhéroe',
        keywords: ['bueno', 'héroe', 'hombre', 'superhombre', 'superpoder', 'superhéroe'],
    },
    '🦸‍♀️': {
        name: 'superheroína',
        keywords: ['héroe', 'heroína', 'mujer', 'superhéroe', 'superpoder', 'superheroína'],
    },
    '🦹': {
        name: 'personaje_de_supervillano',
        keywords: ['mal', 'superpoder', 'supervillana', 'supervillano', 'villana', 'villano', 'personaje de supervillano'],
    },
    '🦹‍♂️': {
        name: 'supervillano',
        keywords: ['hombre', 'mal', 'malvado', 'villano', 'supervillano'],
    },
    '🦹‍♀️': {
        name: 'supervillana',
        keywords: ['mal', 'malvada', 'mujer', 'villana', 'supervillana'],
    },
    '🧙': {
        name: 'brujo',
        keywords: ['bruja', 'brujo', 'hechicera', 'hechicero', 'persona maga'],
    },
    '🧙‍♂️': {
        name: 'mago',
        keywords: ['brujo', 'hechicero', 'mago'],
    },
    '🧙‍♀️': {
        name: 'maga',
        keywords: ['bruja', 'hechicera', 'maga'],
    },
    '🧚': {
        name: 'hada',
        keywords: ['campanilla', 'oberón', 'puck', 'titania', 'hada'],
    },
    '🧚‍♂️': {
        name: 'hada_macho',
        keywords: ['hada', 'oberón', 'puck', 'hada hombre'],
    },
    '🧚‍♀️': {
        name: 'hada_hembra',
        keywords: ['campanilla', 'hada', 'titania', 'hada mujer'],
    },
    '🧛': {
        name: 'vampiro',
        keywords: ['drácula', 'muerto viviente', 'no muerto', 'vampiro'],
    },
    '🧛‍♂️': {
        name: 'vampiro_macho',
        keywords: ['drácula', 'muerto viviente', 'no muerto', 'vampiro hombre'],
    },
    '🧛‍♀️': {
        name: 'vampira',
        keywords: ['muerta viviente', 'no muerta', 'vampiresa'],
    },
    '🧜': {
        name: 'sirena-tritón',
        keywords: ['sirena', 'tritón', 'persona sirena'],
    },
    '🧜‍♂️': {
        name: 'tritón',
        keywords: ['sirena', 'tritón', 'sirena hombre'],
    },
    '🧜‍♀️': {
        name: 'sirena',
        keywords: ['sirena'],
    },
    '🧝': {
        name: 'elfo',
        keywords: ['mágico', 'elfo'],
    },
    '🧝‍♂️': {
        name: 'elfo_macho',
        keywords: ['elfo', 'mágico', 'elfo hombre'],
    },
    '🧝‍♀️': {
        name: 'elfa',
        keywords: ['mágico', 'mujer', 'elfa'],
    },
    '🧞': {
        name: 'genio',
        keywords: ['lámpara', 'genio'],
    },
    '🧞‍♂️': {
        name: 'genio_de_la_lámpara',
        keywords: ['djinn', 'genio', 'lámpara', 'genio hombre'],
    },
    '🧞‍♀️': {
        name: 'genia_de_la_lámpara',
        keywords: ['genio', 'lámpara', 'genio mujer'],
    },
    '🧟': {
        name: 'zombi',
        keywords: ['muerto viviente', 'no muerto', 'zombi'],
    },
    '🧟‍♂️': {
        name: 'zombi_macho',
        keywords: ['caminante', 'muerto viviente', 'no muerto', 'zombi hombre'],
    },
    '🧟‍♀️': {
        name: 'zombi_hembra',
        keywords: ['caminante', 'muerta viviente', 'no muerta', 'zombi mujer'],
    },
    '💆': {
        name: 'masaje',
        keywords: ['cara', 'facial', 'masaje', 'salón', 'persona recibiendo masaje'],
    },
    '💆‍♂️': {
        name: 'hombre_dándose_un_masaje',
        keywords: ['cara', 'facial', 'masaje', 'salón', 'hombre recibiendo masaje'],
    },
    '💆‍♀️': {
        name: 'mujer_dándose_un_masaje',
        keywords: ['cara', 'facial', 'masaje', 'salón', 'mujer recibiendo masaje'],
    },
    '💇': {
        name: 'corte_de_pelo',
        keywords: ['belleza', 'corte', 'pelo', 'peluquero', 'persona cortándose el pelo'],
    },
    '💇‍♂️': {
        name: 'hombre_cortándose_el_pelo',
        keywords: ['belleza', 'corte', 'pelo', 'peluquero', 'hombre cortándose el pelo'],
    },
    '💇‍♀️': {
        name: 'mujer_cortándose_el_pelo',
        keywords: ['belleza', 'corte', 'pelo', 'peluquero', 'mujer cortándose el pelo'],
    },
    '🚶': {
        name: 'caminando',
        keywords: ['andar', 'caminando', 'caminar', 'persona caminando'],
    },
    '🚶‍♂️': {
        name: 'hombre_caminando',
        keywords: ['andar', 'caminata', 'hombre', 'marcha', 'hombre caminando'],
    },
    '🚶‍♀️': {
        name: 'mujer_caminando',
        keywords: ['andar', 'caminata', 'marcha', 'mujer', 'mujer caminando'],
    },
    '🧍': {
        name: 'persona_de_pie',
        keywords: ['de pie', 'levantada', 'levantado', 'levantarse', 'persona de pie'],
    },
    '🧍‍♂️': {
        name: 'hombre_de_pie',
        keywords: ['de pie', 'hombre', 'levantado', 'levantarse', 'hombre de pie'],
    },
    '🧍‍♀️': {
        name: 'mujer_de_pie',
        keywords: ['de pie', 'levantada', 'levantarse', 'mujer', 'mujer de pie'],
    },
    '🧎': {
        name: 'persona_de_rodillas',
        keywords: ['arrodillada', 'arrodillado', 'arrodillarse', 'de rodillas', 'persona de rodillas'],
    },
    '🧎‍♂️': {
        name: 'hombre_de_rodillas',
        keywords: ['arrodillado', 'arrodillarse', 'de rodillas', 'hombre', 'hombre de rodillas'],
    },
    '🧎‍♀️': {
        name: 'mujer_de_rodillas',
        keywords: ['arrodillada', 'arrodillarse', 'de rodillas', 'mujer', 'mujer de rodillas'],
    },
    '🧑‍🦯': {
        name: 'persona_con_bastón',
        keywords: ['accesibilidad', 'ciego', 'invidente', 'persona con bastón'],
    },
    '👨‍🦯': {
        name: 'hombre_con_bastón',
        keywords: ['accesibilidad', 'bastón', 'ciego', 'hombre', 'invidente', 'hombre con bastón'],
    },
    '👩‍🦯': {
        name: 'mujer_con_bastón',
        keywords: ['accesibilidad', 'bastón', 'ciega', 'invidente', 'mujer', 'mujer con bastón'],
    },
    '🧑‍🦼': {
        name: 'persona_en_silla_de_ruedas_eléctrica',
        keywords: ['accesibilidad', 'silla de ruedas', 'persona en silla de ruedas eléctrica'],
    },
    '👨‍🦼': {
        name: 'hombre_en_silla_de_ruedas_eléctrica',
        keywords: ['accesibilidad', 'hombre', 'silla de ruedas', 'hombre en silla de ruedas eléctrica'],
    },
    '👩‍🦼': {
        name: 'mujer_en_silla_de_ruedas_eléctrica',
        keywords: ['accesibilidad', 'mujer', 'silla de ruedas', 'mujer en silla de ruedas eléctrica'],
    },
    '🧑‍🦽': {
        name: 'persona_en_silla_de_ruedas_manual',
        keywords: ['accesibilidad', 'silla de ruedas', 'persona en silla de ruedas manual'],
    },
    '👨‍🦽': {
        name: 'hombre_en_silla_de_ruedas_manual',
        keywords: ['accesibilidad', 'hombre', 'silla de ruedas', 'hombre en silla de ruedas manual'],
    },
    '👩‍🦽': {
        name: 'mujer_en_silla_de_ruedas_manual',
        keywords: ['accesibilidad', 'mujer', 'silla de ruedas', 'mujer en silla de ruedas manual'],
    },
    '🏃': {
        name: 'corredor',
        keywords: ['carrera', 'deporte', 'maratón  persona corriendo'],
    },
    '🏃‍♂️': {
        name: 'hombre_corriendo',
        keywords: ['carrera', 'correr', 'hombre', 'hombre corriendo  maratón'],
    },
    '🏃‍♀️': {
        name: 'mujer_corriendo',
        keywords: ['carrera', 'correr', 'mujer', 'maratón', 'mujer corriendo'],
    },
    '💃': {
        name: 'bailarín',
        keywords: ['bailar', 'mujer', 'mujer bailando'],
    },
    '🕺': {
        name: 'hombre_bailando',
        keywords: ['bailar', 'hombre', 'hombre bailando'],
    },
    '🕴️': {
        name: 'hombre_de_negocios_levitando',
        keywords: ['levitar', 'negocios', 'persona', 'traje', 'persona trajeada levitando'],
    },
    '👯': {
        name: 'bailarines',
        keywords: ['bailar', 'fiesta', 'orejas de conejo', 'personas', 'personas con orejas de conejo'],
    },
    '👯‍♂️': {
        name: 'hombre_con_orejas_de_conejo',
        keywords: ['bailar', 'fiesta', 'hombre', 'orejas de conejo', 'hombres con orejas de conejo'],
    },
    '👯‍♀️': {
        name: 'mujer_con_orejas_de_conejo',
        keywords: ['bailar', 'fiesta', 'mujer', 'orejas de conejo', 'mujeres con orejas de conejo'],
    },
    '🧖': {
        name: 'persona_en_sauna',
        keywords: ['sauna', 'vapor', 'persona en una sauna'],
    },
    '🧖‍♂️': {
        name: 'hombre_en_sauna',
        keywords: ['sauna', 'vapor', 'hombre en una sauna'],
    },
    '🧖‍♀️': {
        name: 'mujer_en_sauna',
        keywords: ['sauna', 'vapor', 'mujer en una sauna'],
    },
    '🧗': {
        name: 'persona_escalando',
        keywords: ['alpinista', 'escalador', 'persona escalando'],
    },
    '🧗‍♂️': {
        name: 'hombre_escalando',
        keywords: ['alpinista', 'escalador', 'hombre escalando'],
    },
    '🧗‍♀️': {
        name: 'mujer_escalando',
        keywords: ['alpinista', 'escaladora', 'mujer escalando'],
    },
    '🤺': {
        name: 'esgrimista',
        keywords: ['esgrima', 'esgrimista', 'espada', 'persona haciendo esgrima'],
    },
    '🏇': {
        name: 'carrera_de_caballos',
        keywords: ['caballo', 'caballo de carreras', 'carreras', 'jinete', 'carrera de caballos'],
    },
    '⛷️': {
        name: 'esquiador',
        keywords: ['esquí', 'esquiador', 'nieve', 'persona esquiando'],
    },
    '🏂': {
        name: 'practicante_de_snowboard',
        keywords: ['nieve', 'snowboard', 'practicante de snowboard'],
    },
    '🏌️': {
        name: 'golfista',
        keywords: ['golf', 'golfista', 'pelota', 'persona jugando al golf'],
    },
    '🏌️‍♂️': {
        name: 'hombre_jugando_golf',
        keywords: ['golf', 'hombre', 'jugador', 'hombre jugando al golf'],
    },
    '🏌️‍♀️': {
        name: 'mujer_jugando_golf',
        keywords: ['golf', 'jugadora', 'mujer', 'mujer jugando al golf'],
    },
    '🏄': {
        name: 'surfista',
        keywords: ['surf', 'persona haciendo surf', 'surfear'],
    },
    '🏄‍♂️': {
        name: 'hombre_surfeando',
        keywords: ['hombre', 'surf', 'surfero', 'surfista', 'hombre haciendo surf'],
    },
    '🏄‍♀️': {
        name: 'mujer_haciendo_surf',
        keywords: ['mujer', 'surf', 'surfera', 'surfista', 'mujer haciendo surf'],
    },
    '🚣': {
        name: 'bote_de_remos',
        keywords: ['barca', 'bote', 'remo', 'persona remando en un bote'],
    },
    '🚣‍♂️': {
        name: 'hombre_remando_barca',
        keywords: ['barca', 'bote', 'hombre', 'remo', 'hombre remando en un bote'],
    },
    '🚣‍♀️': {
        name: 'mujer_remando_barca',
        keywords: ['barca', 'bote', 'mujer', 'remo', 'mujer remando en un bote'],
    },
    '🏊': {
        name: 'nadador',
        keywords: ['nadar', 'natación', 'persona nadando'],
    },
    '🏊‍♂️': {
        name: 'hombre_nadando',
        keywords: ['hombre', 'nadar', 'hombre nadando'],
    },
    '🏊‍♀️': {
        name: 'mujer_nadando',
        keywords: ['mujer', 'nadar', 'mujer nadando'],
    },
    '⛹️': {
        name: 'persona_con_una_pelota',
        keywords: ['balón', 'botar', 'pelota', 'persona botando un balón'],
    },
    '⛹️‍♂️': {
        name: 'hombre_botando_balón',
        keywords: ['balón', 'botar', 'hombre', 'pelota', 'hombre botando un balón'],
    },
    '⛹️‍♀️': {
        name: 'mujer_botando_balón',
        keywords: ['balón', 'botar', 'mujer', 'pelota', 'mujer botando un balón'],
    },
    '🏋️': {
        name: 'levantador_de_peso',
        keywords: ['halterofilia', 'levantador', 'pesas', 'peso', 'persona levantando pesas'],
    },
    '🏋️‍♂️': {
        name: 'hombre_levantando_pesas',
        keywords: ['halterofilia', 'hombre', 'levantador de pesas', 'pesas', 'hombre levantando pesas'],
    },
    '🏋️‍♀️': {
        name: 'mujer_levantando_pesas',
        keywords: ['halterofilia', 'levantadora de pesas', 'mujer', 'pesas', 'mujer levantando pesas'],
    },
    '🚴': {
        name: 'ciclista',
        keywords: ['bicicleta', 'ciclismo', 'ciclista', 'persona en bicicleta'],
    },
    '🚴‍♂️': {
        name: 'hombre_en_bici',
        keywords: ['bicicleta', 'ciclismo', 'ciclista', 'hombre', 'hombre en bicicleta'],
    },
    '🚴‍♀️': {
        name: 'mujer_en_bici',
        keywords: ['bicicleta', 'ciclismo', 'ciclista', 'mujer', 'mujer en bicicleta'],
    },
    '🚵': {
        name: 'ciclista_de_montaña',
        keywords: ['bicicleta', 'ciclista', 'montaña', 'mountain bike', 'persona en bicicleta de montaña'],
    },
    '🚵‍♂️': {
        name: 'hombre_bici_montaña',
        keywords: ['bicicleta', 'ciclista', 'montaña', 'mountain bike', 'hombre en bicicleta de montaña'],
    },
    '🚵‍♀️': {
        name: 'mujer_bici_montaña',
        keywords: ['bicicleta', 'ciclista', 'montaña', 'mountain bike', 'mujer en bicicleta de montaña'],
    },
    '🤸': {
        name: 'persona_dando_volteretas',
        keywords: ['acrobacia', 'gimnasia', 'pirueta', 'rueda', 'voltereta', 'persona haciendo voltereta lateral'],
    },
    '🤸‍♂️': {
        name: 'hombre_dando_volteretas',
        keywords: ['deporte', 'gimnasia', 'hombre', 'rueda', 'voltereta', 'hombre dando una voltereta lateral'],
    },
    '🤸‍♀️': {
        name: 'mujer_dando_volteretas',
        keywords: ['deporte', 'gimnasia', 'mujer', 'rueda', 'voltereta', 'mujer dando una voltereta lateral'],
    },
    '🤼': {
        name: 'luchadores',
        keywords: ['lucha', 'luchador', 'personas luchando'],
    },
    '🤼‍♂️': {
        name: 'hombre_lucha_libre',
        keywords: ['deporte', 'hombre', 'lucha', 'luchador', 'hombres luchando'],
    },
    '🤼‍♀️': {
        name: 'mujer_lucha_libre',
        keywords: ['deporte', 'lucha', 'luchadora', 'mujer', 'mujeres luchando'],
    },
    '🤽': {
        name: 'waterpolo',
        keywords: ['waterpolista', 'waterpolo', 'persona jugando al waterpolo'],
    },
    '🤽‍♂️': {
        name: 'hombre_jugando_waterpolo',
        keywords: ['agua', 'deporte', 'waterpolista', 'waterpolo', 'hombre jugando al waterpolo'],
    },
    '🤽‍♀️': {
        name: 'mujer_jugando_waterpolo',
        keywords: ['agua', 'deporte', 'waterpolista', 'waterpolo', 'mujer jugando al waterpolo'],
    },
    '🤾': {
        name: 'balonmano',
        keywords: ['balonmanista', 'balonmano', 'persona jugando al balonmano'],
    },
    '🤾‍♂️': {
        name: 'hombre_jugando_balonmano',
        keywords: ['balonmanista', 'balonmano', 'deporte', 'hombre', 'hombre jugando al balonmano'],
    },
    '🤾‍♀️': {
        name: 'mujer_jugando_balonmano',
        keywords: ['balonmanista', 'balonmano', 'deporte', 'mujer', 'mujer jugando al balonmano'],
    },
    '🤹': {
        name: 'malabarismo',
        keywords: ['equilibrio', 'malabares', 'malabarismo', 'malabarista', 'persona haciendo malabares'],
    },
    '🤹‍♂️': {
        name: 'malabarista_hombre',
        keywords: ['hombre', 'malabares', 'malabarismo', 'malabarista', 'hombre haciendo malabares'],
    },
    '🤹‍♀️': {
        name: 'malabarista_mujer',
        keywords: ['malabares', 'malabarismo', 'malabarista', 'mujer', 'mujer haciendo malabares'],
    },
    '🧘': {
        name: 'persona_en_postura_loto',
        keywords: ['meditación', 'yoga', 'persona en posición de loto'],
    },
    '🧘‍♂️': {
        name: 'hombre_en_postura_loto',
        keywords: ['meditación', 'yoga', 'hombre en posición de loto'],
    },
    '🧘‍♀️': {
        name: 'mujer_en_postura_loto',
        keywords: ['meditación', 'yoga', 'mujer en posición de loto'],
    },
    '🛀': {
        name: 'bañera',
        keywords: ['bañera', 'baño', 'persona', 'persona en la bañera'],
    },
    '🛌': {
        name: 'lugar_para_dormir',
        keywords: ['dormir', 'hotel', 'persona en la cama'],
    },
    '🧑‍🤝‍🧑': {
        name: 'dos_personas_dándose_la_mano',
        keywords: ['mano', 'pareja', 'persona', 'dos personas de la mano'],
    },
    '👭': {
        name: 'dos_mujeres_de_la_mano',
        keywords: ['lesbianas', 'mujeres', 'novias', 'pareja', 'mujeres de la mano'],
    },
    '👫': {
        name: 'hombre_y_mujer_de_la_mano',
        keywords: ['hombre', 'hombre y mujer de la mano', 'mujer', 'novios', 'pareja', 'mujer y hombre de la mano'],
    },
    '👬': {
        name: 'dos_hombres_de_la_mano',
        keywords: ['gays', 'hombres', 'novios', 'pareja', 'hombres de la mano'],
    },
    '💏': {
        name: 'pareja_besándose',
        keywords: ['personas', 'romance', 'beso'],
    },
    '👩‍❤️‍💋‍👨': {
        name: 'mujer_beso_hombre',
        keywords: ['beso', 'hombre', 'mujer', 'personas', 'romance'],
    },
    '👨‍❤️‍💋‍👨': {
        name: 'hombre_beso_hombre',
        keywords: ['beso', 'hombre', 'personas', 'romance'],
    },
    '👩‍❤️‍💋‍👩': {
        name: 'mujer_beso_mujer',
        keywords: ['beso', 'mujer', 'personas', 'romance'],
    },
    '💑': {
        name: 'pareja_con_corazón',
        keywords: ['amor', 'pareja', 'pareja enamorada  personas enamoradas'],
    },
    '👩‍❤️‍👨': {
        name: 'mujer_corazón_hombre',
        keywords: ['amor', 'hombre', 'mujer', 'pareja', 'pareja enamorada', 'personas enamoradas'],
    },
    '👨‍❤️‍👨': {
        name: 'hombre_corazón_hombre',
        keywords: ['amor', 'hombre', 'pareja', 'pareja enamorada', 'personas enamoradas'],
    },
    '👩‍❤️‍👩': {
        name: 'mujer_corazón_mujer',
        keywords: ['amor', 'mujer', 'pareja', 'pareja enamorada', 'personas enamoradas'],
    },
    '👪': {
        name: 'familia',
        keywords: ['familia'],
    },
    '👨‍👩‍👦': {
        name: 'hombre_mujer_niño',
        keywords: ['familia', 'hombre', 'mujer', 'niño'],
    },
    '👨‍👩‍👧': {
        name: 'hombre_mujer_niña',
        keywords: ['familia', 'hombre', 'mujer', 'niña'],
    },
    '👨‍👩‍👧‍👦': {
        name: 'hombre_mujer_niña_niño',
        keywords: ['familia', 'hombre', 'mujer', 'niña', 'niño'],
    },
    '👨‍👩‍👦‍👦': {
        name: 'hombre_mujer_niño_niño',
        keywords: ['familia', 'hombre', 'mujer', 'niño'],
    },
    '👨‍👩‍👧‍👧': {
        name: 'hombre_mujer_niña_niña',
        keywords: ['familia', 'hombre', 'mujer', 'niña'],
    },
    '👨‍👨‍👦': {
        name: 'hombre_hombre_niño',
        keywords: ['familia', 'hombre', 'niño'],
    },
    '👨‍👨‍👧': {
        name: 'hombre_hombre_niña',
        keywords: ['familia', 'hombre', 'niña'],
    },
    '👨‍👨‍👧‍👦': {
        name: 'hombre_hombre_niña_niño',
        keywords: ['familia', 'hombre', 'niña', 'niño'],
    },
    '👨‍👨‍👦‍👦': {
        name: 'hombre_hombre_niño_niño',
        keywords: ['familia', 'hombre', 'niño'],
    },
    '👨‍👨‍👧‍👧': {
        name: 'hombre_hombre_niña_niña',
        keywords: ['familia', 'hombre', 'niña'],
    },
    '👩‍👩‍👦': {
        name: 'mujer_mujer_niño',
        keywords: ['familia', 'mujer', 'niño'],
    },
    '👩‍👩‍👧': {
        name: 'mujer_mujer_niña',
        keywords: ['familia', 'mujer', 'niña'],
    },
    '👩‍👩‍👧‍👦': {
        name: 'mujer_mujer_niña_niño',
        keywords: ['familia', 'mujer', 'niña', 'niño'],
    },
    '👩‍👩‍👦‍👦': {
        name: 'mujer_mujer_niño_niño',
        keywords: ['familia', 'mujer', 'niño'],
    },
    '👩‍👩‍👧‍👧': {
        name: 'mujer_mujer_niña_niña',
        keywords: ['familia', 'mujer', 'niña'],
    },
    '👨‍👦': {
        name: 'hombre_niño',
        keywords: ['familia', 'hombre', 'niño'],
    },
    '👨‍👦‍👦': {
        name: 'hombre_niño_niño',
        keywords: ['familia', 'hombre', 'niño'],
    },
    '👨‍👧': {
        name: 'hombre_niña',
        keywords: ['familia', 'hombre', 'niña'],
    },
    '👨‍👧‍👦': {
        name: 'hombre_niño_niña',
        keywords: ['familia', 'hombre', 'niña', 'niño'],
    },
    '👨‍👧‍👧': {
        name: 'hombre_niña_niña',
        keywords: ['familia', 'hombre', 'niña'],
    },
    '👩‍👦': {
        name: 'mujer_niño',
        keywords: ['familia', 'mujer', 'niño'],
    },
    '👩‍👦‍👦': {
        name: 'mujer_niño_niño',
        keywords: ['familia', 'mujer', 'niño'],
    },
    '👩‍👧': {
        name: 'mujer_niña',
        keywords: ['familia', 'mujer', 'niña'],
    },
    '👩‍👧‍👦': {
        name: 'mujer_niña_niño',
        keywords: ['familia', 'mujer', 'niña', 'niño'],
    },
    '👩‍👧‍👧': {
        name: 'mujer_niña_niña',
        keywords: ['familia', 'mujer', 'niña'],
    },
    '🗣️': {
        name: 'silueta_de_cabeza_parlante',
        keywords: ['cabeza', 'cara', 'hablar', 'silueta', 'cabeza parlante'],
    },
    '👤': {
        name: 'silueta_de_busto',
        keywords: ['busto', 'silueta', 'silueta de busto'],
    },
    '👥': {
        name: 'siluetas_de_bustos',
        keywords: ['bustos', 'siluetas', 'dos siluetas de bustos'],
    },
    '🫂': {
        name: 'personas_abrazándose',
        keywords: ['abrazo', 'adiós', 'despedida', 'gracias', 'saludo', 'personas abrazándose'],
    },
    '👣': {
        name: 'huellas',
        keywords: ['huellas', 'pies', 'huellas de pies'],
    },
    '🐵': {
        name: 'cara_de_mono',
        keywords: ['cara', 'mono', 'cara de mono'],
    },
    '🐒': {
        name: 'mono',
        keywords: ['macaco', 'simio', 'mono'],
    },
    '🦍': {
        name: 'gorila',
        keywords: ['primate', 'simio', 'gorila'],
    },
    '🦧': {
        name: 'orangután',
        keywords: ['mono', 'primate', 'simio', 'orangután'],
    },
    '🐶': {
        name: 'perro',
        keywords: ['cara', 'mascota', 'perro', 'cara de perro'],
    },
    '🐕': {
        name: 'perro2',
        keywords: ['cachorro', 'perrete', 'perrito', 'perro'],
    },
    '🦮': {
        name: 'perro_guía',
        keywords: ['accesibilidad', 'ciego', 'guía', 'invidente', 'lazarillo', 'perro guía'],
    },
    '🐕‍🦺': {
        name: 'perro_de_servicio',
        keywords: ['accesibilidad', 'apoyo', 'asistencia', 'perro', 'servicio', 'perro de servicio'],
    },
    '🐩': {
        name: 'caniche',
        keywords: ['perrito', 'perro', 'caniche'],
    },
    '🐺': {
        name: 'lobo',
        keywords: ['cara', 'lobo'],
    },
    '🦊': {
        name: 'cara_zorro',
        keywords: ['cara', 'zorro'],
    },
    '🦝': {
        name: 'mapache',
        keywords: ['astuto', 'curioso', 'ladino', 'maquillaje', 'ojeras', 'mapache'],
    },
    '🐱': {
        name: 'gato',
        keywords: ['cara', 'gato', 'mascota', 'cara de gato'],
    },
    '🐈': {
        name: 'gato2',
        keywords: ['gatete', 'minino', 'gato'],
    },
    '🐈‍⬛': {
        name: 'gato_negro',
        keywords: ['gato', 'mala suerte', 'negro'],
    },
    '🦁': {
        name: 'cara_de_león',
        keywords: ['cara', 'leo', 'zodiaco', 'león'],
    },
    '🐯': {
        name: 'tigre',
        keywords: ['cara', 'tigre', 'cara de tigre'],
    },
    '🐅': {
        name: 'tigre2',
        keywords: ['felino', 'tigre'],
    },
    '🐆': {
        name: 'leopardo',
        keywords: ['felino', 'leopardo'],
    },
    '🐴': {
        name: 'caballo',
        keywords: ['caballo', 'cara', 'cara de caballo'],
    },
    '🐎': {
        name: 'caballo_de_carreras',
        keywords: ['caballo de carreras', 'ecuestre', 'caballo', 'carreras de caballos'],
    },
    '🦄': {
        name: 'cara_de_unicornio',
        keywords: ['cara', 'unicornio'],
    },
    '🦓': {
        name: 'cara_zebra',
        keywords: ['raya', 'cebra'],
    },
    '🦌': {
        name: 'ciervo',
        keywords: ['bambi  cervatillo  ciervo'],
    },
    '🦬': {
        name: 'bisonte',
        keywords: ['búfalo', 'cíbolo', 'bisonte'],
    },
    '🐮': {
        name: 'vaca',
        keywords: ['cara', 'vaca', 'cara de vaca'],
    },
    '🐂': {
        name: 'buey',
        keywords: ['cabestro', 'tauro', 'zodiaco', 'buey'],
    },
    '🐃': {
        name: 'búfalo_de_agua',
        keywords: ['agua', 'búfalo', 'búfalo de agua'],
    },
    '🐄': {
        name: 'vaca2',
        keywords: ['bovino', 'res', 'vaca'],
    },
    '🐷': {
        name: 'cerdo',
        keywords: ['cara', 'cerdo', 'gorrino', 'cara de cerdo'],
    },
    '🐖': {
        name: 'cerdo2',
        keywords: ['cochino', 'gorrino', 'puerco', 'cerdo'],
    },
    '🐗': {
        name: 'jabalí',
        keywords: ['cerdo salvaje', 'jabalí'],
    },
    '🐽': {
        name: 'hocico_de_cerdo',
        keywords: ['cara', 'cerdo', 'morro', 'nariz', 'nariz de cerdo'],
    },
    '🐏': {
        name: 'carnero',
        keywords: ['aries', 'morueco', 'zodiaco', 'carnero'],
    },
    '🐑': {
        name: 'oveja',
        keywords: ['borrego', 'cordero', 'ovino', 'oveja'],
    },
    '🐐': {
        name: 'cabra',
        keywords: ['capricornio', 'caprino', 'chivo', 'zodiaco', 'cabra'],
    },
    '🐪': {
        name: 'dromedario_camello',
        keywords: ['camello', 'desierto', 'joroba', 'dromedario'],
    },
    '🐫': {
        name: 'camello',
        keywords: ['bactriano', 'desierto', 'dromedario', 'jorobas', 'camello'],
    },
    '🦙': {
        name: 'llama',
        keywords: ['alpaca', 'guanaco', 'lana', 'vicuña', 'llama'],
    },
    '🦒': {
        name: 'cara_jirafa',
        keywords: ['manchas', 'jirafa'],
    },
    '🐘': {
        name: 'elefante',
        keywords: ['paquidermo', 'elefante'],
    },
    '🦣': {
        name: 'mamut',
        keywords: ['colmillo', 'extinguido', 'lanudo', 'mamut'],
    },
    '🦏': {
        name: 'rinoceronte',
        keywords: ['paquidermo', 'rinoceronte'],
    },
    '🦛': {
        name: 'hipopótamo',
        keywords: ['paquidermo', 'hipopótamo'],
    },
    '🐭': {
        name: 'ratón',
        keywords: ['cara', 'ratón', 'cara de ratón'],
    },
    '🐁': {
        name: 'mouse2',
        keywords: ['roedor', 'ratón'],
    },
    '🐀': {
        name: 'rata',
        keywords: ['roedor', 'rata'],
    },
    '🐹': {
        name: 'hámster',
        keywords: ['cara', 'mascota', 'hámster'],
    },
    '🐰': {
        name: 'conejo',
        keywords: ['cara', 'conejo', 'mascota', 'cara de conejo'],
    },
    '🐇': {
        name: 'conejo2',
        keywords: ['conejito', 'gazapo', 'conejo'],
    },
    '🐿️': {
        name: 'ardilla',
        keywords: ['ardilla'],
    },
    '🦫': {
        name: 'castor',
        keywords: ['roedor', 'castor'],
    },
    '🦔': {
        name: 'erizo',
        keywords: ['espinas', 'púas', 'erizo'],
    },
    '🦇': {
        name: 'murciélago',
        keywords: ['vampiro', 'murciélago'],
    },
    '🐻': {
        name: 'oso',
        keywords: ['cara', 'oso'],
    },
    '🐻‍❄️': {
        name: 'oso_polar',
        keywords: ['ártico', 'blanco', 'oso', 'polar'],
    },
    '🐨': {
        name: 'coala',
        keywords: ['cara', 'marsupial', 'koala'],
    },
    '🐼': {
        name: 'cara_de_panda',
        keywords: ['cara', 'oso panda', 'panda'],
    },
    '🦥': {
        name: 'perezoso',
        keywords: ['gandul', 'lento', 'vago', 'perezoso'],
    },
    '🦦': {
        name: 'nutria',
        keywords: ['bromista', 'juguetón', 'pesca', 'nutria'],
    },
    '🦨': {
        name: 'mofeta',
        keywords: ['apestar', 'hedor', 'mal olor', 'peste', 'tufo', 'mofeta'],
    },
    '🦘': {
        name: 'canguro',
        keywords: ['marsupial', 'salto', 'canguro'],
    },
    '🦡': {
        name: 'tejón',
        keywords: ['ratel', 'tejón de la miel', 'tejón melero', 'tejón'],
    },
    '🐾': {
        name: 'pies',
        keywords: ['huellas', 'pezuñas', 'huellas de pezuñas'],
    },
    '🦃': {
        name: 'pavo',
        keywords: ['ave', 'pavo'],
    },
    '🐔': {
        name: 'pollo',
        keywords: ['ave', 'gallinácea', 'pollo', 'gallina'],
    },
    '🐓': {
        name: 'gallo',
        keywords: ['ave', 'gallina', 'gallinácea', 'pollo', 'gallo'],
    },
    '🐣': {
        name: 'pollito_saliendo_del_cascarón',
        keywords: ['ave', 'huevo', 'pollito', 'pollo', 'pollito rompiendo el cascarón'],
    },
    '🐤': {
        name: 'pollito',
        keywords: ['ave', 'pollo', 'polluelo', 'pollito'],
    },
    '🐥': {
        name: 'pollito_recién_nacido',
        keywords: ['ave', 'pollito', 'pollo', 'pollito de frente'],
    },
    '🐦': {
        name: 'pájaro',
        keywords: ['ave', 'pajarillo', 'pájaro'],
    },
    '🐧': {
        name: 'pingüino',
        keywords: ['ave', 'pingüino'],
    },
    '🕊️': {
        name: 'paloma_de_la_paz',
        keywords: ['ave', 'pájaro', 'paz', 'paloma'],
    },
    '🦅': {
        name: 'águila',
        keywords: ['ave', 'águila'],
    },
    '🦆': {
        name: 'pato',
        keywords: ['ave', 'pato'],
    },
    '🦢': {
        name: 'cisne',
        keywords: ['ave', 'patito feo', 'cisne'],
    },
    '🦉': {
        name: 'búho',
        keywords: ['ave', 'lechuza', 'pájaro', 'búho'],
    },
    '🦤': {
        name: 'dodo',
        keywords: ['ave', 'dronte', 'extinguido', 'Mauricio', 'pájaro', 'dodo'],
    },
    '🪶': {
        name: 'pluma',
        keywords: ['ave', 'ligero', 'pájaro', 'plumaje', 'pluma'],
    },
    '🦩': {
        name: 'flamenco',
        keywords: ['extravangante', 'ostentoso', 'tropical', 'flamenco'],
    },
    '🦚': {
        name: 'pavo_real',
        keywords: ['ave', 'orgulloso', 'pavo', 'plumas', 'pavo real'],
    },
    '🦜': {
        name: 'loro',
        keywords: ['ave', 'hablar', 'papagayo', 'pirata', 'loro'],
    },
    '🐸': {
        name: 'rana',
        keywords: ['cara', 'rana'],
    },
    '🐊': {
        name: 'cocodrilo',
        keywords: ['caimán', 'cocodrilo'],
    },
    '🐢': {
        name: 'tortuga',
        keywords: ['galápago', 'tortuga'],
    },
    '🦎': {
        name: 'lagarto',
        keywords: ['lagartija', 'reptil', 'lagarto'],
    },
    '🐍': {
        name: 'serpiente',
        keywords: ['culebra', 'reptil', 'víbora', 'serpiente'],
    },
    '🐲': {
        name: 'cara_de_dragón',
        keywords: ['cara', 'cuento', 'dragón', 'fantasía', 'cara de dragón'],
    },
    '🐉': {
        name: 'dragón',
        keywords: ['cuento', 'fantasía', 'dragón'],
    },
    '🦕': {
        name: 'saurópodo',
        keywords: ['braquiosaurio', 'brontosaurio', 'diplodocus', 'saurópodo'],
    },
    '🦖': {
        name: 't-rex',
        keywords: ['tiranosaurio', 'tiranosaurio rex', 't-rex'],
    },
    '🐳': {
        name: 'ballena',
        keywords: ['ballena', 'chorro de agua', 'ballena soltando un chorro'],
    },
    '🐋': {
        name: 'ballena2',
        keywords: ['cachalote', 'cetáceo', 'ballena'],
    },
    '🐬': {
        name: 'delfín',
        keywords: ['cetáceo', 'delfín'],
    },
    '🦭': {
        name: 'foca',
        keywords: ['león marino', 'foca'],
    },
    '🐟': {
        name: 'pez',
        keywords: ['pececillo', 'pescado', 'piscis', 'zodiaco', 'pez'],
    },
    '🐠': {
        name: 'pez_tropical',
        keywords: ['pez', 'tropical'],
    },
    '🐡': {
        name: 'pez_globo',
        keywords: ['globo', 'pez'],
    },
    '🦈': {
        name: 'tiburón',
        keywords: ['pez', 'tiburón'],
    },
    '🐙': {
        name: 'pulpo',
        keywords: ['cefalópodo', 'octópodo', 'pulpo'],
    },
    '🐚': {
        name: 'caracola',
        keywords: ['concha', 'mar', 'concha de mar'],
    },
    '🐌': {
        name: 'caracol',
        keywords: ['caracola', 'molusco', 'caracol'],
    },
    '🦋': {
        name: 'mariposa',
        keywords: ['bonito', 'insecto', 'mariposa'],
    },
    '🐛': {
        name: 'bicho',
        keywords: ['gusano', 'insecto', 'bicho'],
    },
    '🐜': {
        name: 'hormiga',
        keywords: ['antenas', 'insecto', 'hormiga'],
    },
    '🐝': {
        name: 'abeja',
        keywords: ['insecto', 'miel', 'abeja'],
    },
    '🪲': {
        name: 'escarabajo',
        keywords: ['bicho', 'insecto', 'escarabajo'],
    },
    '🐞': {
        name: 'mariquita',
        keywords: ['cochinilla', 'insecto', 'mariquita'],
    },
    '🦗': {
        name: 'grillo',
        keywords: ['saltamontes', 'grillo'],
    },
    '🪳': {
        name: 'cucaracha',
        keywords: ['alimaña', 'bicho', 'insecto', 'plaga', 'cucaracha'],
    },
    '🕷️': {
        name: 'araña',
        keywords: ['insecto', 'araña'],
    },
    '🕸️': {
        name: 'telaraña',
        keywords: ['araña', 'tela', 'telaraña', 'tela de araña'],
    },
    '🦂': {
        name: 'escorpión',
        keywords: ['escorpio', 'zodiaco', 'escorpión'],
    },
    '🦟': {
        name: 'mosquito',
        keywords: ['fiebre', 'insecto', 'malaria', 'virus', 'mosquito'],
    },
    '🪰': {
        name: 'mosca',
        keywords: ['basura', 'bicho', 'mal olor', 'podrido', 'mosca'],
    },
    '🪱': {
        name: 'gusano',
        keywords: ['lombriz', 'oruga', 'parásito', 'gusano'],
    },
    '🦠': {
        name: 'microbio',
        keywords: ['ameba', 'bacteria', 'germen', 'virus', 'microbio'],
    },
    '💐': {
        name: 'ramo',
        keywords: ['bouquet', 'flores', 'ramo', 'ramo de flores'],
    },
    '🌸': {
        name: 'flor_de_cerezo',
        keywords: ['cerezo', 'flor', 'flor de cerezo'],
    },
    '💮': {
        name: 'flor_blanca',
        keywords: ['blanca', 'flor'],
    },
    '🏵️': {
        name: 'roseta',
        keywords: ['flor', 'planta', 'roseta'],
    },
    '🌹': {
        name: 'rosa',
        keywords: ['flor', 'rosa'],
    },
    '🥀': {
        name: 'flor_marchita',
        keywords: ['flor', 'marchita', 'marchitada', 'marchitarse'],
    },
    '🌺': {
        name: 'hibisco',
        keywords: ['flor', 'hibisco', 'flor de hibisco'],
    },
    '🌻': {
        name: 'girasol',
        keywords: ['flor', 'sol', 'girasol'],
    },
    '🌼': {
        name: 'flor',
        keywords: ['flor'],
    },
    '🌷': {
        name: 'tulipán',
        keywords: ['flor', 'tulipán'],
    },
    '🌱': {
        name: 'plántula',
        keywords: ['plantón', 'planta joven'],
    },
    '🪴': {
        name: 'planta_de_maceta',
        keywords: ['crecer', 'maceta', 'planta', 'tiesto', 'planta de maceta'],
    },
    '🌲': {
        name: 'árbol_de_hoja_perenne',
        keywords: ['árbol', 'hoja perenne', 'perenne', 'árbol de hoja perenne'],
    },
    '🌳': {
        name: 'árbol_caduco',
        keywords: ['árbol', 'caducifolio', 'hoja caduca', 'árbol de hoja caduca'],
    },
    '🌴': {
        name: 'palmera',
        keywords: ['árbol', 'árbol de palma', 'palmera'],
    },
    '🌵': {
        name: 'cactus',
        keywords: ['planta', 'cactus'],
    },
    '🌾': {
        name: 'planta_de_arroz',
        keywords: ['arroz', 'espiga', 'planta', 'espiga de arroz'],
    },
    '🌿': {
        name: 'hierba',
        keywords: ['hoja', 'verde', 'hierba'],
    },
    '☘️': {
        name: 'trébol',
        keywords: ['planta', 'trébol'],
    },
    '🍀': {
        name: 'trébol_de_cuatro_hojas',
        keywords: ['suerte', 'trébol', 'trébol de cuatro hojas'],
    },
    '🍁': {
        name: 'hoja_de_arce',
        keywords: ['arce', 'hoja', 'hoja de arce'],
    },
    '🍂': {
        name: 'hoja_caída',
        keywords: ['caída', 'hojas', 'hojas caídas'],
    },
    '🍃': {
        name: 'hojas',
        keywords: ['hoja', 'revolotear', 'soplar', 'viento', 'hojas revoloteando al viento'],
    },
    '🍇': {
        name: 'uvas',
        keywords: ['agracejo', 'fruta', 'racimo', 'uva', 'uvas'],
    },
    '🍈': {
        name: 'melón',
        keywords: ['fruta', 'melón'],
    },
    '🍉': {
        name: 'sandía',
        keywords: ['fruta', 'sandía'],
    },
    '🍊': {
        name: 'mandarina',
        keywords: ['fruta', 'naranja', 'mandarina'],
    },
    '🍋': {
        name: 'limón',
        keywords: ['cítrico', 'citrón', 'fruta', 'limón'],
    },
    '🍌': {
        name: 'plátano',
        keywords: ['banana', 'fruta', 'plátano'],
    },
    '🍍': {
        name: 'piña',
        keywords: ['ananás', 'fruta', 'piña'],
    },
    '🥭': {
        name: 'mango',
        keywords: ['fruta', 'tropical', 'mango'],
    },
    '🍎': {
        name: 'manzana',
        keywords: ['fruta', 'manzana', 'poma', 'roja'],
    },
    '🍏': {
        name: 'manzana_verde',
        keywords: ['fruta', 'manzana', 'poma', 'verde'],
    },
    '🍐': {
        name: 'pera',
        keywords: ['fruta', 'perilla', 'pera'],
    },
    '🍑': {
        name: 'melocotón',
        keywords: ['durazno', 'fruta', 'melocotón'],
    },
    '🍒': {
        name: 'cerezas',
        keywords: ['cereza', 'fruta', 'guindas', 'cerezas'],
    },
    '🍓': {
        name: 'fresa',
        keywords: ['fresón', 'fruta', 'fresa'],
    },
    '🫐': {
        name: 'arándanos',
        keywords: ['arándano', 'azul', 'baya', 'frutos del bosque', 'mirtilo', 'arándanos'],
    },
    '🥝': {
        name: 'kiwi',
        keywords: ['comida', 'fruta', 'kiwi'],
    },
    '🍅': {
        name: 'tomate',
        keywords: ['ensalada', 'fruta', 'verdura', 'tomate'],
    },
    '🫒': {
        name: 'aceituna',
        keywords: ['aperitivo', 'comida', 'oliva', 'aceituna'],
    },
    '🥥': {
        name: 'coco',
        keywords: ['palmera', 'piña colada', 'coco'],
    },
    '🥑': {
        name: 'aguacate',
        keywords: ['comida', 'fruta', 'aguacate'],
    },
    '🍆': {
        name: 'berenjena',
        keywords: ['fruto', 'verdura', 'berenjena'],
    },
    '🥔': {
        name: 'patata',
        keywords: ['comida', 'papa', 'verdura', 'patata'],
    },
    '🥕': {
        name: 'zanahoria',
        keywords: ['comida', 'verdura', 'zanahoria'],
    },
    '🌽': {
        name: 'maíz',
        keywords: ['espiga', 'maíz', 'mazorca', 'mijo', 'espiga de maíz'],
    },
    '🌶️': {
        name: 'guindilla',
        keywords: ['chile', 'picante', 'planta'],
    },
    '🫑': {
        name: 'pimiento',
        keywords: ['ají', 'chile', 'morrón', 'rojo', 'verdura', 'pimiento'],
    },
    '🥒': {
        name: 'pepino',
        keywords: ['comida', 'pepinillo', 'verdura', 'pepino'],
    },
    '🥬': {
        name: 'verdura_de_hoja_verde',
        keywords: ['bok choy', 'col', 'kale', 'lechuga', 'pak choi', 'verdura de hoja verde'],
    },
    '🥦': {
        name: 'brócoli',
        keywords: ['col', 'repollo', 'brócoli'],
    },
    '🧄': {
        name: 'ajo',
        keywords: ['condimento', 'vampiro', 'ajo'],
    },
    '🧅': {
        name: 'cebolla',
        keywords: ['condimento', 'llorar', 'cebolla'],
    },
    '🍄': {
        name: 'seta',
        keywords: ['hongo', 'seta', 'champiñón'],
    },
    '🥜': {
        name: 'cacahuetes',
        keywords: ['cacahuete', 'comida', 'fruto seco', 'verdura', 'cacahuetes'],
    },
    '🌰': {
        name: 'castaña',
        keywords: ['castaño', 'fruto seco', 'castaña'],
    },
    '🍞': {
        name: 'pan',
        keywords: ['pan', 'rebanada', 'tostada', 'pan de molde'],
    },
    '🥐': {
        name: 'cruasán',
        keywords: ['bollo', 'comida', 'croissant', 'francés', 'cruasán'],
    },
    '🥖': {
        name: 'baguete',
        keywords: ['baguette', 'barra', 'comida', 'francés', 'pan', 'baguete'],
    },
    '🫓': {
        name: 'pan_sin_levadura',
        keywords: ['arepa', 'naan', 'pita', 'tortilla', 'pan sin levadura'],
    },
    '🥨': {
        name: 'galleta_salada',
        keywords: ['galleta salada', 'pretzel', 'bretzel'],
    },
    '🥯': {
        name: 'bagel',
        keywords: ['bocadillo', 'pan', 'panadería', 'bagel'],
    },
    '🥞': {
        name: 'crepes',
        keywords: ['comida', 'dulce', 'pancakes', 'postre', 'tortita', 'tortitas'],
    },
    '🧇': {
        name: 'gofre',
        keywords: ['waffle', 'gofre'],
    },
    '🧀': {
        name: 'cuña_de_queso',
        keywords: ['cuña', 'queso', 'trozo', 'cuña de queso'],
    },
    '🍖': {
        name: 'hueso_con_carne',
        keywords: ['carne', 'hueso', 'restaurante', 'carne con hueso'],
    },
    '🍗': {
        name: 'muslo_de_pollo',
        keywords: ['muslo', 'pollo', 'restaurante', 'muslo de pollo'],
    },
    '🥩': {
        name: 'chuleta',
        keywords: ['carne', 'chuleta', 'filete', 'corte de carne'],
    },
    '🥓': {
        name: 'beicon',
        keywords: ['bacon', 'carne', 'comida', 'panceta', 'beicon'],
    },
    '🍔': {
        name: 'hamburguesa',
        keywords: ['burger', 'hamburguesa'],
    },
    '🍟': {
        name: 'patatas_fritas',
        keywords: ['papas fritas', 'patatas', 'restaurante', 'patatas fritas'],
    },
    '🍕': {
        name: 'pizza',
        keywords: ['porción', 'restaurante', 'pizza'],
    },
    '🌭': {
        name: 'perrito_caliente',
        keywords: ['perrito', 'salchicha', 'perrito caliente'],
    },
    '🥪': {
        name: 'sándwich',
        keywords: ['bocadillo', 'bocata', 'emparedado', 'sándwich'],
    },
    '🌮': {
        name: 'taco',
        keywords: ['comida', 'mexicano', 'taco'],
    },
    '🌯': {
        name: 'burrito',
        keywords: ['comida', 'mexicano', 'tex mex', 'wrap', 'burrito'],
    },
    '🫔': {
        name: 'tamal',
        keywords: ['mejicano', 'mexicano', 'wrap', 'tamal'],
    },
    '🥙': {
        name: 'kebab',
        keywords: ['comida', 'durum', 'falafel', 'kebab', 'pan de pita', 'pan relleno'],
    },
    '🧆': {
        name: 'falafel',
        keywords: ['albóndiga', 'garbanzo', 'falafel'],
    },
    '🥚': {
        name: 'huevo',
        keywords: ['comida', 'huevo'],
    },
    '🍳': {
        name: 'huevo_frito',
        keywords: ['freír', 'huevo', 'sartén', 'cocinar'],
    },
    '🥘': {
        name: 'paella',
        keywords: ['arroz', 'comida', 'paella'],
    },
    '🍲': {
        name: 'estofado',
        keywords: ['comida de olla', 'puchero', 'restaurante', 'olla de comida'],
    },
    '🫕': {
        name: 'fondue',
        keywords: ['chocolate', 'olla', 'queso', 'suizo', 'fondue'],
    },
    '🥣': {
        name: 'cuenco_con_cuchara',
        keywords: ['cereal', 'desayuno', 'cuenco con cuchara'],
    },
    '🥗': {
        name: 'ensalada_verde',
        keywords: ['bol', 'comida', 'verde', 'ensalada'],
    },
    '🍿': {
        name: 'palomitas_de_maíz',
        keywords: ['maíz', 'palomitas'],
    },
    '🧈': {
        name: 'mantequilla',
        keywords: ['lácteo', 'mantequilla'],
    },
    '🧂': {
        name: 'sal',
        keywords: ['condimento', 'salero', 'sal'],
    },
    '🥫': {
        name: 'comida_enlatada',
        keywords: ['conserva', 'lata', 'comida enlatada'],
    },
    '🍱': {
        name: 'bento',
        keywords: ['bento', 'caja', 'comida', 'restaurante', 'caja de bento'],
    },
    '🍘': {
        name: 'galleta_de_arroz',
        keywords: ['arroz', 'galleta', 'galleta de arroz'],
    },
    '🍙': {
        name: 'bola_de_arroz',
        keywords: ['arroz', 'japonés', 'onigiri', 'restaurante', 'bola de arroz'],
    },
    '🍚': {
        name: 'arroz',
        keywords: ['arroz', 'restaurante', 'arroz cocido'],
    },
    '🍛': {
        name: 'curry',
        keywords: ['arroz', 'curry', 'restaurante', 'arroz con curry'],
    },
    '🍜': {
        name: 'ramen',
        keywords: ['fideos calientes', 'fideos chinos', 'fideos ramen', 'ramen', 'tazón de fideos'],
    },
    '🍝': {
        name: 'espaguetis',
        keywords: ['pasta', 'restaurante', 'espagueti'],
    },
    '🍠': {
        name: 'batata',
        keywords: ['asada', 'papa asada', 'patata', 'restaurante'],
    },
    '🍢': {
        name: 'oden',
        keywords: ['japonés', 'marisco', 'oden', 'pincho', 'brocheta'],
    },
    '🍣': {
        name: 'sushi',
        keywords: ['restaurante', 'sushi'],
    },
    '🍤': {
        name: 'camarón_frito',
        keywords: ['frito', 'gamba', 'restaurante', 'gamba frita'],
    },
    '🍥': {
        name: 'pastel_de_pescado',
        keywords: ['comida japonesa', 'pastel', 'pescado', 'pastel de pescado japonés'],
    },
    '🥮': {
        name: 'pastel_de_luna',
        keywords: ['festival', 'luna', 'otoño', 'yuebing', 'pastel de luna'],
    },
    '🍡': {
        name: 'dango',
        keywords: ['japonés', 'pincho', 'postre', 'restaurante', 'dango'],
    },
    '🥟': {
        name: 'empanadilla',
        keywords: ['comida', 'gyōza', 'jiaozi', 'masa', 'dumpling'],
    },
    '🥠': {
        name: 'galletita_fortuna',
        keywords: ['adivinación', 'profecía', 'superstición', 'galleta de la fortuna'],
    },
    '🥡': {
        name: 'caja_comida_rápida',
        keywords: ['recipiente para llevar', 'restaurante', 'caja para llevar'],
    },
    '🦀': {
        name: 'cangrejo',
        keywords: ['animal', 'cáncer', 'zodiaco', 'cangrejo'],
    },
    '🦞': {
        name: 'langosta',
        keywords: ['langosta', 'marisco', 'pinzas', 'bogavante'],
    },
    '🦐': {
        name: 'camarón',
        keywords: ['camarón', 'comida', 'langostino', 'marisco', 'gamba'],
    },
    '🦑': {
        name: 'calamar',
        keywords: ['comida', 'molusco', 'calamar'],
    },
    '🦪': {
        name: 'ostra',
        keywords: ['buceo', 'perla', 'ostra'],
    },
    '🍦': {
        name: 'helado',
        keywords: ['cucurucho', 'dulce', 'helado', 'helado de cucurucho', 'restaurante', 'cucurucho de helado'],
    },
    '🍧': {
        name: 'hielo_picado',
        keywords: ['helado', 'hielo', 'postre', 'raspado', 'granizado hawaiano'],
    },
    '🍨': {
        name: 'postre_helado',
        keywords: ['postre', 'sorbete', 'helado'],
    },
    '🍩': {
        name: 'rosquilla',
        keywords: ['berlina', 'pastel', 'rosquilla', 'dónut'],
    },
    '🍪': {
        name: 'galleta',
        keywords: ['dulce', 'pasta', 'postre', 'galleta'],
    },
    '🎂': {
        name: 'cumpleaños',
        keywords: ['celebración', 'cumpleaños', 'tarta', 'tarta de cumpleaños'],
    },
    '🍰': {
        name: 'pastel',
        keywords: ['pedazo de tarta', 'restaurante', 'tarta', 'trozo de tarta'],
    },
    '🧁': {
        name: 'magdalena',
        keywords: ['cupcake', 'dulce', 'repostería', 'magdalena'],
    },
    '🥧': {
        name: 'tarta',
        keywords: ['masa', 'relleno', 'pastel'],
    },
    '🍫': {
        name: 'chocolatina',
        keywords: ['barra', 'chocolate', 'restaurante', 'tableta', 'tableta de chocolate'],
    },
    '🍬': {
        name: 'caramelo',
        keywords: ['chuche', 'chuchería', 'dulce', 'golosina', 'caramelo'],
    },
    '🍭': {
        name: 'piruleta',
        keywords: ['chuche', 'chuchería', 'dulce', 'golosina', 'piruleta'],
    },
    '🍮': {
        name: 'natillas',
        keywords: ['dulce', 'postre', 'pudding', 'flan'],
    },
    '🍯': {
        name: 'tarro_de_miel',
        keywords: ['dulce', 'miel', 'tarro', 'tarro de miel'],
    },
    '🍼': {
        name: 'biberón',
        keywords: ['bebé', 'bibe', 'bibi', 'botella', 'leche', 'biberón'],
    },
    '🥛': {
        name: 'vaso_de_leche',
        keywords: ['bebida', 'leche', 'vaso', 'vaso de leche'],
    },
    '☕': {
        name: 'café',
        keywords: ['bebida', 'café', 'caliente', 'té'],
    },
    '🫖': {
        name: 'tetera',
        keywords: ['bebida', 'infusión', 'té', 'tetera'],
    },
    '🍵': {
        name: 'té',
        keywords: ['bebida', 'taza', 'té', 'tazón de té'],
    },
    '🍶': {
        name: 'sake',
        keywords: ['bar', 'bebida', 'botella', 'restaurante', 'tazón', 'sake'],
    },
    '🍾': {
        name: 'champán',
        keywords: ['bar', 'beber', 'botella', 'cava', 'corcho', 'botella descorchada'],
    },
    '🍷': {
        name: 'copa_de_vino',
        keywords: ['bar', 'bebida', 'copa', 'vaso', 'vino', 'copa de vino'],
    },
    '🍸': {
        name: 'cóctel',
        keywords: ['bar', 'cóctel', 'copa', 'restaurante', 'copa de cóctel'],
    },
    '🍹': {
        name: 'bebida_tropical',
        keywords: ['bar', 'bebida', 'restaurante', 'tropical'],
    },
    '🍺': {
        name: 'cerveza',
        keywords: ['bar', 'cerveza', 'jarra', 'restaurante', 'jarra de cerveza'],
    },
    '🍻': {
        name: 'cervezas',
        keywords: ['bar', 'cerveza', 'jarra', 'jarras', 'restaurante', 'jarras de cerveza brindando'],
    },
    '🥂': {
        name: 'copas_brindis',
        keywords: ['bebida', 'brindar', 'brindis', 'celebración', 'copa', 'copas brindando'],
    },
    '🥃': {
        name: 'vaso_corto',
        keywords: ['chupito', 'copa', 'licor', 'vaso', 'whisky', 'vaso de whisky'],
    },
    '🥤': {
        name: 'vaso_con_pajita',
        keywords: ['refresco', 'zumo', 'vaso con pajita'],
    },
    '🧋': {
        name: 'té_de_burbujas',
        keywords: ['boba', 'bubble tea', 'burbuja', 'leche', 'perla', 'té', 'té de burbujas'],
    },
    '🧃': {
        name: 'tetrabrik',
        keywords: ['brick', 'cartón', 'envase', 'zumo', 'tetrabrik'],
    },
    '🧉': {
        name: 'bebida_de_mate',
        keywords: ['bebida', 'infusión', 'mate'],
    },
    '🧊': {
        name: 'cubito_de_hielo',
        keywords: ['frío', 'iceberg', 'cubito de hielo'],
    },
    '🥢': {
        name: 'palillos',
        keywords: ['cubiertos', 'hashi', 'palillos'],
    },
    '🍽️': {
        name: 'cuchillo_tenedor_plato',
        keywords: ['cuchillo', 'plato', 'restaurante', 'tenedor', 'cuchillo y tenedor con un plato'],
    },
    '🍴': {
        name: 'cuchilo_y_tenedor',
        keywords: ['cuchillo', 'restaurante', 'tenedor', 'tenedor y cuchillo'],
    },
    '🥄': {
        name: 'cuchara',
        keywords: ['cubiertos', 'cucharilla', 'cuchara'],
    },
    '🔪': {
        name: 'cuchillo_japonés',
        keywords: ['arma', 'cocinar', 'cuchillo', 'cuchillo de cocina'],
    },
    '🏺': {
        name: 'ánfora',
        keywords: ['acuario', 'beber', 'jarra', 'zodiaco', 'ánfora'],
    },
    '🌍': {
        name: 'tierra_áfrica',
        keywords: ['África', 'Europa', 'mundo', 'planeta', 'Tierra', 'globo terráqueo mostrando Europa y África'],
    },
    '🌎': {
        name: 'tierra_américa',
        keywords: ['América', 'globo', 'mundo', 'planeta', 'Tierra', 'globo terráqueo mostrando América'],
    },
    '🌏': {
        name: 'tierra_asia',
        keywords: ['Asia', 'Australia', 'mundo', 'planeta', 'Tierra', 'globo terráqueo mostrando Asia y Australia'],
    },
    '🌐': {
        name: 'globo_terráqueo_con_meridianos',
        keywords: ['globo', 'meridianos', 'mundo', 'Tierra', 'globo terráqueo con meridianos'],
    },
    '🗺️': {
        name: 'mapamundi',
        keywords: ['mapa', 'mapamundi', 'mundo', 'mapa mundial'],
    },
    '🗾': {
        name: 'japón',
        keywords: ['Japón', 'mapa', 'mapa de japón', 'mapa de Japón'],
    },
    '🧭': {
        name: 'brújula',
        keywords: ['compás', 'magnético', 'navegación', 'orientación', 'brújula'],
    },
    '🏔️': {
        name: 'montaña_con_cima_nevada',
        keywords: ['frío', 'montaña', 'nieve', 'montaña con nieve'],
    },
    '⛰️': {
        name: 'montaña',
        keywords: ['monte', 'montaña'],
    },
    '🌋': {
        name: 'volcán',
        keywords: ['erupción', 'erupción volcánica', 'volcán'],
    },
    '🗻': {
        name: 'monte_fuji',
        keywords: ['montaña', 'monte fuji', 'monte Fuji'],
    },
    '🏕️': {
        name: 'campin',
        keywords: ['acampada', 'campamento', 'vacaciones', 'camping'],
    },
    '🏖️': {
        name: 'playa_con_sombrilla',
        keywords: ['playa', 'sombrilla', 'playa y sombrilla'],
    },
    '🏜️': {
        name: 'desierto',
        keywords: ['arena', 'desierto'],
    },
    '🏝️': {
        name: 'isla_desierta',
        keywords: ['desierta', 'isla'],
    },
    '🏞️': {
        name: 'parque_nacional',
        keywords: ['nacional', 'parque'],
    },
    '🏟️': {
        name: 'estadio',
        keywords: ['estadio'],
    },
    '🏛️': {
        name: 'edificio_clásico',
        keywords: ['clásico', 'edificio'],
    },
    '🏗️': {
        name: 'edificio_en_construcción',
        keywords: ['edificio', 'obra', 'construcción'],
    },
    '🧱': {
        name: 'ladrillos',
        keywords: ['arcilla', 'cemento', 'muro', 'pared', 'ladrillo'],
    },
    '🪨': {
        name: 'roca',
        keywords: ['pedrusco', 'peña', 'peñasco', 'roca', 'piedra'],
    },
    '🪵': {
        name: 'madera',
        keywords: ['hoguera', 'leña', 'madero', 'palos', 'tronco', 'madera'],
    },
    '🛖': {
        name: 'cabaña',
        keywords: ['casa', 'yurta', 'cabaña'],
    },
    '🏘️': {
        name: 'edificios_de_viviendas',
        keywords: ['edificio', 'urbanización', 'casas'],
    },
    '🏚️': {
        name: 'edificio_de_viviendas_en_ruinas',
        keywords: ['abandonada', 'casa', 'deshabitada', 'inhabitada', 'vacía'],
    },
    '🏠': {
        name: 'casa',
        keywords: ['vivienda', 'casa'],
    },
    '🏡': {
        name: 'casa_con_jardín',
        keywords: ['casa', 'construcción', 'jardín', 'vivienda', 'casa con jardín'],
    },
    '🏢': {
        name: 'oficina',
        keywords: ['construcción', 'edificio', 'oficinas', 'edificio de oficinas'],
    },
    '🏣': {
        name: 'oficina_postal',
        keywords: ['correos', 'edificio', 'japón', 'oficina de correos', 'oficina de correos japonesa'],
    },
    '🏤': {
        name: 'oficina_de_correos_europea',
        keywords: ['correos', 'edificio', 'europa', 'oficina de correos', 'oficina de correos europea'],
    },
    '🏥': {
        name: 'hospital',
        keywords: ['doctor', 'edificio', 'medicina', 'médico', 'hospital'],
    },
    '🏦': {
        name: 'banco',
        keywords: ['banca', 'edificio', 'banco'],
    },
    '🏨': {
        name: 'hotel',
        keywords: ['alojamiento', 'edificio', 'turismo', 'hotel'],
    },
    '🏩': {
        name: 'motel_para_parejas',
        keywords: ['amor', 'edificio', 'hotel', 'hotel del amor'],
    },
    '🏪': {
        name: 'tienda_de_barrio',
        keywords: ['edificio', 'establecimiento', 'tienda de comestibles', 'tienda 24 horas'],
    },
    '🏫': {
        name: 'colegio',
        keywords: ['edificio', 'escuela', 'colegio'],
    },
    '🏬': {
        name: 'grandes_almacenes',
        keywords: ['comercio', 'grandes almacenes'],
    },
    '🏭': {
        name: 'fábrica',
        keywords: ['edificio', 'industria', 'fábrica'],
    },
    '🏯': {
        name: 'castillo_japonés',
        keywords: ['castillo', 'construcción', 'castillo japonés'],
    },
    '🏰': {
        name: 'castillo_europeo',
        keywords: ['castillo', 'construcción', 'castillo europeo'],
    },
    '💒': {
        name: 'boda',
        keywords: ['boda', 'iglesia', 'romance', 'iglesia celebrando boda'],
    },
    '🗼': {
        name: 'torre_de_tokio',
        keywords: ['Tokio', 'torre', 'Torre de Tokio'],
    },
    '🗽': {
        name: 'estatua_de_la_libertad',
        keywords: ['estatua', 'estatua de la libertad', 'Estatua de la Libertad', 'libertad'],
    },
    '⛪': {
        name: 'iglesia',
        keywords: ['cristianismo', 'cruz', 'edificio', 'religión', 'iglesia'],
    },
    '🕌': {
        name: 'mezquita',
        keywords: ['islam', 'religión', 'mezquita'],
    },
    '🛕': {
        name: 'templo_hindú',
        keywords: ['hindú', 'templo'],
    },
    '🕍': {
        name: 'sinagoga',
        keywords: ['judaísmo', 'religión', 'sinagoga'],
    },
    '⛩️': {
        name: 'santuario_sintoísta',
        keywords: ['japón', 'religión', 'santuario', 'sintoísmo', 'santuario sintoísta'],
    },
    '🕋': {
        name: 'kaaba',
        keywords: ['islam', 'kaaba', 'Kaaba', 'religión'],
    },
    '⛲': {
        name: 'fuente',
        keywords: ['fuente'],
    },
    '⛺': {
        name: 'tienda_de_campaña',
        keywords: ['campaña', 'camping', 'tienda', 'vacaciones', 'tienda de campaña'],
    },
    '🌁': {
        name: 'brumoso',
        keywords: ['niebla', 'bruma'],
    },
    '🌃': {
        name: 'noche_estrellada',
        keywords: ['estrellas', 'noche', 'noche estrellada'],
    },
    '🏙️': {
        name: 'paisaje_urbano',
        keywords: ['ciudad', 'edificio', 'paisaje', 'paisaje urbano'],
    },
    '🌄': {
        name: 'amanecer_sobre_las_montañas',
        keywords: ['amanecer', 'montaña', 'salida', 'sol', 'amanecer sobre montañas'],
    },
    '🌅': {
        name: 'amanecer',
        keywords: ['salida del sol', 'amanecer'],
    },
    '🌆': {
        name: 'puesta_de_sol_urbana',
        keywords: ['atardecer', 'ciudad', 'edificios', 'paisaje', 'ciudad al atardecer'],
    },
    '🌇': {
        name: 'amanecer_urbano',
        keywords: ['edificios', 'puesta del sol'],
    },
    '🌉': {
        name: 'puente_de_noche',
        keywords: ['noche', 'puente', 'puente de noche'],
    },
    '♨️': {
        name: 'aguas_termales',
        keywords: ['termas', 'vapor', 'aguas termales'],
    },
    '🎠': {
        name: 'caballito_de_carrusel',
        keywords: ['caballo', 'entretenimiento', 'tiovivo', 'caballo de tiovivo'],
    },
    '🎡': {
        name: 'noria',
        keywords: ['atracciones', 'entretenimiento', 'feria', 'noria', 'noria de feria'],
    },
    '🎢': {
        name: 'montaña_rusa',
        keywords: ['atracciones', 'entretenimiento', 'feria', 'parque', 'montaña rusa'],
    },
    '💈': {
        name: 'barbero',
        keywords: ['barbería', 'barbero', 'peluquero', 'poste', 'poste de barbero'],
    },
    '🎪': {
        name: 'carpa_de_circo',
        keywords: ['carpa', 'circo', 'entretenimiento', 'carpa de circo'],
    },
    '🚂': {
        name: 'locomotora_de_vapor',
        keywords: ['locomotora', 'tren', 'vehículo', 'locomotora de vapor'],
    },
    '🚃': {
        name: 'vagón',
        keywords: ['ferrocarril', 'tranvía', 'tren eléctrico', 'vehículo', 'vagón'],
    },
    '🚄': {
        name: 'tren_bala_de_lado',
        keywords: ['AVE', 'ferrocarril', 'rápido', 'tren', 'velocidad', 'tren de alta velocidad'],
    },
    '🚅': {
        name: 'tren_bala_de_frente',
        keywords: ['bala', 'shinkansen', 'tren', 'vehículo', 'velocidad'],
    },
    '🚆': {
        name: 'tren2',
        keywords: ['ferrocarril', 'vehículo', 'tren'],
    },
    '🚇': {
        name: 'metro',
        keywords: ['subterráneo', 'suburbano', 'transporte', 'metro'],
    },
    '🚈': {
        name: 'tren_ligero',
        keywords: ['ferrocarril', 'transporte', 'tren', 'tren ligero'],
    },
    '🚉': {
        name: 'estación',
        keywords: ['estación', 'tren', 'estación de tren'],
    },
    '🚊': {
        name: 'tranvía',
        keywords: ['transporte', 'trolebús', 'tranvía'],
    },
    '🚝': {
        name: 'monorraíl',
        keywords: ['ferrocarril', 'monocarril', 'transporte', 'tren', 'monorraíl'],
    },
    '🚞': {
        name: 'tren_de_montaña',
        keywords: ['ferrocarril', 'montaña', 'vehículo', 'ferrocarril de montaña'],
    },
    '🚋': {
        name: 'tren',
        keywords: ['tranvía', 'vagón', 'vehículo', 'vagón de tranvía'],
    },
    '🚌': {
        name: 'autobús',
        keywords: ['bus', 'transporte', 'autobús'],
    },
    '🚍': {
        name: 'bus_en_sentido_contrario',
        keywords: ['autobús', 'próximo', 'vehículo'],
    },
    '🚎': {
        name: 'trolebús',
        keywords: ['transporte', 'tranvía', 'trolebús'],
    },
    '🚐': {
        name: 'microbús',
        keywords: ['autobús', 'bus', 'transporte', 'minibús'],
    },
    '🚑': {
        name: 'ambulancia',
        keywords: ['asistencia médica', 'transporte', 'vehículo', 'ambulancia'],
    },
    '🚒': {
        name: 'camión_de_bomberos',
        keywords: ['camión', 'camión de bomberos', 'fuego', 'vehículo', 'coche de bomberos'],
    },
    '🚓': {
        name: 'coche_patrulla',
        keywords: ['coche patrulla', 'policía', 'vehículo', 'coche de policía'],
    },
    '🚔': {
        name: 'coche_de_policía_en_sentido_contrario',
        keywords: ['coche patrulla', 'policía', 'próximo', 'vehículo', 'coche de policía próximo'],
    },
    '🚕': {
        name: 'taxi',
        keywords: ['coche', 'vehículo', 'taxi'],
    },
    '🚖': {
        name: 'taxi_en_sentido_contrario',
        keywords: ['taxi', 'vehículo', 'taxi próximo'],
    },
    '🚗': {
        name: 'coche',
        keywords: ['automóvil', 'vehículo', 'coche'],
    },
    '🚘': {
        name: 'automóvil_en_sentido_contrario',
        keywords: ['automóvil', 'coche', 'próximo', 'vehículo'],
    },
    '🚙': {
        name: 'coche_azul',
        keywords: ['camping', 'caravana', 'furgoneta', 'vacaciones', 'vehículo', 'vehículo deportivo utilitario'],
    },
    '🛻': {
        name: 'camioneta',
        keywords: ['pickup', 'ranchera', 'camioneta'],
    },
    '🚚': {
        name: 'camión',
        keywords: ['mercancías', 'reparto', 'transporte', 'vehículo', 'camión de reparto'],
    },
    '🚛': {
        name: 'camión_articulado',
        keywords: ['camión', 'tráiler', 'vehículo', 'camión articulado'],
    },
    '🚜': {
        name: 'tractor',
        keywords: ['agricultura', 'vehículo', 'tractor'],
    },
    '🏎️': {
        name: 'coche_de_carreras',
        keywords: ['carreras', 'coche', 'coche de carreras'],
    },
    '🏍️': {
        name: 'moto_de_carreras',
        keywords: ['carreras', 'motocicleta', 'vehículo', 'moto'],
    },
    '🛵': {
        name: 'vespa',
        keywords: ['escúter', 'moto', 'scooter'],
    },
    '🦽': {
        name: 'silla_de_ruedas_manual',
        keywords: ['accesibilidad', 'silla de ruedas manual'],
    },
    '🦼': {
        name: 'silla_de_ruedas_eléctrica',
        keywords: ['accesibilidad', 'silla de ruedas eléctrica'],
    },
    '🛺': {
        name: 'mototaxi',
        keywords: ['rickshaw', 'tuk tuk', 'mototaxi'],
    },
    '🚲': {
        name: 'bicicleta',
        keywords: ['bici', 'vehículo', 'bicicleta'],
    },
    '🛴': {
        name: 'patinete',
        keywords: ['patinete'],
    },
    '🛹': {
        name: 'monopatín',
        keywords: ['skateboard', 'tabla', 'monopatín'],
    },
    '🛼': {
        name: 'patines',
        keywords: ['patín', 'patín de 4 ruedas', 'patín de cuatro ruedas', 'patines'],
    },
    '🚏': {
        name: 'parada_de_autobús',
        keywords: ['autobús', 'parada', 'parada de autobús'],
    },
    '🛣️': {
        name: 'autopista',
        keywords: ['carretera', 'autopista'],
    },
    '🛤️': {
        name: 'vía_de_tren',
        keywords: ['tren', 'vía', 'vía de tren'],
    },
    '🛢️': {
        name: 'barril_de_petróleo',
        keywords: ['barril', 'bidón', 'petróleo', 'barril de petróleo'],
    },
    '⛽': {
        name: 'surtidor_de_gasolina',
        keywords: ['bomba de gasolina', 'combustible', 'gasolina', 'surtidor', 'surtidor de gasolina'],
    },
    '🚨': {
        name: 'luz_giratoria',
        keywords: ['coche de policía', 'luces', 'policía', 'luces de policía'],
    },
    '🚥': {
        name: 'semáforo',
        keywords: ['luz', 'señales de tráfico', 'tráfico', 'semáforo horizontal'],
    },
    '🚦': {
        name: 'semáforo_vertical',
        keywords: ['luz', 'semáforo vertical', 'señales de tráfico', 'tráfico', 'semáforo'],
    },
    '🛑': {
        name: 'señal_octogonal',
        keywords: ['octágono', 'parada', 'señal', 'stop', 'señal de stop'],
    },
    '🚧': {
        name: 'construcción',
        keywords: ['construcción', 'señal', 'señal de obras', 'obras'],
    },
    '⚓': {
        name: 'ancla',
        keywords: ['barco', 'gancho', 'ancla'],
    },
    '⛵': {
        name: 'barco_de_vela',
        keywords: ['barco', 'barco de vela', 'yate', 'velero'],
    },
    '🛶': {
        name: 'canoa',
        keywords: ['barca', 'barco', 'piragua', 'canoa'],
    },
    '🚤': {
        name: 'lancha_rápida',
        keywords: ['barco', 'vehículo', 'lancha motora'],
    },
    '🛳️': {
        name: 'barco_de_pasajeros',
        keywords: ['barco', 'pasajeros', 'vehículo', 'barco de pasajeros'],
    },
    '⛴️': {
        name: 'ferri',
        keywords: ['barco', 'ferry', 'ferri'],
    },
    '🛥️': {
        name: 'motora',
        keywords: ['barco', 'motor', 'vehículo', 'barco a motor'],
    },
    '🚢': {
        name: 'barco',
        keywords: ['vehículo', 'barco'],
    },
    '✈️': {
        name: 'avión',
        keywords: ['aeroplano', 'avión'],
    },
    '🛩️': {
        name: 'avioneta',
        keywords: ['avión', 'avioneta'],
    },
    '🛫': {
        name: 'avión_despegando',
        keywords: ['aeroplano', 'avión', 'salida', 'avión despegando'],
    },
    '🛬': {
        name: 'avión_aterrizando',
        keywords: ['aeroplano', 'avión', 'llegada', 'avión aterrizando'],
    },
    '🪂': {
        name: 'paracaídas',
        keywords: ['ala delta', 'paracaidismo', 'paravela', 'volar', 'paracaídas'],
    },
    '💺': {
        name: 'asiento',
        keywords: ['asiento', 'plaza', 'silla', 'asiento de transporte'],
    },
    '🚁': {
        name: 'helicóptero',
        keywords: ['aspas', 'rotores', 'vehículo', 'volar', 'helicóptero'],
    },
    '🚟': {
        name: 'tren_colgante',
        keywords: ['ferrocarril', 'suspensión', 'vehículo', 'ferrocarril de suspensión'],
    },
    '🚠': {
        name: 'funicular_de_montaña',
        keywords: ['cable', 'funicular', 'montaña', 'teleférico', 'vehículo', 'teleférico de montaña'],
    },
    '🚡': {
        name: 'teleférico',
        keywords: ['aéreo', 'tranvía', 'vehículo', 'teleférico'],
    },
    '🛰️': {
        name: 'satélite',
        keywords: ['espacio', 'vehículo', 'satélite'],
    },
    '🚀': {
        name: 'cohete',
        keywords: ['espacio', 'vehículo', 'cohete'],
    },
    '🛸': {
        name: 'platillo_volante',
        keywords: ['ovni', 'platillo volante'],
    },
    '🛎️': {
        name: 'timbre_de_hotel',
        keywords: ['botones', 'campanilla', 'hotel', 'timbre', 'timbre de hotel'],
    },
    '🧳': {
        name: 'equipaje',
        keywords: ['maleta', 'viajar', 'equipaje'],
    },
    '⌛': {
        name: 'reloj_de_arena',
        keywords: ['arena', 'reloj', 'temporizador', 'reloj de arena sin tiempo'],
    },
    '⏳': {
        name: 'reloj_de_arena_en_marcha',
        keywords: ['reloj con arena cayendo', 'temporizador', 'reloj de arena con tiempo'],
    },
    '⌚': {
        name: 'reloj',
        keywords: ['reloj'],
    },
    '⏰': {
        name: 'reloj_de_alarma',
        keywords: ['alarma', 'despertador', 'reloj'],
    },
    '⏱️': {
        name: 'cronómetro',
        keywords: ['reloj', 'cronómetro'],
    },
    '⏲️': {
        name: 'temporizador',
        keywords: ['reloj', 'temporizador'],
    },
    '🕰️': {
        name: 'reloj_de_repisa',
        keywords: ['reloj', 'sobremesa', 'reloj de sobremesa'],
    },
    '🕛': {
        name: 'reloj12',
        keywords: ['12:00', 'doce', 'reloj', '12 en punto'],
    },
    '🕧': {
        name: 'reloj1230',
        keywords: ['12:30', 'reloj', 'doce y media'],
    },
    '🕐': {
        name: 'reloj1',
        keywords: ['reloj', 'una', '1 en punto  1:00'],
    },
    '🕜': {
        name: 'reloj130',
        keywords: ['1:30', 'reloj', 'una y media'],
    },
    '🕑': {
        name: 'reloj2',
        keywords: ['2:00', 'dos', 'reloj', '2 en punto'],
    },
    '🕝': {
        name: 'reloj230',
        keywords: ['2:30', 'reloj', 'dos y media'],
    },
    '🕒': {
        name: 'reloj3',
        keywords: ['3:00', 'reloj', 'tres', '3 en punto'],
    },
    '🕞': {
        name: 'reloj330',
        keywords: ['3:30', 'reloj', 'tres y media'],
    },
    '🕓': {
        name: 'reloj4',
        keywords: ['4:00', 'cuatro', 'reloj', '4 en punto'],
    },
    '🕟': {
        name: 'reloj430',
        keywords: ['4:30', 'reloj', 'cuatro y media'],
    },
    '🕔': {
        name: 'reloj5',
        keywords: ['5:00', 'cinco', 'reloj', '5 en punto'],
    },
    '🕠': {
        name: 'reloj530',
        keywords: ['5:30', 'reloj', 'cinco y media'],
    },
    '🕕': {
        name: 'reloj6',
        keywords: ['6:00', 'reloj', 'seis', '6 en punto'],
    },
    '🕡': {
        name: 'reloj630',
        keywords: ['6:30', 'reloj', 'seis y media'],
    },
    '🕖': {
        name: 'reloj7',
        keywords: ['7:00', 'reloj', 'siete', '7 en punto'],
    },
    '🕢': {
        name: 'reloj730',
        keywords: ['7:30', 'reloj', 'siete y media'],
    },
    '🕗': {
        name: 'reloj8',
        keywords: ['8:00', 'ocho', 'reloj', '8 en punto'],
    },
    '🕣': {
        name: 'reloj830',
        keywords: ['8:30', 'reloj', 'ocho y media'],
    },
    '🕘': {
        name: 'reloj9',
        keywords: ['9:00', 'nueve', 'reloj', '9 en punto'],
    },
    '🕤': {
        name: 'reloj930',
        keywords: ['9:30', 'reloj', 'nueve y media'],
    },
    '🕙': {
        name: 'reloj10',
        keywords: ['10:00', 'diez', 'reloj', '10 en punto'],
    },
    '🕥': {
        name: 'reloj1030',
        keywords: ['10:30', 'reloj', 'diez y media'],
    },
    '🕚': {
        name: 'reloj11',
        keywords: ['11:00', 'once', 'reloj', '11 en punto'],
    },
    '🕦': {
        name: 'reloj1130',
        keywords: ['11:30', 'reloj', 'once y media'],
    },
    '🌑': {
        name: 'luna_nueva',
        keywords: ['luna', 'oscuridad', 'luna nueva'],
    },
    '🌒': {
        name: 'luna_nueva_visible',
        keywords: ['creciente', 'cuarto', 'espacio', 'luna'],
    },
    '🌓': {
        name: 'luna_en_cuarto_creciente',
        keywords: ['creciente', 'cuarto', 'espacio', 'luna', 'luna en cuarto creciente'],
    },
    '🌔': {
        name: 'luna',
        keywords: ['creciente', 'gibosa', 'luna'],
    },
    '🌕': {
        name: 'luna_llena',
        keywords: ['llena', 'luna', 'plenilunio'],
    },
    '🌖': {
        name: 'luna_gibosa_menguante',
        keywords: ['gibosa', 'luna', 'menguante'],
    },
    '🌗': {
        name: 'luna_en_cuarto_menguante',
        keywords: ['cuarto', 'luna', 'menguante', 'luna en cuarto menguante'],
    },
    '🌘': {
        name: 'luna_menguante',
        keywords: ['luna', 'menguante'],
    },
    '🌙': {
        name: 'luna_creciente',
        keywords: ['creciente', 'espacio', 'luna'],
    },
    '🌚': {
        name: 'luna_nueva_con_cara',
        keywords: ['cara', 'espacio', 'luna', 'luna nueva con cara'],
    },
    '🌛': {
        name: 'luna_en_cuarto_creciente_con_cara',
        keywords: ['cara', 'creciente', 'cuarto', 'espacio', 'luna', 'luna de cuarto creciente con cara'],
    },
    '🌜': {
        name: 'luna_en_cuarto_menguante_con_cara',
        keywords: ['cara', 'creciente', 'cuarto', 'espacio', 'luna', 'luna de cuarto menguante con cara'],
    },
    '🌡️': {
        name: 'termómetro',
        keywords: ['temperatura', 'termómetro'],
    },
    '☀️': {
        name: 'soleado',
        keywords: ['espacio', 'rayos', 'soleado', 'sol'],
    },
    '🌝': {
        name: 'luna_llena_con_cara',
        keywords: ['cara', 'llena', 'luna', 'luna llena con cara'],
    },
    '🌞': {
        name: 'sol_con_cara',
        keywords: ['brillante', 'cara', 'sol', 'sol con cara'],
    },
    '🪐': {
        name: 'planeta_con_anillos',
        keywords: ['saturnino', 'saturno', 'planeta con anillos'],
    },
    '⭐': {
        name: 'estrella',
        keywords: ['estelar  estrella'],
    },
    '🌟': {
        name: 'estrella2',
        keywords: ['brillante', 'estrella', 'resplandeciente'],
    },
    '🌠': {
        name: 'estrellas',
        keywords: ['estrella', 'lluvia', 'estrella fugaz'],
    },
    '🌌': {
        name: 'vía_láctea',
        keywords: ['espacio', 'galaxia', 'vía láctea', 'Vía Láctea'],
    },
    '☁️': {
        name: 'nube',
        keywords: ['tiempo', 'nube'],
    },
    '⛅': {
        name: 'parcialmente_soleado',
        keywords: ['nube', 'sol', 'sol con nubes', 'sol detrás de una nube'],
    },
    '⛈️': {
        name: 'nube_de_truenos_y_lluvia',
        keywords: ['lluvia', 'nube', 'trueno', 'nube con rayo y lluvia'],
    },
    '🌤️': {
        name: 'casi_todo_soleado',
        keywords: ['nube', 'sol', 'sol detrás de una nube pequeña'],
    },
    '🌥️': {
        name: 'sol_con_nubes',
        keywords: ['nube', 'sol', 'sol detrás de una nube grande'],
    },
    '🌦️': {
        name: 'parcialmente_soleado_lluvioso',
        keywords: ['lluvia', 'nube', 'sol', 'sol detrás de una nube con lluvia'],
    },
    '🌧️': {
        name: 'nube_de_lluvia',
        keywords: ['lluvia', 'nube', 'nube con lluvia'],
    },
    '🌨️': {
        name: 'nube_de_nieve',
        keywords: ['frío', 'nieve', 'nube', 'nube con nieve'],
    },
    '🌩️': {
        name: 'relámpago',
        keywords: ['nube', 'rayo', 'nube con rayo'],
    },
    '🌪️': {
        name: 'tornado',
        keywords: ['nube', 'torbellino', 'tornado'],
    },
    '🌫️': {
        name: 'niebla',
        keywords: ['nube', 'niebla'],
    },
    '🌬️': {
        name: 'cara_soplando_viento',
        keywords: ['cara', 'nube', 'soplar', 'viento', 'cara de viento'],
    },
    '🌀': {
        name: 'ciclón',
        keywords: ['mareo', 'tifón', 'tornado', 'ciclón'],
    },
    '🌈': {
        name: 'arco_iris',
        keywords: ['colores', 'lluvia', 'arcoíris'],
    },
    '🌂': {
        name: 'paraguas_cerrado',
        keywords: ['accesorios', 'lluvia', 'paraguas', 'paraguas cerrado'],
    },
    '☂️': {
        name: 'paraguas',
        keywords: ['lluvia', 'paraguas abierto', 'paraguas'],
    },
    '☔': {
        name: 'paraguas_con_gotas_de_lluvia',
        keywords: ['gotas', 'lluvia', 'paraguas', 'paraguas con gotas de lluvia'],
    },
    '⛱️': {
        name: 'paraguas_en_el_suelo',
        keywords: ['arena', 'sol', 'sombrilla', 'sombrilla en la arena'],
    },
    '⚡': {
        name: 'alto_voltaje',
        keywords: ['electricidad', 'peligro', 'peligro de alto voltaje', 'señal de alto voltaje', 'voltaje', 'alto voltaje'],
    },
    '❄️': {
        name: 'copo_de_nieve',
        keywords: ['frío', 'nieve', 'copo de nieve'],
    },
    '☃️': {
        name: 'muñeco_de_nieve',
        keywords: ['nieve', 'muñeco de nieve con nieve'],
    },
    '⛄': {
        name: 'muñeco_de_nieve_sin_nieve',
        keywords: ['muñeco de nieve sin nieve', 'nieve', 'muñeco de nieve'],
    },
    '☄️': {
        name: 'astro_cometa',
        keywords: ['cometa', 'espacio', 'meteorito'],
    },
    '🔥': {
        name: 'fuego',
        keywords: ['llama', 'fuego'],
    },
    '💧': {
        name: 'gota',
        keywords: ['agua', 'cómic', 'sudor', 'gota'],
    },
    '🌊': {
        name: 'océano',
        keywords: ['mar', 'océano', 'ola', 'ola de mar'],
    },
    '🎃': {
        name: 'calabaza_iluminada',
        keywords: ['calabaza', 'celebración', 'Halloween', 'linterna', 'calabaza de Halloween'],
    },
    '🎄': {
        name: 'árbol_de_navidad',
        keywords: ['abeto de Navidad', 'árbol', 'celebración', 'Navidad', 'árbol de Navidad'],
    },
    '🎆': {
        name: 'fuegos_artificiales',
        keywords: ['celebración', 'fuegos artificiales'],
    },
    '🎇': {
        name: 'bengala',
        keywords: ['celebración', 'fuegos artificiales', 'bengala'],
    },
    '🧨': {
        name: 'petardo',
        keywords: ['dinamita', 'explosivo', 'fuegos artificiales', 'petardo'],
    },
    '✨': {
        name: 'destellos',
        keywords: ['bengala', 'estrellas', '*', 'chispas'],
    },
    '🎈': {
        name: 'globo',
        keywords: ['celebración', 'globo'],
    },
    '🎉': {
        name: 'gorro_de_fiesta',
        keywords: ['celebración', 'confeti', 'fiesta', 'cañón de confeti'],
    },
    '🎊': {
        name: 'bola_de_confeti',
        keywords: ['celebración', 'confeti', 'bola de confeti'],
    },
    '🎋': {
        name: 'árbol_de_los_deseos',
        keywords: ['árbol', 'celebración', 'festividad', 'tanabata', 'árbol de tanabata'],
    },
    '🎍': {
        name: 'bambú',
        keywords: ['año nuevo japonés', 'bambú', 'celebración', 'decoración', 'kadomatsu', 'decoración de pino'],
    },
    '🎎': {
        name: 'muñecas',
        keywords: ['celebración', 'festival', 'hinamatsuri', 'muñecas', 'muñecas japonesas'],
    },
    '🎏': {
        name: 'banderas',
        keywords: ['banderín', 'carpa', 'celebración', 'koinobori', 'banderín de carpas'],
    },
    '🎐': {
        name: 'campanilla_de_viento',
        keywords: ['campanilla', 'furin', 'viento', 'campanilla de viento'],
    },
    '🎑': {
        name: 'espiga_de_arroz',
        keywords: ['celebración', 'contemplación', 'luna', 'tsukimi', 'ceremonia de contemplación de la luna'],
    },
    '🧧': {
        name: 'sobre_rojo',
        keywords: ['buena suerte', 'hóngbāo', 'lai see', 'regalo', 'sobre rojo'],
    },
    '🎀': {
        name: 'cinta',
        keywords: ['celebración', 'lazo'],
    },
    '🎁': {
        name: 'regalo',
        keywords: ['celebración', 'envoltorio', 'presente', 'regalo envuelto', 'regalo'],
    },
    '🎗️': {
        name: 'lazo_de_apoyo',
        keywords: ['conmemorativo', 'lazo'],
    },
    '🎟️': {
        name: 'boletos_de_entrada',
        keywords: ['acceso', 'admisión', 'entrada', 'evento', 'entradas'],
    },
    '🎫': {
        name: 'tique',
        keywords: ['acceso', 'admisión', 'tique'],
    },
    '🎖️': {
        name: 'medalla',
        keywords: ['celebración', 'medalla', 'militar'],
    },
    '🏆': {
        name: 'trofeo',
        keywords: ['premio', 'trofeo'],
    },
    '🏅': {
        name: 'medalla_deportiva',
        keywords: ['medalla', 'premio', 'medalla deportiva'],
    },
    '🥇': {
        name: 'medalla_de_oro',
        keywords: ['medalla', 'oro', 'primero', 'medalla de oro'],
    },
    '🥈': {
        name: 'medalla_de_plata',
        keywords: ['medalla', 'plata', 'segundo', 'medalla de plata'],
    },
    '🥉': {
        name: 'medalla_de_bronce',
        keywords: ['bronce', 'medalla', 'tercero', 'medalla de bronce'],
    },
    '⚽': {
        name: 'fútbol',
        keywords: ['balón', 'fútbol', 'balón de fútbol'],
    },
    '⚾': {
        name: 'béisbol',
        keywords: ['balón', 'baseball', 'pelota', 'béisbol'],
    },
    '🥎': {
        name: 'pelota_de_softball',
        keywords: ['bola', 'pelota', 'softball', 'pelota de softball'],
    },
    '🏀': {
        name: 'baloncesto',
        keywords: ['balón', 'canasta', 'deporte', 'balón de baloncesto'],
    },
    '🏐': {
        name: 'voleibol',
        keywords: ['balón', 'juego', 'pelota', 'voleibol', 'pelota de voleibol'],
    },
    '🏈': {
        name: 'balón_de_fútbol_americano',
        keywords: ['balón', 'deporte', 'fútbol americano', 'balón de fútbol americano'],
    },
    '🏉': {
        name: 'pelota_de_rugby',
        keywords: ['balón', 'deporte', 'rugby', 'balón de rugby'],
    },
    '🎾': {
        name: 'tenis',
        keywords: ['deporte', 'pelota', 'tenis', 'pelota de tenis'],
    },
    '🥏': {
        name: 'disco_volador',
        keywords: ['disco', 'frisbee', 'disco volador'],
    },
    '🎳': {
        name: 'bolos',
        keywords: ['bola', 'bola de bolos', 'juego', 'bolos'],
    },
    '🏏': {
        name: 'pelota_y_bate_de_cricket',
        keywords: ['juego', 'pelota', 'críquet'],
    },
    '🏑': {
        name: 'palo_y_pelota_de_hockey',
        keywords: ['hierba', 'hockey', 'juego', 'palo', 'pelota', 'hockey sobre hierba'],
    },
    '🏒': {
        name: 'palo_y_disco_de_hockey_sobre_hielo',
        keywords: ['disco', 'hielo', 'hockey', 'palo', 'hockey sobre hielo'],
    },
    '🥍': {
        name: 'lacrosse',
        keywords: ['bola', 'palo', 'pelota', 'raqueta', 'lacrosse'],
    },
    '🏓': {
        name: 'raqueta_y_pelota_de_tenis_de_mesa',
        keywords: ['juego', 'mesa', 'pelota', 'ping pong', 'tenis de mesa'],
    },
    '🏸': {
        name: 'raqueta_y_pluma_de_bádminton',
        keywords: ['pluma', 'raqueta', 'volante', 'bádminton'],
    },
    '🥊': {
        name: 'guante-boxeo',
        keywords: ['boxeo', 'deporte', 'guante', 'guante de boxeo'],
    },
    '🥋': {
        name: 'uniforme_artes_marciales',
        keywords: ['artes marciales', 'judo', 'kárate', 'taekwondo', 'uniforme de artes marciales'],
    },
    '🥅': {
        name: 'portería',
        keywords: ['deporte', 'red', 'portería'],
    },
    '⛳': {
        name: 'golf',
        keywords: ['banderín', 'golf', 'hoyo', 'banderín en hoyo'],
    },
    '⛸️': {
        name: 'patinaje_sobre_hielo',
        keywords: ['hielo', 'patín', 'patín de hielo'],
    },
    '🎣': {
        name: 'caña_de_pescar_y_pez',
        keywords: ['caña', 'entretenimiento', 'esparcimiento', 'pesca', 'pez', 'caña de pescar'],
    },
    '🤿': {
        name: 'máscara_de_buceo',
        keywords: ['bucear', 'buzo', 'esnórquel', 'máscara', 'tubo', 'máscara de buceo'],
    },
    '🎽': {
        name: 'camiseta_de_correr_con_franja',
        keywords: ['banda', 'camiseta con banda', 'camiseta de correr', 'deporte', 'camiseta sin mangas'],
    },
    '🎿': {
        name: 'esquí',
        keywords: ['esquí', 'esquíes', 'nieve', 'esquís'],
    },
    '🛷': {
        name: 'trineo',
        keywords: ['trineo'],
    },
    '🥌': {
        name: 'piedra_curling',
        keywords: ['juego', 'roca', 'piedra de curling'],
    },
    '🎯': {
        name: 'dardo',
        keywords: ['blanco', 'en el blanco', 'juego', 'diana'],
    },
    '🪀': {
        name: 'yoyó',
        keywords: ['dieta', 'efecto', 'fluctuar', 'juguete', 'yoyó'],
    },
    '🪁': {
        name: 'cometa',
        keywords: ['juguete', 'planear', 'viento', 'volar', 'cometa'],
    },
    '🎱': {
        name: 'bola_ocho',
        keywords: ['8', 'billar', 'bola ocho', 'juego', 'bola negra de billar'],
    },
    '🔮': {
        name: 'bola_de_cristal',
        keywords: ['adivinación', 'bola', 'buena fortuna', 'cristal', 'bola de cristal'],
    },
    '🪄': {
        name: 'varita_mágica',
        keywords: ['bruja', 'hechicero', 'magia', 'mago', 'prestidigitación', 'varita', 'varita mágica'],
    },
    '🧿': {
        name: 'ojo_turco',
        keywords: ['amuleto', 'mal de ojo', 'nazar', 'talismán', 'ojo turco'],
    },
    '🎮': {
        name: 'videojuego',
        keywords: ['juego', 'mando', 'videojuego', 'mando de videoconsola'],
    },
    '🕹️': {
        name: 'palanca_de_mando',
        keywords: ['juego', 'mando', 'palanca', 'videojuego', 'joystick'],
    },
    '🎰': {
        name: 'tragaperras',
        keywords: ['juego', 'máquina', 'máquina tragaperras'],
    },
    '🎲': {
        name: 'dado',
        keywords: ['juego', 'dado'],
    },
    '🧩': {
        name: 'pieza_de_puzle',
        keywords: ['conectar', 'pieza', 'pista', 'puzle', 'rompecabezas', 'pieza de puzle'],
    },
    '🧸': {
        name: 'osito_de_peluche',
        keywords: ['juguete', 'oso', 'peluche', 'osito de peluche'],
    },
    '🪅': {
        name: 'piñata',
        keywords: ['caballito', 'celebración', 'fiesta', 'piñata'],
    },
    '🪆': {
        name: 'muñeca_rusa',
        keywords: ['babushka', 'mamushka', 'matrioska', 'rusia', 'muñeca rusa'],
    },
    '♠️': {
        name: 'picas',
        keywords: ['carta', 'juego', 'palo', 'picas', 'palo de picas'],
    },
    '♥️': {
        name: 'corazones',
        keywords: ['carta', 'corazones', 'juego', 'palo', 'palo de corazones'],
    },
    '♦️': {
        name: 'diamantes',
        keywords: ['carta', 'diamantes', 'juego', 'palo', 'palo de diamantes'],
    },
    '♣️': {
        name: 'tréboles',
        keywords: ['carta', 'juego', 'palo', 'tréboles', 'palo de tréboles'],
    },
    '♟️': {
        name: 'peón_de_ajedrez',
        keywords: ['ajedrez', 'peón', 'peón de ajedrez'],
    },
    '🃏': {
        name: 'comodín_negro',
        keywords: ['joker', 'comodín'],
    },
    '🀄': {
        name: 'dragón_rojo',
        keywords: ['dragón rojo', 'juego', 'mahjong', 'dragón rojo de mahjong'],
    },
    '🎴': {
        name: 'cartas-de_juegos_de_asociación',
        keywords: ['carta', 'flor', 'hanafuda', 'naipe japonés', 'cartas de flores'],
    },
    '🎭': {
        name: 'artes_escénicas',
        keywords: ['actuación', 'arte', 'artes escénicas', 'entretenimiento', 'máscaras de teatro'],
    },
    '🖼️': {
        name: 'marco_con_foto',
        keywords: ['marco', 'museo', 'cuadro enmarcado'],
    },
    '🎨': {
        name: 'arte',
        keywords: ['arte', 'artista', 'paleta', 'pintura', 'paleta de pintor'],
    },
    '🧵': {
        name: 'hilo',
        keywords: ['aguja', 'carrete', 'coser', 'costura', 'hilo'],
    },
    '🪡': {
        name: 'aguja_de_coser',
        keywords: ['aguja', 'bordado', 'coser', 'hilar', 'punto', 'tejer', 'aguja de coser'],
    },
    '🧶': {
        name: 'ovillo',
        keywords: ['bola', 'croché', 'punto', 'tejer', 'ovillo'],
    },
    '🪢': {
        name: 'nudo',
        keywords: ['anudar', 'atar', 'enredar', 'trenzar', 'nudo'],
    },
    '👓': {
        name: 'gafas',
        keywords: ['accesorios', 'ojo', 'ropa', 'gafas'],
    },
    '🕶️': {
        name: 'gafas_de_sol_oscuras',
        keywords: ['gafas', 'ojo', 'oscuras', 'sol', 'gafas de sol'],
    },
    '🥽': {
        name: 'gafas_de_protección',
        keywords: ['gafas', 'nadar', 'protección ocular', 'soldar', 'gafas de protección'],
    },
    '🥼': {
        name: 'bata_de_laboratorio',
        keywords: ['científico', 'doctor', 'experimento', 'médico', 'bata de laboratorio'],
    },
    '🦺': {
        name: 'chaleco_de_seguridad',
        keywords: ['chaleco', 'emergencia', 'seguridad', 'chaleco de seguridad'],
    },
    '👔': {
        name: 'corbata',
        keywords: ['accesorio', 'ropa', 'corbata'],
    },
    '👕': {
        name: 'camiseta',
        keywords: ['ropa', 'camiseta'],
    },
    '👖': {
        name: 'vaqueros',
        keywords: ['pantalones', 'ropa', 'vaqueros'],
    },
    '🧣': {
        name: 'bufanda',
        keywords: ['abrigo', 'cuello', 'bufanda'],
    },
    '🧤': {
        name: 'guantes',
        keywords: ['mano', 'guantes'],
    },
    '🧥': {
        name: 'abrigo',
        keywords: ['chaquetón', 'abrigo'],
    },
    '🧦': {
        name: 'calcetines',
        keywords: ['pies', 'ropa', 'calcetines'],
    },
    '👗': {
        name: 'vestido',
        keywords: ['mujer', 'ropa', 'vestido'],
    },
    '👘': {
        name: 'kimono',
        keywords: ['japonés', 'ropa', 'kimono'],
    },
    '🥻': {
        name: 'sari',
        keywords: ['prenda', 'ropa', 'vestido', 'sari'],
    },
    '🩱': {
        name: 'traje_de_baño_de_una_pieza',
        keywords: ['bañador', 'traje de baño de una pieza'],
    },
    '🩲': {
        name: 'ropa_interior',
        keywords: ['bañador', 'bragas', 'braguitas', 'calzoncillos', 'slip', 'ropa interior'],
    },
    '🩳': {
        name: 'pantalones_cortos',
        keywords: ['bañador', 'bermudas', 'calzoncillos', 'ropa interior', 'shorts', 'pantalones cortos'],
    },
    '👙': {
        name: 'bikini',
        keywords: ['baño', 'playa', 'ropa', 'bikini'],
    },
    '👚': {
        name: 'ropa_de_mujer',
        keywords: ['blusa', 'camisa', 'femenina', 'ropa', 'ropa de mujer'],
    },
    '👛': {
        name: 'cartera_de_mano',
        keywords: ['accesorios', 'cartera', 'complementos', 'monedero'],
    },
    '👜': {
        name: 'bolso',
        keywords: ['accesorios', 'complementos', 'bolso'],
    },
    '👝': {
        name: 'cartera',
        keywords: ['accesorios', 'bolso', 'cartera', 'complementos', 'bolso de mano'],
    },
    '🛍️': {
        name: 'bolsas_de_la_compra',
        keywords: ['bolsa', 'compra', 'bolsas de compras'],
    },
    '🎒': {
        name: 'mochila',
        keywords: ['colegio', 'mochila', 'mochila escolar'],
    },
    '🩴': {
        name: 'chancla',
        keywords: ['chancla de dedo', 'chancleta', 'chinela', 'sandalia', 'chancla'],
    },
    '👞': {
        name: 'zapatos_de_hombre',
        keywords: ['calzado', 'hombre', 'ropa', 'zapato', 'zapato de hombre'],
    },
    '👟': {
        name: 'zapatilla_de_atletismo',
        keywords: ['calzado', 'correr', 'ropa', 'tenis', 'zapatilla deportiva'],
    },
    '🥾': {
        name: 'bota_de_senderismo',
        keywords: ['bota', 'camping', 'mochilero', 'senderismo', 'bota de senderismo'],
    },
    '🥿': {
        name: 'bailarina',
        keywords: ['calzado', 'zapato', 'bailarina'],
    },
    '👠': {
        name: 'tacón_de_aguja',
        keywords: ['mujer', 'tacón', 'zapato', 'zapato de tacón'],
    },
    '👡': {
        name: 'sandalia',
        keywords: ['calzado', 'mujer', 'ropa', 'sandalia', 'sandalia de mujer'],
    },
    '🩰': {
        name: 'zapatillas_de_ballet',
        keywords: ['bailar', 'balé', 'ballet', 'danza', 'zapatillas de ballet'],
    },
    '👢': {
        name: 'bota',
        keywords: ['bota', 'calzado', 'mujer', 'ropa', 'bota de mujer'],
    },
    '👑': {
        name: 'corona',
        keywords: ['accesorios', 'complementos', 'reina', 'rey', 'corona'],
    },
    '👒': {
        name: 'sombrero_de_mujer',
        keywords: ['accesorio', 'mujer', 'ropa', 'sombrero', 'sombrero de mujer'],
    },
    '🎩': {
        name: 'sombrero_de_copa',
        keywords: ['chistera', 'copa', 'ropa', 'sombrero', 'sombrero de copa'],
    },
    '🎓': {
        name: 'birrete',
        keywords: ['celebración', 'gorro', 'graduación', 'birrete'],
    },
    '🧢': {
        name: 'gorra',
        keywords: ['béisbol', 'gorra', 'visera', 'gorra con visera'],
    },
    '🪖': {
        name: 'casco_militar',
        keywords: ['casco', 'ejército', 'guerra', 'guerrero', 'soldado', 'casco militar'],
    },
    '⛑️': {
        name: 'casco_con_cruz_blanca',
        keywords: ['ayuda', 'cara', 'casco', 'cruz', 'casco con una cruz blanca'],
    },
    '📿': {
        name: 'rosario',
        keywords: ['collar', 'cuentas', 'religión', 'rosario'],
    },
    '💄': {
        name: 'lápiz_labial',
        keywords: ['barra', 'cosmética', 'labios', 'maquillaje', 'pintalabios'],
    },
    '💍': {
        name: 'anillo',
        keywords: ['diamante', 'anillo'],
    },
    '💎': {
        name: 'joya',
        keywords: ['diamante', 'gema', 'joya', 'piedra', 'preciosa'],
    },
    '🔇': {
        name: 'mudo',
        keywords: ['altavoz', 'altavoz con marca de cancelación', 'mute', 'silencio', 'altavoz silenciado'],
    },
    '🔈': {
        name: 'altavoz',
        keywords: ['volumen bajo', 'altavoz a volumen bajo'],
    },
    '🔉': {
        name: 'sonido',
        keywords: ['altavoz con volumen medio', 'medio', 'volumen medio', 'altavoz a volumen medio'],
    },
    '🔊': {
        name: 'sonido_agudo',
        keywords: ['altavoz', 'alto', 'volumen alto', 'altavoz a volumen alto'],
    },
    '📢': {
        name: 'altavoz_sonando',
        keywords: ['altavoz', 'comunicación', 'altavoz de mano'],
    },
    '📣': {
        name: 'mega',
        keywords: ['comunicación', 'megáfono'],
    },
    '📯': {
        name: 'corneta',
        keywords: ['corneta', 'posta', 'corneta de posta'],
    },
    '🔔': {
        name: 'campana',
        keywords: ['campana'],
    },
    '🔕': {
        name: 'prohibido_claxon',
        keywords: ['campana', 'cancelación', 'ruido', 'campana con signo de cancelación'],
    },
    '🎼': {
        name: 'partitura',
        keywords: ['música', 'partitura', 'pentagrama'],
    },
    '🎵': {
        name: 'nota_musical',
        keywords: ['música', 'nota', 'nota musical'],
    },
    '🎶': {
        name: 'notas',
        keywords: ['música', 'notas', 'notas musicales'],
    },
    '🎙️': {
        name: 'micrófono_de_estudio',
        keywords: ['estudio', 'micrófono', 'música', 'micrófono de estudio'],
    },
    '🎚️': {
        name: 'indicador_de_nivel',
        keywords: ['control', 'fader', 'volumen', 'control de volumen'],
    },
    '🎛️': {
        name: 'mandos_de_control',
        keywords: ['control', 'diales', 'música', 'potenciómetros', 'ruedas', 'ruedas de control'],
    },
    '🎤': {
        name: 'micrófono',
        keywords: ['entretenimiento', 'karaoke', 'micro', 'micrófono'],
    },
    '🎧': {
        name: 'auriculares',
        keywords: ['cascos', 'auricular'],
    },
    '📻': {
        name: 'radio',
        keywords: ['radio'],
    },
    '🎷': {
        name: 'saxofón',
        keywords: ['instrumento', 'instrumento musical', 'música', 'saxo', 'saxofón'],
    },
    '🪗': {
        name: 'acordeón',
        keywords: ['concertina', 'acordeón'],
    },
    '🎸': {
        name: 'guitarra',
        keywords: ['instrumento', 'instrumento musical', 'música', 'guitarra'],
    },
    '🎹': {
        name: 'teclado_musical',
        keywords: ['instrumento', 'instrumento musical', 'música', 'teclado', 'piano', 'teclado musical'],
    },
    '🎺': {
        name: 'trompeta',
        keywords: ['instrumento', 'instrumento musical', 'música', 'trompeta'],
    },
    '🎻': {
        name: 'violín',
        keywords: ['instrumento', 'instrumento musical', 'música', 'violín'],
    },
    '🪕': {
        name: 'banjo',
        keywords: ['banyo', 'cuerda', 'instrumento', 'música', 'banjo'],
    },
    '🥁': {
        name: 'tambor_con_baquetas',
        keywords: ['baquetas', 'música', 'tambor'],
    },
    '🪘': {
        name: 'tamboril',
        keywords: ['conga', 'ritmo', 'tambor', 'tamboril'],
    },
    '📱': {
        name: 'iphone',
        keywords: ['celular', 'móvil', 'teléfono'],
    },
    '📲': {
        name: 'llamando',
        keywords: ['flecha', 'llamada', 'móvil', 'recibir', 'teléfono', 'móvil con una flecha'],
    },
    '☎️': {
        name: 'teléfono',
        keywords: ['teléfono'],
    },
    '📞': {
        name: 'receptor_de_teléfono',
        keywords: ['comunicación', 'teléfono', 'auricular de teléfono'],
    },
    '📟': {
        name: 'buscapersonas',
        keywords: ['comunicación', 'localizador', 'busca'],
    },
    '📠': {
        name: 'fax',
        keywords: ['comunicación', 'fax', 'máquina de fax'],
    },
    '🔋': {
        name: 'batería',
        keywords: ['batería', 'pila'],
    },
    '🔌': {
        name: 'enchufe_eléctrico',
        keywords: ['corriente', 'electricidad', 'eléctrico', 'enchufe'],
    },
    '💻': {
        name: 'ordenador',
        keywords: ['ordenador', 'pc', 'personal', 'ordenador portátil'],
    },
    '🖥️': {
        name: 'ordenador_de_sobremesa',
        keywords: ['ordenador', 'sobremesa', 'ordenador de sobremesa'],
    },
    '🖨️': {
        name: 'impresora',
        keywords: ['ordenador', 'impresora'],
    },
    '⌨️': {
        name: 'teclado',
        keywords: ['ordenador', 'teclado'],
    },
    '🖱️': {
        name: 'mouse_de_tres_botones',
        keywords: ['ordenador', 'ratón', 'ratón de ordenador'],
    },
    '🖲️': {
        name: 'bola_de_seguimiento',
        keywords: ['ordenador', 'trackball', 'bola de desplazamiento'],
    },
    '💽': {
        name: 'minidisc',
        keywords: ['disco', 'md', 'minidisc'],
    },
    '💾': {
        name: 'disquete',
        keywords: ['disco', 'disco de 3 1/2', 'disquete'],
    },
    '💿': {
        name: 'cd',
        keywords: ['cd', 'disco', 'disco óptico'],
    },
    '📀': {
        name: 'dvd',
        keywords: ['disco', 'dvd', 'disco DVD'],
    },
    '🧮': {
        name: 'ábaco',
        keywords: ['cálculo', 'contar', 'matemáticas', 'ábaco'],
    },
    '🎥': {
        name: 'cámara_de_cine',
        keywords: ['cámara', 'cine', 'entretenimiento', 'película', 'cámara de cine'],
    },
    '🎞️': {
        name: 'fotogramas_de_película',
        keywords: ['cine', 'fotograma', 'película', 'fotograma de película'],
    },
    '📽️': {
        name: 'proyector_de_cine',
        keywords: ['cine', 'película', 'proyector', 'proyector de cine'],
    },
    '🎬': {
        name: 'claqueta',
        keywords: ['cine', 'claqueta de cine', 'entretenimiento', 'película', 'claqueta'],
    },
    '📺': {
        name: 'televisión',
        keywords: ['tv', 'televisión'],
    },
    '📷': {
        name: 'cámara',
        keywords: ['cámara', 'cámara de fotos'],
    },
    '📸': {
        name: 'cámara_con_flash',
        keywords: ['cámara', 'flash', 'cámara con flash'],
    },
    '📹': {
        name: 'videocámara',
        keywords: ['cámara', 'vídeo', 'videocámara'],
    },
    '📼': {
        name: 'vhs',
        keywords: ['cinta', 'cinta de vídeo'],
    },
    '🔍': {
        name: 'lupa',
        keywords: ['buscar', 'lupa', 'lupa orientada hacia la izquierda'],
    },
    '🔎': {
        name: 'lupa_derecha',
        keywords: ['buscar', 'lupa', 'lupa orientada hacia la derecha'],
    },
    '🕯️': {
        name: 'vela',
        keywords: ['luz', 'vela'],
    },
    '💡': {
        name: 'bombilla',
        keywords: ['cómic', 'electricidad', 'idea', 'luz', 'bombilla'],
    },
    '🔦': {
        name: 'linterna',
        keywords: ['luz', 'linterna'],
    },
    '🏮': {
        name: 'farolillo_de_papel',
        keywords: ['izakaya', 'lámpara roja', 'linterna izakaya', 'linterna japonesa', 'restaurante', 'lámpara japonesa'],
    },
    '🪔': {
        name: 'lámpara_de_aceite',
        keywords: ['aceite', 'diya', 'lámpara', 'lámpara de aceite'],
    },
    '📔': {
        name: 'cuaderno_con_tapa_decorada',
        keywords: ['cuaderno', 'decoración', 'tapa', 'cuaderno con tapa decorativa'],
    },
    '📕': {
        name: 'libro_cerrado',
        keywords: ['cerrado', 'libro'],
    },
    '📖': {
        name: 'libro',
        keywords: ['abierto', 'libro'],
    },
    '📗': {
        name: 'libro_verde',
        keywords: ['libro', 'verde'],
    },
    '📘': {
        name: 'libro_azul',
        keywords: ['azul', 'libro'],
    },
    '📙': {
        name: 'libro_naranja',
        keywords: ['libro', 'naranja'],
    },
    '📚': {
        name: 'libros',
        keywords: ['libro', 'libros'],
    },
    '📓': {
        name: 'cuaderno',
        keywords: ['libreta', 'cuaderno'],
    },
    '📒': {
        name: 'registro',
        keywords: ['cuaderno', 'libro de contabilidad'],
    },
    '📃': {
        name: 'página_doblada_por_abajo',
        keywords: ['documento', 'página', 'página doblada'],
    },
    '📜': {
        name: 'pergamino',
        keywords: ['pergamino de papel', 'pergamino'],
    },
    '📄': {
        name: 'página_boca_arriba',
        keywords: ['anverso', 'documento', 'página', 'página hacia arriba'],
    },
    '📰': {
        name: 'periódico',
        keywords: ['diario', 'periódico'],
    },
    '🗞️': {
        name: 'periódico_enrollado',
        keywords: ['noticias', 'papel', 'periódico', 'periódico enrollado'],
    },
    '📑': {
        name: 'pestañas_de_marcadores',
        keywords: ['pestañas', 'marcadores'],
    },
    '🔖': {
        name: 'marcador',
        keywords: ['marcador', 'marcapáginas'],
    },
    '🏷️': {
        name: 'etiqueta',
        keywords: ['etiqueta'],
    },
    '💰': {
        name: 'bolsa_de_dinero',
        keywords: ['bolsa', 'bolsa de dólares', 'dinero', 'bolsa de dinero'],
    },
    '🪙': {
        name: 'moneda',
        keywords: ['dinero', 'metal', 'oro', 'plata', 'tesoro', 'moneda'],
    },
    '💴': {
        name: 'yen',
        keywords: ['billete', 'billete de banco', 'dinero', 'yen', 'billete de yen'],
    },
    '💵': {
        name: 'dólar',
        keywords: ['billete', 'billete de banco', 'dinero', 'dólar', 'billete de dólar'],
    },
    '💶': {
        name: 'euro',
        keywords: ['billete', 'billete de banco', 'dinero', 'euro', 'billete de euro'],
    },
    '💷': {
        name: 'libra_esterlina',
        keywords: ['billete de banco', 'dinero', 'libra', 'billete de libra'],
    },
    '💸': {
        name: 'dinero_con_alas',
        keywords: ['billete', 'billete de banco', 'dinero', 'dinero con alas', 'billete con alas'],
    },
    '💳': {
        name: 'tarjeta_de_crédito',
        keywords: ['crédito', 'tarjeta', 'tarjeta de crédito'],
    },
    '🧾': {
        name: 'recibo',
        keywords: ['contabilidad', 'prueba', 'teneduría de libros', 'testimonio', 'recibo'],
    },
    '💹': {
        name: 'gráfico',
        keywords: ['alza', 'mercado', 'mercado alcista', 'tabla', 'mercado al alza'],
    },
    '✉️': {
        name: 'correo',
        keywords: ['carta', 'correo', 'sobre'],
    },
    '📧': {
        name: 'correo_electrónico',
        keywords: ['comunicación', 'correo', 'sobre', 'correo electrónico'],
    },
    '📨': {
        name: 'correo_entrante',
        keywords: ['carta', 'comunicación', 'correo', 'correo electrónico', 'sobre', 'sobre entrante'],
    },
    '📩': {
        name: 'sobre_con_flecha',
        keywords: ['carta', 'comunicación', 'correo', 'correo electrónico', 'sobre', 'sobre con flecha'],
    },
    '📤': {
        name: 'bandeja_de_salida',
        keywords: ['bandeja', 'comunicación', 'correo', 'enviado', 'salida', 'bandeja de salida'],
    },
    '📥': {
        name: 'bandeja_de_entrada',
        keywords: ['bandeja', 'comunicación', 'correo', 'entrada', 'recibido', 'bandeja de entrada'],
    },
    '📦': {
        name: 'paquete',
        keywords: ['caja', 'paquete'],
    },
    '📫': {
        name: 'buzón',
        keywords: ['bandera', 'buzón', 'buzón cerrado', 'con contenido', 'buzón cerrado con la bandera levantada'],
    },
    '📪': {
        name: 'buzón_cerrado',
        keywords: ['bandera', 'buzón', 'buzón cerrado', 'vacío', 'buzón cerrado con la bandera bajada'],
    },
    '📬': {
        name: 'buzón_con_cartas',
        keywords: ['bandera', 'buzón', 'buzón abierto', 'con contenido', 'buzón abierto con la bandera levantada'],
    },
    '📭': {
        name: 'buzón_sin_cartas',
        keywords: ['bandera', 'buzón', 'buzón abierto', 'vacío', 'buzón abierto con la bandera bajada'],
    },
    '📮': {
        name: 'carta_al_buzón',
        keywords: ['cartas', 'correo', 'buzón'],
    },
    '🗳️': {
        name: 'urna_con_papeleta',
        keywords: ['papeleta', 'urna', 'voto', 'urna con papeleta'],
    },
    '✏️': {
        name: 'lápiz2',
        keywords: ['escolar', 'escribir', 'lapicero', 'lápiz'],
    },
    '✒️': {
        name: 'plumín_negro',
        keywords: ['bolígrafo', 'escribir', 'pluma', 'tinta', 'pluma negra'],
    },
    '🖋️': {
        name: 'pluma_estilográfica_abajo_a_la_izquierda',
        keywords: ['bolígrafo', 'escribir', 'pluma', 'tinta', 'estilográfica'],
    },
    '🖊️': {
        name: 'bolígrafo_abajo_a_la_izquierda',
        keywords: ['boli', 'escribir', 'bolígrafo'],
    },
    '🖌️': {
        name: 'pincel_abajo_a_la_izquierda',
        keywords: ['pintar', 'pincel'],
    },
    '🖍️': {
        name: 'lápiz_abajo_a_la_izquierda',
        keywords: ['cera', 'lápiz', 'lápiz de cera'],
    },
    '📝': {
        name: 'nota',
        keywords: ['comunicación', 'cuaderno de notas'],
    },
    '💼': {
        name: 'maletín',
        keywords: ['cartera', 'documentos', 'maletín'],
    },
    '📁': {
        name: 'carpeta_de_archivos',
        keywords: ['archivo', 'carpeta', 'carpeta de archivos'],
    },
    '📂': {
        name: 'carpeta_abierta',
        keywords: ['abierta', 'archivo', 'carpeta', 'carpeta de archivos abierta'],
    },
    '🗂️': {
        name: 'separadores_de_índice_de_tarjetas',
        keywords: ['fichas', 'fichero', 'separador', 'separador de fichas'],
    },
    '📅': {
        name: 'fecha',
        keywords: ['fecha', 'calendario'],
    },
    '📆': {
        name: 'calendario',
        keywords: ['calendario', 'fecha', 'calendario recortable'],
    },
    '🗒️': {
        name: 'cuaderno_de_espiral',
        keywords: ['bloc', 'cuaderno', 'espiral', 'notas', 'bloc de notas de espiral'],
    },
    '🗓️': {
        name: 'calendario_de_sobremesa',
        keywords: ['calendario', 'espiral', 'calendario de espiral'],
    },
    '📇': {
        name: 'índice_de_tarjetas',
        keywords: ['cartera', 'ficha', 'organizador', 'tarjetas', 'organizador de fichas'],
    },
    '📈': {
        name: 'gráfico_con_tendencia_ascendente',
        keywords: ['ascendente', 'gráfica', 'gráfico', 'tendencia ascendente', 'gráfica de evolución ascendente'],
    },
    '📉': {
        name: 'gráfico_con_tendencia_descendente',
        keywords: ['descendente', 'gráfica', 'gráfico', 'tendencia descendente', 'gráfica de evolución descendente'],
    },
    '📊': {
        name: 'gráfico_de_barras',
        keywords: ['barras', 'gráfico', 'gráfico de barras'],
    },
    '📋': {
        name: 'portapapeles',
        keywords: ['papeles', 'pinza', 'tabla', 'portapapeles'],
    },
    '📌': {
        name: 'chincheta',
        keywords: ['tachuela', 'chincheta'],
    },
    '📍': {
        name: 'tachuela_redonda',
        keywords: ['chincheta', 'chincheta redonda'],
    },
    '📎': {
        name: 'clip',
        keywords: ['clip'],
    },
    '🖇️': {
        name: 'clips_unidos',
        keywords: ['clips', 'unidos', 'unión'],
    },
    '📏': {
        name: 'regla',
        keywords: ['regla'],
    },
    '📐': {
        name: 'escuadra',
        keywords: ['regla', 'regla triangular', 'triángulo', 'escuadra'],
    },
    '✂️': {
        name: 'tijeras',
        keywords: ['cortar', 'herramienta', 'tijeras'],
    },
    '🗃️': {
        name: 'fichero_de_tarjetas',
        keywords: ['archivador', 'archivo', 'caja', 'archivador de tarjetas'],
    },
    '🗄️': {
        name: 'archivador',
        keywords: ['archivos', 'oficina', 'organizador', 'archivador'],
    },
    '🗑️': {
        name: 'papelera',
        keywords: ['basura', 'cubo', 'papelera'],
    },
    '🔒': {
        name: 'candado',
        keywords: ['candado', 'cerrado', 'cerrar'],
    },
    '🔓': {
        name: 'activar',
        keywords: ['abierto', 'abrir', 'candado'],
    },
    '🔏': {
        name: 'candado_con_pluma_de_tinta',
        keywords: ['candado', 'cerrado', 'estilográfica', 'pluma', 'privacidad', 'candado con pluma estilográfica'],
    },
    '🔐': {
        name: 'candado_cerrado_con_llave',
        keywords: ['candado', 'cerrado', 'llave', 'seguro', 'candado cerrado y llave'],
    },
    '🔑': {
        name: 'llave',
        keywords: ['contraseña', 'llave'],
    },
    '🗝️': {
        name: 'llave_vieja',
        keywords: ['antigua', 'llave'],
    },
    '🔨': {
        name: 'martillo',
        keywords: ['herramienta', 'martillo'],
    },
    '🪓': {
        name: 'hacha',
        keywords: ['cortar', 'dividir', 'hachuela', 'madera', 'talar', 'hacha'],
    },
    '⛏️': {
        name: 'pico',
        keywords: ['herramienta', 'mina', 'pico'],
    },
    '⚒️': {
        name: 'martillo_y_pico',
        keywords: ['herramienta', 'martillo', 'pico', 'martillo y pico'],
    },
    '🛠️': {
        name: 'martillo_y_llave_inglesa',
        keywords: ['herramienta', 'llave inglesa', 'martillo', 'martillo y llave inglesa'],
    },
    '🗡️': {
        name: 'daga',
        keywords: ['arma', 'cuchillo', 'daga', 'puñal'],
    },
    '⚔️': {
        name: 'espadas_cruzadas',
        keywords: ['arma', 'cruzadas', 'espadas'],
    },
    '🔫': {
        name: 'pistola',
        keywords: ['agua', 'juguete', 'pistola', 'verano', 'pistola de agua'],
    },
    '🪃': {
        name: 'bumerán',
        keywords: ['boomerang', 'rebotar', 'bumerán'],
    },
    '🏹': {
        name: 'arco_y_flecha',
        keywords: ['arco', 'arquero', 'flecha', 'sagitario', 'zodiaco', 'arco y flecha'],
    },
    '🛡️': {
        name: 'escudo',
        keywords: ['defensa', 'escudo'],
    },
    '🪚': {
        name: 'sierra_de_carpintería',
        keywords: ['carpintería', 'carpintero', 'herramienta', 'sierra', 'talar', 'sierra de carpintería'],
    },
    '🔧': {
        name: 'llave_de_tuerca',
        keywords: ['herramienta', 'llave inglesa'],
    },
    '🪛': {
        name: 'destornillador',
        keywords: ['atornillador', 'herramienta', 'tornillo', 'destornillador'],
    },
    '🔩': {
        name: 'tuerca_y_perno',
        keywords: ['herramienta', 'tornillo', 'tuerca', 'tornillo y tuerca'],
    },
    '⚙️': {
        name: 'engranaje',
        keywords: ['herramienta', 'engranaje'],
    },
    '🗜️': {
        name: 'compresión',
        keywords: ['herramienta', 'tornillo', 'tornillo de banco'],
    },
    '⚖️': {
        name: 'balanza',
        keywords: ['justicia', 'libra', 'peso', 'zodiaco', 'balanza'],
    },
    '🦯': {
        name: 'bastón',
        keywords: ['accesibilidad', 'ceguera', 'ciega', 'ciego', 'invidente', 'bastón'],
    },
    '🔗': {
        name: 'eslabón',
        keywords: ['eslabón'],
    },
    '⛓️': {
        name: 'cadenas',
        keywords: ['cadena', 'cadenas'],
    },
    '🪝': {
        name: 'gancho',
        keywords: ['agarrar', 'anzuelo', 'atrapar', 'garfio', 'gancho'],
    },
    '🧰': {
        name: 'caja_de_herramientas',
        keywords: ['armario', 'herramienta', 'mecánico', 'caja de herramientas'],
    },
    '🧲': {
        name: 'imán',
        keywords: ['atracción', 'herradura', 'magnético', 'imán'],
    },
    '🪜': {
        name: 'escalera',
        keywords: ['escalar', 'escalerilla', 'escalón', 'peldaño', 'escalera'],
    },
    '⚗️': {
        name: 'alambique',
        keywords: ['herramienta', 'química', 'alambique'],
    },
    '🧪': {
        name: 'tubo_de_ensayo',
        keywords: ['ciencia', 'experimento', 'laboratorio', 'química', 'químico', 'tubo de ensayo'],
    },
    '🧫': {
        name: 'placa_de_petri',
        keywords: ['bacterias', 'biología', 'biólogo', 'cultivo', 'laboratorio', 'placa de petri'],
    },
    '🧬': {
        name: 'adn',
        keywords: ['biólogo', 'evolución', 'gen', 'genética', 'vida', 'adn'],
    },
    '🔬': {
        name: 'microscopio',
        keywords: ['instrumento', 'laboratorio', 'microscopio'],
    },
    '🔭': {
        name: 'telescopio',
        keywords: ['astronomía', 'instrumento', 'telescopio'],
    },
    '📡': {
        name: 'antena_de_satélite',
        keywords: ['antena', 'comunicación', 'satélite', 'antena de satélite'],
    },
    '💉': {
        name: 'jeringuilla',
        keywords: ['aguja', 'jeringa', 'medicina', 'médico', 'jeringuilla'],
    },
    '🩸': {
        name: 'gota_de_sangre',
        keywords: ['donación de sangre', 'donar sangre', 'herida', 'medicina', 'sangre', 'gota de sangre'],
    },
    '💊': {
        name: 'píldora',
        keywords: ['comprimido', 'medicina', 'médico', 'pastilla', 'píldora'],
    },
    '🩹': {
        name: 'tirita',
        keywords: ['apósito', 'tirita'],
    },
    '🩺': {
        name: 'estetoscopio',
        keywords: ['corazón', 'doctor', 'fonendoscopio', 'latido', 'medicina', 'médico', 'estetoscopio'],
    },
    '🚪': {
        name: 'puerta',
        keywords: ['puerta'],
    },
    '🛗': {
        name: 'ascensor',
        keywords: ['accesibilidad', 'elevador', 'montacargas', 'ascensor'],
    },
    '🪞': {
        name: 'espejo',
        keywords: ['espéculo', 'reflector', 'reflejo', 'espejo'],
    },
    '🪟': {
        name: 'ventana',
        keywords: ['abertura', 'apertura', 'cristal', 'marco', 'transparente', 'vista', 'ventana'],
    },
    '🛏️': {
        name: 'cama',
        keywords: ['dormir', 'hotel', 'cama'],
    },
    '🛋️': {
        name: 'sofá_y_lámpara',
        keywords: ['hotel', 'lámpara', 'sofá', 'sofá y lámpara'],
    },
    '🪑': {
        name: 'silla',
        keywords: ['asiento', 'sentarse', 'silla'],
    },
    '🚽': {
        name: 'baño',
        keywords: ['baño', 'váter', 'wc', 'inodoro'],
    },
    '🪠': {
        name: 'desatascador',
        keywords: ['fontanero', 'retrete', 'servicio', 'succión', 'desatascador'],
    },
    '🚿': {
        name: 'ducha',
        keywords: ['agua', 'baño', 'ducha'],
    },
    '🛁': {
        name: 'bañera',
        keywords: ['baño', 'bañera'],
    },
    '🪤': {
        name: 'ratonera',
        keywords: ['cebo', 'cepo', 'engañar', 'ratón', 'ratonera', 'trampa', 'trampa de ratones'],
    },
    '🪒': {
        name: 'cuchilla_de_afeitar',
        keywords: ['afeitado', 'afeitar', 'afilado', 'barbero', 'navaja', 'cuchilla de afeitar'],
    },
    '🧴': {
        name: 'bote_de_crema',
        keywords: ['champú', 'crema', 'hidratante', 'protector solar', 'bote de crema'],
    },
    '🧷': {
        name: 'imperdible',
        keywords: ['pañal', 'punk rock', 'imperdible'],
    },
    '🧹': {
        name: 'escoba',
        keywords: ['barrer', 'bruja', 'fregar', 'escoba'],
    },
    '🧺': {
        name: 'cesta',
        keywords: ['colada', 'cosecha', 'pícnic', 'cesta'],
    },
    '🧻': {
        name: 'rollo_de_papel',
        keywords: ['papel absorbente', 'papel higiénico', 'rollo de papel'],
    },
    '🪣': {
        name: 'cubo',
        keywords: ['balde', 'barreño', 'cuba', 'cubeta', 'cubo'],
    },
    '🧼': {
        name: 'jabón',
        keywords: ['bañarse', 'enjabonarse', 'jabonera', 'lavarse', 'pastilla', 'jabón'],
    },
    '🪥': {
        name: 'cepillo_de_dientes',
        keywords: ['cepillo', 'dental', 'higiene', 'limpio', 'servicio', 'cepillo de dientes'],
    },
    '🧽': {
        name: 'esponja',
        keywords: ['absorbente', 'limpiar', 'poroso', 'esponja'],
    },
    '🧯': {
        name: 'extintor',
        keywords: ['apagar', 'extinguir', 'incendio', 'extintor'],
    },
    '🛒': {
        name: 'carrito_de_compras',
        keywords: ['carrito', 'carro', 'compra', 'supermercado', 'carrito de la compra'],
    },
    '🚬': {
        name: 'fumando',
        keywords: ['cigarro', 'fumar', 'cigarrillo'],
    },
    '⚰️': {
        name: 'ataúd',
        keywords: ['muerte', 'ataúd'],
    },
    '🪦': {
        name: 'lápida',
        keywords: ['cementario', 'estela', 'sepulcro', 'tumba', 'lápida'],
    },
    '⚱️': {
        name: 'urna_funeraria',
        keywords: ['funeraria', 'muerte', 'urna'],
    },
    '🗿': {
        name: 'moái',
        keywords: ['estatua', 'moái', 'Pascua'],
    },
    '🪧': {
        name: 'letrero',
        keywords: ['anuncio', 'aviso', 'cartel', 'pancarta', 'poste', 'letrero'],
    },
    '🏧': {
        name: 'cajero_automático',
        keywords: ['atm', 'banco', 'cajero', 'señal de cajero automático'],
    },
    '🚮': {
        name: 'la_basura_en_su_lugar',
        keywords: ['basura', 'papelera', 'señal', 'tirar la basura en la papelera', 'señal de usar papelera'],
    },
    '🚰': {
        name: 'agua_potable',
        keywords: ['agua', 'potable'],
    },
    '♿': {
        name: 'silla_de_ruedas',
        keywords: ['acceso', 'señal', 'silla', 'silla de ruedas', 'símbolo', 'símbolo de silla de ruedas'],
    },
    '🚹': {
        name: 'baño_de_hombres',
        keywords: ['aseo de caballeros', 'baño', 'señal', 'señal con un hombre', 'servicio', 'aseo para hombres'],
    },
    '🚺': {
        name: 'baño_de_mujeres',
        keywords: ['aseo de señoras', 'baño', 'señal', 'señal con una mujer', 'servicio', 'señal de aseo para mujeres'],
    },
    '🚻': {
        name: 'signo_de_baño',
        keywords: ['aseos', 'servicios', 'wc', 'señal de aseos'],
    },
    '🚼': {
        name: 'símbolo_de_bebé',
        keywords: ['bebé', 'cambiar', 'lactancia', 'señal de bebé'],
    },
    '🚾': {
        name: 'wc',
        keywords: ['lavabo', 'servicios', 'WC', 'aseos'],
    },
    '🛂': {
        name: 'control_de_pasaportes',
        keywords: ['control', 'pasaportes', 'control de pasaportes'],
    },
    '🛃': {
        name: 'aduana',
        keywords: ['aduana'],
    },
    '🛄': {
        name: 'recogida_de_equipaje',
        keywords: ['equipaje', 'maleta', 'recogida de equipajes'],
    },
    '🛅': {
        name: 'consigna',
        keywords: ['depósito', 'equipaje', 'servicio de equipaje en depósito', 'consigna'],
    },
    '⚠️': {
        name: 'advertencia',
        keywords: ['cuidado', 'señal', 'advertencia'],
    },
    '🚸': {
        name: 'niños_cruzando',
        keywords: ['cruzando', 'niños', 'señal'],
    },
    '⛔': {
        name: 'prohibido_el_paso',
        keywords: ['no', 'prohibido', 'señal', 'señal de dirección prohibida', 'dirección prohibida'],
    },
    '🚫': {
        name: 'señal_de_prohibido_el_paso',
        keywords: ['entrar', 'no', 'pasar', 'prohibición', 'prohibido'],
    },
    '🚳': {
        name: 'prohibidas_bicicletas',
        keywords: ['bicicleta', 'prohibido', 'vehículo', 'bicicletas prohibidas'],
    },
    '🚭': {
        name: 'prohibido_fumar',
        keywords: ['fumar', 'no', 'prohibido', 'señal'],
    },
    '🚯': {
        name: 'no_tirar_basura',
        keywords: ['basura', 'prohibido', 'señal', 'señal de no tirar basura', 'prohibido tirar basura'],
    },
    '🚱': {
        name: 'agua_no_potable',
        keywords: ['agua', 'no potable', 'agua no potable'],
    },
    '🚷': {
        name: 'prohibido_el_paso_a_peatones',
        keywords: ['peatón', 'peatones', 'prohibido', 'señal', 'prohibido el paso de peatones'],
    },
    '📵': {
        name: 'prohibidos_teléfonos_móviles',
        keywords: ['móvil', 'no hacer llamadas', 'prohibido', 'teléfono', 'prohibido el uso de móviles'],
    },
    '🔞': {
        name: 'menor_de_edad',
        keywords: ['prohibido', 'prohibido para menores de 18 años', '18  no apto para menores', 'prohibido para menos de 18 años'],
    },
    '☢️': {
        name: 'señal_de_radioactividad',
        keywords: ['radiactividad', 'radioactividad', 'radioactivo', 'señal', 'radiactivo'],
    },
    '☣️': {
        name: 'símbolo_de_riesgo_biológico',
        keywords: ['peligro', 'señal', 'riesgo biológico'],
    },
    '⬆️': {
        name: 'flecha_hacia_arriba',
        keywords: ['dirección', 'flecha', 'flecha arriba', 'norte', 'flecha hacia arriba'],
    },
    '↗️': {
        name: 'flecha_hacia_arriba_a_la_derecha',
        keywords: ['arriba', 'derecha', 'dirección', 'flecha', 'noreste', 'flecha hacia la esquina superior derecha'],
    },
    '➡️': {
        name: 'flecha_a_la_derecha',
        keywords: ['derecha', 'dirección', 'este', 'flecha', 'flecha hacia la derecha'],
    },
    '↘️': {
        name: 'flecha_abajo_a_la_derecha',
        keywords: ['abajo', 'derecha', 'dirección', 'flecha', 'sudeste', 'flecha hacia la esquina inferior derecha'],
    },
    '⬇️': {
        name: 'flecha_hacia_abajo',
        keywords: ['abajo', 'dirección', 'flecha', 'sur', 'flecha hacia abajo'],
    },
    '↙️': {
        name: 'flecha_abajo_a_la_iquierda',
        keywords: ['abajo', 'dirección', 'flecha', 'izquierda', 'suroeste', 'flecha hacia la esquina inferior izquierda'],
    },
    '⬅️': {
        name: 'flecha_a_la_izquierda',
        keywords: ['flecha', 'izquierda', 'oeste', 'flecha hacia la izquierda'],
    },
    '↖️': {
        name: 'flecha_hacia_arriba_a_la_izquierda',
        keywords: ['arriba', 'dirección', 'flecha', 'izquierda', 'noroeste', 'flecha hacia la esquina superior izquierda'],
    },
    '↕️': {
        name: 'flecha_hacia_arriba_y_hacia_abajo',
        keywords: ['abajo', 'arriba', 'dirección', 'flecha', 'flecha arriba y abajo'],
    },
    '↔️': {
        name: 'flecha_izquierda_derecha',
        keywords: ['derecha', 'dirección', 'flecha', 'izquierda', 'flecha izquierda y derecha'],
    },
    '↩️': {
        name: 'flecha_curvada_a_la_izquierda',
        keywords: ['curva', 'dirección', 'flecha', 'izquierda', 'flecha derecha curvándose a la izquierda'],
    },
    '↪️': {
        name: 'flecha_en_curva_a_la_derecha',
        keywords: ['curva', 'derecha', 'dirección', 'flecha', 'flecha izquierda curvándose a la derecha'],
    },
    '⤴️': {
        name: 'flecha_en_dirección_ascendente',
        keywords: ['arriba', 'curva', 'dirección', 'flecha', 'flecha derecha curvándose hacia arriba'],
    },
    '⤵️': {
        name: 'flecha_en_dirección_descendente',
        keywords: ['abajo', 'curva', 'dirección', 'flecha', 'flecha derecha curvándose hacia abajo'],
    },
    '🔃': {
        name: 'flechas_en_sentido_horario',
        keywords: ['flechas', 'flechas verticales sentido horario', 'horario', 'señal de recarga', 'flechas verticales en sentido horario'],
    },
    '🔄': {
        name: 'flechas_en_sentido_antihorario',
        keywords: ['dirección', 'flechas', 'señal de recarga', 'sentido antihorario', 'flechas en sentido antihorario'],
    },
    '🔙': {
        name: 'atrás',
        keywords: ['atrás', 'atrás con flecha izquierda', 'back', 'flecha', 'flecha a la izquierda', 'flecha BACK'],
    },
    '🔚': {
        name: 'fin',
        keywords: ['final', 'final con flecha izquierda', 'flecha', 'flecha a la izquierda', 'flecha END'],
    },
    '🔛': {
        name: 'encendido',
        keywords: ['flecha', 'on', 'señal', 'flecha de doble punta con la palabra "on" encima  flecha ON!'],
    },
    '🔜': {
        name: 'pronto',
        keywords: ['flecha', 'soon', 'soon con flecha a la derecha', 'flecha SOON'],
    },
    '🔝': {
        name: 'parte_superior',
        keywords: ['arriba', 'flecha hacia arriba', 'top', 'top con flecha hacia arriba', 'flecha TOP'],
    },
    '🛐': {
        name: 'lugar_de_culto',
        keywords: ['culto', 'religión', 'lugar de culto'],
    },
    '⚛️': {
        name: 'símbolo_del_átomo',
        keywords: ['átomo', 'símbolo', 'símbolo de átomo'],
    },
    '🕉️': {
        name: 'símbolo_de_om',
        keywords: ['hindú', 'religión', 'om'],
    },
    '✡️': {
        name: 'estrella_de_david',
        keywords: ['david', 'estrella', 'estrella de david', 'estrella de David', 'judaísmo', 'religión'],
    },
    '☸️': {
        name: 'rueda_del_dharma',
        keywords: ['budismo', 'dharma', 'religión', 'rueda', 'rueda del dharma'],
    },
    '☯️': {
        name: 'yin_yang',
        keywords: ['religión', 'taoísmo', 'yang', 'yin'],
    },
    '✝️': {
        name: 'cruz_latina',
        keywords: ['cristianismo', 'cruz', 'religión', 'cruz latina'],
    },
    '☦️': {
        name: 'cruz_ortodoxa',
        keywords: ['cruz', 'religión', 'cruz ortodoxa'],
    },
    '☪️': {
        name: 'estrella_y_luna_creciente',
        keywords: ['estrella', 'islam', 'luna', 'religión', 'media luna y estrella'],
    },
    '☮️': {
        name: 'símbolo_de_la_paz',
        keywords: ['paz', 'símbolo de la paz'],
    },
    '🕎': {
        name: 'candelabro_de_nueve_brazos',
        keywords: ['candelabro', 'religión', 'menorá'],
    },
    '🔯': {
        name: 'estrella_de_seis_puntas',
        keywords: ['adivinación', 'buena fortuna', 'estrella', 'seis puntas', 'estrella de seis puntas'],
    },
    '♈': {
        name: 'aries',
        keywords: ['aries', 'Aries', 'carnero', 'zodiaco'],
    },
    '♉': {
        name: 'tauro',
        keywords: ['buey', 'tauro', 'Tauro', 'toro', 'zodiaco'],
    },
    '♊': {
        name: 'géminis',
        keywords: ['gemelos', 'géminis', 'Géminis', 'zodiaco'],
    },
    '♋': {
        name: 'cáncer',
        keywords: ['cáncer', 'Cáncer', 'cangrejo', 'zodiaco'],
    },
    '♌': {
        name: 'leo',
        keywords: ['leo', 'Leo', 'león', 'zodiaco'],
    },
    '♍': {
        name: 'virgo',
        keywords: ['zodiaco', 'virgo  Virgo'],
    },
    '♎': {
        name: 'libra',
        keywords: ['balanza', 'escala', 'justicia', 'libra', 'Libra', 'zodiaco'],
    },
    '♏': {
        name: 'escorpio',
        keywords: ['escorpio', 'Escorpio', 'escorpión', 'zodiaco'],
    },
    '♐': {
        name: 'sagitario',
        keywords: ['arquero', 'sagitario', 'Sagitario', 'zodiaco'],
    },
    '♑': {
        name: 'capricornio',
        keywords: ['cabra', 'capricornio', 'Capricornio', 'zodiaco'],
    },
    '♒': {
        name: 'acuario',
        keywords: ['acuario', 'Acuario', 'agua', 'zodiaco'],
    },
    '♓': {
        name: 'piscis',
        keywords: ['pescado', 'pez', 'piscis', 'Piscis', 'zodiaco'],
    },
    '⛎': {
        name: 'ofiuco',
        keywords: ['ofiuco', 'Ofiuco', 'serpiente', 'zodiaco'],
    },
    '🔀': {
        name: 'flechas_cruzadas_hacia_la_derecha',
        keywords: ['cruzado', 'flechas', 'flechas entrecruzadas', 'reproducción aleatoria'],
    },
    '🔁': {
        name: 'repetir',
        keywords: ['flechas', 'repetición', 'repetir'],
    },
    '🔂': {
        name: 'repetir_una_vez',
        keywords: ['flechas', 'repetición', 'uno', 'repetir una vez'],
    },
    '▶️': {
        name: 'flecha_hacia_delante',
        keywords: ['botón de reproducción', 'flecha', 'triángulo', 'reproducir'],
    },
    '⏩': {
        name: 'avance_rápido',
        keywords: ['avanzar', 'doble', 'flecha', 'avance rápido'],
    },
    '⏭️': {
        name: 'triángulo_doble_negro_en_dirección_derecha_con_barra_vertical',
        keywords: ['raya vertical', 'siguiente', 'triángulos', 'pista siguiente'],
    },
    '⏯️': {
        name: 'triángulo_negro_en_dirección_derecha_con_doble_barra_vertical',
        keywords: ['pausa', 'reproducir', 'triángulo', 'reproducir o pausa'],
    },
    '◀️': {
        name: 'flecha_hacia_atrás',
        keywords: ['izquierda', 'triángulo', 'retroceso'],
    },
    '⏪': {
        name: 'rebobinar',
        keywords: ['flecha', 'flecha doble a la izquierda', 'izquierda', 'rebobinado', 'rebobinar', 'retroceso rápido'],
    },
    '⏮️': {
        name: 'triángulo_doble_negro_en_dirección_izquierda_con_barra_vertical',
        keywords: ['atrás', 'escena anterior', 'triángulo', 'pista anterior'],
    },
    '🔼': {
        name: 'flecha_pequeña_hacia_arriba',
        keywords: ['arriba', 'botón', 'botón triángulo hacia arriba', 'triángulo', 'triángulo hacia arriba'],
    },
    '⏫': {
        name: 'flecha_doble_hacia_arriba',
        keywords: ['arriba', 'flecha', 'triángulo doble hacia arriba'],
    },
    '🔽': {
        name: 'flecha_pequeña_hacia_abajo',
        keywords: ['abajo', 'botón', 'botón triángulo hacia abajo', 'triángulo', 'triángulo hacia abajo'],
    },
    '⏬': {
        name: 'flecha_doble_hacia_abajo',
        keywords: ['triángulo', 'triángulo doble abajo', 'triángulo doble hacia abajo'],
    },
    '⏸️': {
        name: 'doble_barra_vertical',
        keywords: ['barras', 'botón', 'vertical', 'pausa'],
    },
    '⏹️': {
        name: 'cuadrado_negro_para_detener',
        keywords: ['botón', 'cuadrado', 'parar', 'detener'],
    },
    '⏺️': {
        name: 'círculo_negro_de_grabación',
        keywords: ['botón', 'círculo', 'grabar'],
    },
    '⏏️': {
        name: 'expulsar',
        keywords: ['botón', 'expulsar'],
    },
    '🎦': {
        name: 'cine',
        keywords: ['entretenimiento', 'película', 'cine'],
    },
    '🔅': {
        name: 'poco_brillo',
        keywords: ['bajo', 'brillo', 'señal de brillo bajo', 'tenue'],
    },
    '🔆': {
        name: 'mucho_brillo',
        keywords: ['alto', 'brillante', 'brillo', 'señal de brillo alto'],
    },
    '📶': {
        name: 'barras_de_recepción_de_señal',
        keywords: ['antena', 'celular', 'móvil', 'señal', 'teléfono', 'barras de cobertura'],
    },
    '📳': {
        name: 'modo_vibración',
        keywords: ['móvil', 'teléfono', 'teléfono celular', 'vibración', 'modo vibración'],
    },
    '📴': {
        name: 'móvil_desconectado',
        keywords: ['apagado', 'móvil', 'teléfono', 'teléfono celular'],
    },
    '♀️': {
        name: 'signo_femenino',
        keywords: ['mujer', 'signo', 'símbolo', 'signo femenino'],
    },
    '♂️': {
        name: 'signo_masculino',
        keywords: ['hombre', 'signo', 'símbolo', 'signo masculino'],
    },
    '⚧️': {
        name: 'símbolo_de_transgénero',
        keywords: ['transgénero', 'símbolo de transgénero'],
    },
    '✖️': {
        name: 'signo_de_multiplicación_grueso',
        keywords: ['cancelar', 'marca', 'prohibido', 'signo de multiplicación', '×', 'multiplicación', 'x'],
    },
    '➕': {
        name: 'signo_de_suma_grueso',
        keywords: ['signo', 'suma', '+  más'],
    },
    '➖': {
        name: 'signo_de_resta_grueso',
        keywords: ['−', 'resta', 'signo', '-', 'menos'],
    },
    '➗': {
        name: 'signo_de_división_grueso',
        keywords: ['÷', 'signo', 'signo de división', 'división'],
    },
    '♾️': {
        name: 'infinito',
        keywords: ['ilimitado', 'siempre', 'universal', 'infinito'],
    },
    '‼️': {
        name: 'bangbang',
        keywords: ['exclamación', 'puntuación', 'sorpresa', '!!', 'exclamación doble'],
    },
    '⁉️': {
        name: 'signos_de_interrogación_y_exclamación',
        keywords: ['exclamación', 'interrogación', '!  !?  ?', 'exclamación e interrogación'],
    },
    '❓': {
        name: 'signo_de_interrogación_rojo',
        keywords: ['interrogación', 'pregunta', 'puntuación', 'signo de interrogación', '?', 'interrogación roja'],
    },
    '❔': {
        name: 'signo_de_interrogación_gris',
        keywords: ['interrogación', 'pregunta', 'puntuación', '?', 'interrogación blanca'],
    },
    '❕': {
        name: 'signo_de_exclamación_gris',
        keywords: ['exclamación', 'puntuación', '!', 'exclamación blanca'],
    },
    '❗': {
        name: 'exclamación',
        keywords: ['exclamación', 'puntuación', 'signo de exclamación', '!', 'exclamación roja'],
    },
    '〰️': {
        name: 'guion_ondulante',
        keywords: ['guion', 'marca de sonido largo', 'ondulado'],
    },
    '💱': {
        name: 'cambio_de_divisas',
        keywords: ['cambio', 'dinero', 'divisa', 'moneda', 'cambio de divisas'],
    },
    '💲': {
        name: 'símbolo_de_dólar_grueso',
        keywords: ['dinero', 'dólar', 'símbolo', 'símbolo de dólar'],
    },
    '⚕️': {
        name: 'símbolo_médico',
        keywords: ['asclepio', 'esculapio', 'medicina', 'serpiente', 'símbolo de medicina'],
    },
    '♻️': {
        name: 'reciclar',
        keywords: ['reciclaje', 'reciclar', 'señal', 'símbolo universal de reciclaje sólido', 'universal', 'símbolo de reciclaje'],
    },
    '⚜️': {
        name: 'flor_de_lis',
        keywords: ['flor', 'lis', 'flor de lis'],
    },
    '🔱': {
        name: 'tridente',
        keywords: ['ancla', 'emblema', 'tridente', 'emblema de tridente'],
    },
    '📛': {
        name: 'chapa_identificativa',
        keywords: ['etiqueta', 'nombre', 'etiqueta identificativa'],
    },
    '🔰': {
        name: 'principiante',
        keywords: ['amarillo', 'japonés', 'principiante', 'verde', 'símbolo japonés para principiante'],
    },
    '⭕': {
        name: 'o',
        keywords: ['aro', 'círculo', 'o', 'rojo', 'círculo rojo hueco'],
    },
    '✅': {
        name: 'marca_de_verificación_blanca',
        keywords: ['✓', 'botón', 'marca', 'selección', 'verificación', 'botón de marca de verificación'],
    },
    '☑️': {
        name: 'casilla_con_marca_de_verificación',
        keywords: ['✓', 'casilla', 'marca', 'selección', 'verificación', 'casilla con marca de verificación'],
    },
    '✔️': {
        name: 'marca_de_verificación_gruesa',
        keywords: ['✓', 'marca', 'selección', 'verificación', 'marca de verificación'],
    },
    '❌': {
        name: 'x',
        keywords: ['cancelar', 'cruz', 'marca de tachado', 'tachar', '×', 'marca de cruz', 'x'],
    },
    '❎': {
        name: 'cruz_negativa_enmarcada',
        keywords: ['casilla', 'cruz', 'marca', '×  botón con marca de cruz', 'x'],
    },
    '➰': {
        name: 'lazada',
        keywords: ['giro', 'tirabuzón', 'bucle'],
    },
    '➿': {
        name: 'lazo',
        keywords: ['bucle', 'doble'],
    },
    '〽️': {
        name: 'signo_de_inicio_de_canción',
        keywords: ['alternancia', 'marca', 'marca de alternancia'],
    },
    '✳️': {
        name: 'asterisco_de_ocho_puntas',
        keywords: ['asterisco', '*', 'asterisco de ocho puntas'],
    },
    '✴️': {
        name: 'estrella_negra_de_ocho_puntas',
        keywords: ['estrella', '*', 'estrella de ocho puntas'],
    },
    '❇️': {
        name: 'destello',
        keywords: ['*  chispa'],
    },
    '©️': {
        name: 'derechos_de_autor',
        keywords: ['c', 'símbolo', 'copyright'],
    },
    '®️': {
        name: 'registrado',
        keywords: ['r', 'símbolo de marca registrada', 'marca registrada'],
    },
    '™️': {
        name: 'tm',
        keywords: ['marca comercial', 'símbolo de marca comercial'],
    },
    '#️⃣': {
        name: 'almohadilla',
        keywords: ['Teclas'],
    },
    '*️⃣': {
        name: 'asterisco_enmarcado',
        keywords: ['Teclas'],
    },
    '0️⃣': {
        name: 'cero',
        keywords: ['Teclas'],
    },
    '1️⃣': {
        name: 'uno',
        keywords: ['Teclas'],
    },
    '2️⃣': {
        name: 'dos',
        keywords: ['Teclas'],
    },
    '3️⃣': {
        name: 'tres',
        keywords: ['Teclas'],
    },
    '4️⃣': {
        name: 'cuatro',
        keywords: ['Teclas'],
    },
    '5️⃣': {
        name: 'cinco',
        keywords: ['Teclas'],
    },
    '6️⃣': {
        name: 'seis',
        keywords: ['Teclas'],
    },
    '7️⃣': {
        name: 'siete',
        keywords: ['Teclas'],
    },
    '8️⃣': {
        name: 'ocho',
        keywords: ['Teclas'],
    },
    '9️⃣': {
        name: 'nueve',
        keywords: ['Teclas'],
    },
    '🔟': {
        name: 'diez_enmarcado',
        keywords: ['Teclas'],
    },
    '🔠': {
        name: 'abcd_en_mayúsculas',
        keywords: ['abcd', 'letras', 'mayúsculas', 'letras latinas mayúsculas'],
    },
    '🔡': {
        name: 'abcd',
        keywords: ['abcd', 'letras', 'minúsculas', 'letras latinas minúsculas'],
    },
    '🔢': {
        name: '1234',
        keywords: ['1234', 'dígitos', 'números'],
    },
    '🔣': {
        name: 'símbolos',
        keywords: ['〒♪&%', 'símbolos'],
    },
    '🔤': {
        name: 'abc',
        keywords: ['ABC', 'latino', 'alfabeto latino'],
    },
    '🅰️': {
        name: 'a',
        keywords: ['A', 'grupo', 'sanguíneo', 'tipo A'],
    },
    '🆎': {
        name: 'ab',
        keywords: ['AB', 'grupo', 'sanguíneo', 'tipo AB'],
    },
    '🅱️': {
        name: 'b',
        keywords: ['B', 'grupo', 'sanguíneo', 'tipo B'],
    },
    '🆑': {
        name: 'cl',
        keywords: ['símbolo', 'borrar'],
    },
    '🆒': {
        name: 'guay',
        keywords: ['botón', 'cool', 'mola', 'botón COOL'],
    },
    '🆓': {
        name: 'gratis',
        keywords: ['gratis', 'símbolo gratis', 'botón FREE'],
    },
    ℹ️: {
        name: 'fuente_de_información',
        keywords: ['i', 'información'],
    },
    '🆔': {
        name: 'carné_de_identidad',
        keywords: ['ID', 'identidad', 'símbolo identidad', 'símbolo de identificación'],
    },
    'Ⓜ️': {
        name: 'm',
        keywords: ['círculo', 'm', 'm en círculo'],
    },
    '🆕': {
        name: 'nuevo',
        keywords: ['botón', 'NEW', 'nuevo'],
    },
    '🆖': {
        name: 'nada_guay',
        keywords: ['botón', 'ng', 'nuevo', 'botón NG'],
    },
    '🅾️': {
        name: 'o2',
        keywords: ['grupo sanguíneo', 'o', 'grupo sanguíneo tipo O'],
    },
    '🆗': {
        name: 'vale',
        keywords: ['botón', 'ok', 'botón OK'],
    },
    '🅿️': {
        name: 'aparcamiento',
        keywords: ['p', 'parking', 'aparcamiento'],
    },
    '🆘': {
        name: 'llamada_de_socorro',
        keywords: ['ayuda', 'símbolo', 'socorro', 'sos', 'símbolo de socorro'],
    },
    '🆙': {
        name: 'arriba',
        keywords: ['arriba', 'información', 'novedad', 'símbolo', 'up', 'botón UP!'],
    },
    '🆚': {
        name: 'vs',
        keywords: ['contra', 'frente a', 'símbolo', 'versus', 'vs', 'botón VS'],
    },
    '🈁': {
        name: 'koko',
        keywords: ['“aquí”', 'japonés', 'katakana', 'ideograma japonés para "aquí"'],
    },
    '🈂️': {
        name: 'sa',
        keywords: ['cortesía', 'japonés', 'katakana', 'ideograma japonés para "de cortesía"'],
    },
    '🈷️': {
        name: 'u6708',
        keywords: ['“cantidad mensual”', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "cantidad mensual"'],
    },
    '🈶': {
        name: 'u6709',
        keywords: ['“de pago”', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "de pago"'],
    },
    '🈯': {
        name: 'u6307',
        keywords: ['ideograma', 'japonés', 'kanji', 'reservado', 'ideograma japonés para "reservado"'],
    },
    '🉐': {
        name: 'símbolo_de_ganga',
        keywords: ['ganga', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "ganga"'],
    },
    '🈹': {
        name: 'u5272',
        keywords: ['descuento', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "descuento"'],
    },
    '🈚': {
        name: 'u7121',
        keywords: ['gratis', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "gratis"'],
    },
    '🈲': {
        name: 'u7981',
        keywords: ['ideograma', 'japonés', 'kanji', 'prohibido', 'ideograma japonés para "prohibido"'],
    },
    '🉑': {
        name: 'aceptar',
        keywords: ['aceptable', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "aceptable"'],
    },
    '🈸': {
        name: 'u7533',
        keywords: ['aplicación', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "aplicación"'],
    },
    '🈴': {
        name: 'u5408',
        keywords: ['aprobado', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "aprobado"'],
    },
    '🈳': {
        name: 'u7a7a',
        keywords: ['ideograma', 'japonés', 'kanji', 'vacante', 'ideograma japonés para "vacante"'],
    },
    '㊗️': {
        name: 'felicitaciones',
        keywords: ['enhorabuena', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "enhorabuena"'],
    },
    '㊙️': {
        name: 'secreto',
        keywords: ['ideograma', 'japonés', 'kanji', 'secreto', 'ideograma japonés para "secreto"'],
    },
    '🈺': {
        name: 'u55b6',
        keywords: ['abierto', 'ideograma', 'japonés', 'kanji', 'ideograma japonés para "abierto"'],
    },
    '🈵': {
        name: 'u6e80',
        keywords: ['completo', 'ideograma', 'japonés', 'kanji', 'lleno', 'ideograma japonés para "completo"'],
    },
    '🔴': {
        name: 'círculo_rojo',
        keywords: ['círculo', 'geometría', 'rojo'],
    },
    '🟠': {
        name: 'círculo_naranja_grande',
        keywords: ['círculo', 'naranja'],
    },
    '🟡': {
        name: 'círculo_amarillo_grande',
        keywords: ['amarillo', 'círculo'],
    },
    '🟢': {
        name: 'círculo_verde_grande',
        keywords: ['círculo', 'verde'],
    },
    '🔵': {
        name: 'círculo_azul_grande',
        keywords: ['azul', 'círculo', 'geometría'],
    },
    '🟣': {
        name: 'círculo_morado_grande',
        keywords: ['círculo', 'lila', 'morado', 'púrpura'],
    },
    '🟤': {
        name: 'círculo_marrón_grande',
        keywords: ['círculo', 'marrón'],
    },
    '⚫': {
        name: 'círculo_negro',
        keywords: ['círculo', 'geometría', 'círculo negro'],
    },
    '⚪': {
        name: 'círculo_blanco',
        keywords: ['círculo', 'geometría', 'círculo blanco'],
    },
    '🟥': {
        name: 'cuadrado_rojo_grande',
        keywords: ['cuadrado', 'rojo'],
    },
    '🟧': {
        name: 'cuadrado_naranja_grande',
        keywords: ['cuadrado', 'naranja'],
    },
    '🟨': {
        name: 'cuadrado_amarillo_grande',
        keywords: ['amarillo', 'cuadrado'],
    },
    '🟩': {
        name: 'cuadrado_verde_grande',
        keywords: ['cuadrado', 'verde'],
    },
    '🟦': {
        name: 'cuadrado_azul_grande',
        keywords: ['azul', 'cuadrado'],
    },
    '🟪': {
        name: 'cuadrado_morado_grande',
        keywords: ['cuadrado', 'lila', 'morado', 'púrpura'],
    },
    '🟫': {
        name: 'cuadrado_marrón_grande',
        keywords: ['cuadrado', 'marrón'],
    },
    '⬛': {
        name: 'gran_cuadrado_negro',
        keywords: ['cuadrado', 'geometría', 'negro', 'cuadrado negro grande'],
    },
    '⬜': {
        name: 'cuadrado_blanco_grande',
        keywords: ['blanco', 'cuadrado', 'geometría', 'cuadrado blanco grande'],
    },
    '◼️': {
        name: 'cuadrado_mediano_negro',
        keywords: ['cuadrado', 'geometría', 'negro', 'cuadrado negro mediano'],
    },
    '◻️': {
        name: 'cuadrado_blanco_mediano',
        keywords: ['blanco', 'cuadrado', 'geometría', 'cuadrado blanco mediano'],
    },
    '◾': {
        name: 'cuadrado_mediano_pequeño_negro',
        keywords: ['cuadrado', 'geometría', 'negro', 'cuadrado negro mediano-pequeño'],
    },
    '◽': {
        name: 'cuadrado_blanco_mediano_pequeño',
        keywords: ['blanco', 'cuadrado', 'geometría', 'cuadrado blanco mediano-pequeño'],
    },
    '▪️': {
        name: 'cuadrado_pequeño_negro',
        keywords: ['cuadrado', 'geometría', 'negro', 'cuadrado negro pequeño'],
    },
    '▫️': {
        name: 'cuadrado_blanco_pequeño',
        keywords: ['blanco', 'cuadrado', 'geometría', 'cuadrado blanco pequeño'],
    },
    '🔶': {
        name: 'diamante_naranja_grande',
        keywords: ['geometría', 'naranja', 'rombo', 'rombo naranja grande'],
    },
    '🔷': {
        name: 'diamante_azul_grande',
        keywords: ['azul', 'geometría', 'rombo', 'rombo azul grande'],
    },
    '🔸': {
        name: 'diamante_naranja_pequeño',
        keywords: ['geometría', 'naranja', 'rombo', 'rombo naranja pequeño'],
    },
    '🔹': {
        name: 'diamante_azul_pequeño',
        keywords: ['azul', 'geometría', 'rombo', 'rombo azul pequeño'],
    },
    '🔺': {
        name: 'triángulo_rojo_pequeño',
        keywords: ['geometría', 'rojo', 'triángulo', 'triángulo hacia arriba rojo', 'triángulo rojo hacia arriba'],
    },
    '🔻': {
        name: 'triángulo_rojo_pequeño_hacia_abajo',
        keywords: ['geometría', 'rojo', 'triángulo', 'triángulo hacia abajo rojo', 'triángulo rojo hacia abajo'],
    },
    '💠': {
        name: 'forma_de_diamante_con_un_punto_dentro',
        keywords: ['flor', 'geometría', 'rombo', 'rombo con pétalo'],
    },
    '🔘': {
        name: 'botón_de_radio',
        keywords: ['botón', 'opción', 'botón de opción'],
    },
    '🔳': {
        name: 'botón_cuadrado_blanco',
        keywords: ['botón', 'cuadrado', 'botón cuadrado con borde blanco'],
    },
    '🔲': {
        name: 'botón_cuadrado_negro',
        keywords: ['botón', 'cuadrado', 'botón cuadrado con borde negro'],
    },
    '🏁': {
        name: 'bandera_de_cuadros',
        keywords: ['bandera', 'carreras', 'cuadros', 'deporte', 'motor', 'bandera de cuadros'],
    },
    '🚩': {
        name: 'mastil_con_bandera_triangular',
        keywords: ['bandera', 'bandera de localización triangular', 'bandera informativa de localización', 'localización', 'bandera triangular'],
    },
    '🎌': {
        name: 'banderas_cruzadas',
        keywords: ['banderas', 'celebración', 'japón', 'banderas cruzadas'],
    },
    '🏴': {
        name: 'ondeando_bandera_negra',
        keywords: ['bandera', 'negra', 'ondear'],
    },
    '🏳️': {
        name: 'ondeando_bandera_blanca',
        keywords: ['bandera', 'blanca', 'ondear'],
    },
    '🏳️‍🌈': {
        name: 'bandera-arcoíris',
        keywords: ['arcoíris', 'bandera', 'bandera del arcoíris'],
    },
    '🏳️‍⚧️': {
        name: 'bandera_transgénero',
        keywords: ['azul', 'bandera', 'blanco', 'LGTB', 'rosa', 'transgénero'],
    },
    '🏴‍☠️': {
        name: 'bandera_pirata',
        keywords: ['botín', 'Jolly Roger', 'pirata', 'tesoro', 'bandera pirata'],
    },
    '🇦🇨': {
        name: 'bandera-ac',
        keywords: ['Bandera'],
    },
    '🇦🇩': {
        name: 'bandera-ad',
        keywords: ['Bandera'],
    },
    '🇦🇪': {
        name: 'bandera-ae',
        keywords: ['Bandera'],
    },
    '🇦🇫': {
        name: 'bandera-af',
        keywords: ['Bandera'],
    },
    '🇦🇬': {
        name: 'bandera-ag',
        keywords: ['Bandera'],
    },
    '🇦🇮': {
        name: 'bandera-ai',
        keywords: ['Bandera'],
    },
    '🇦🇱': {
        name: 'bandera-al',
        keywords: ['Bandera'],
    },
    '🇦🇲': {
        name: 'bandera-am',
        keywords: ['Bandera'],
    },
    '🇦🇴': {
        name: 'bandera-ao',
        keywords: ['Bandera'],
    },
    '🇦🇶': {
        name: 'bandera-aq',
        keywords: ['Bandera'],
    },
    '🇦🇷': {
        name: 'bandera-ar',
        keywords: ['Bandera'],
    },
    '🇦🇸': {
        name: 'bandera-as',
        keywords: ['Bandera'],
    },
    '🇦🇹': {
        name: 'bandera-at',
        keywords: ['Bandera'],
    },
    '🇦🇺': {
        name: 'bandera-au',
        keywords: ['Bandera'],
    },
    '🇦🇼': {
        name: 'bandera-aw',
        keywords: ['Bandera'],
    },
    '🇦🇽': {
        name: 'bandera-ax',
        keywords: ['Bandera'],
    },
    '🇦🇿': {
        name: 'bandera-az',
        keywords: ['Bandera'],
    },
    '🇧🇦': {
        name: 'bandera-ba',
        keywords: ['Bandera'],
    },
    '🇧🇧': {
        name: 'bandera-bb',
        keywords: ['Bandera'],
    },
    '🇧🇩': {
        name: 'bandera-bd',
        keywords: ['Bandera'],
    },
    '🇧🇪': {
        name: 'bandera-be',
        keywords: ['Bandera'],
    },
    '🇧🇫': {
        name: 'bandera-bf',
        keywords: ['Bandera'],
    },
    '🇧🇬': {
        name: 'bandera-bg',
        keywords: ['Bandera'],
    },
    '🇧🇭': {
        name: 'bandera-bh',
        keywords: ['Bandera'],
    },
    '🇧🇮': {
        name: 'bandera-bi',
        keywords: ['Bandera'],
    },
    '🇧🇯': {
        name: 'bandera-bj',
        keywords: ['Bandera'],
    },
    '🇧🇱': {
        name: 'bandera-bl',
        keywords: ['Bandera'],
    },
    '🇧🇲': {
        name: 'bandera-bm',
        keywords: ['Bandera'],
    },
    '🇧🇳': {
        name: 'bandera-bn',
        keywords: ['Bandera'],
    },
    '🇧🇴': {
        name: 'bandera-bo',
        keywords: ['Bandera'],
    },
    '🇧🇶': {
        name: 'bandera-bq',
        keywords: ['Bandera'],
    },
    '🇧🇷': {
        name: 'bandera-br',
        keywords: ['Bandera'],
    },
    '🇧🇸': {
        name: 'bandera-bs',
        keywords: ['Bandera'],
    },
    '🇧🇹': {
        name: 'bandera-bt',
        keywords: ['Bandera'],
    },
    '🇧🇻': {
        name: 'bandera-bv',
        keywords: ['Bandera'],
    },
    '🇧🇼': {
        name: 'bandera-bw',
        keywords: ['Bandera'],
    },
    '🇧🇾': {
        name: 'bandera-by',
        keywords: ['Bandera'],
    },
    '🇧🇿': {
        name: 'bandera-bz',
        keywords: ['Bandera'],
    },
    '🇨🇦': {
        name: 'bandera-ca',
        keywords: ['Bandera'],
    },
    '🇨🇨': {
        name: 'bandera-cc',
        keywords: ['Bandera'],
    },
    '🇨🇩': {
        name: 'bandera-cd',
        keywords: ['Bandera'],
    },
    '🇨🇫': {
        name: 'bandera-cf',
        keywords: ['Bandera'],
    },
    '🇨🇬': {
        name: 'bandera-cg',
        keywords: ['Bandera'],
    },
    '🇨🇭': {
        name: 'bandera-ch',
        keywords: ['Bandera'],
    },
    '🇨🇮': {
        name: 'bandera-ci',
        keywords: ['Bandera'],
    },
    '🇨🇰': {
        name: 'bandera-ck',
        keywords: ['Bandera'],
    },
    '🇨🇱': {
        name: 'bandera-cl',
        keywords: ['Bandera'],
    },
    '🇨🇲': {
        name: 'bandera-cm',
        keywords: ['Bandera'],
    },
    '🇨🇳': {
        name: 'cn',
        keywords: ['Bandera'],
    },
    '🇨🇴': {
        name: 'bandera-co',
        keywords: ['Bandera'],
    },
    '🇨🇵': {
        name: 'bandera-cp',
        keywords: ['Bandera'],
    },
    '🇨🇷': {
        name: 'bandera-cr',
        keywords: ['Bandera'],
    },
    '🇨🇺': {
        name: 'bandera-cu',
        keywords: ['Bandera'],
    },
    '🇨🇻': {
        name: 'bandera-cv',
        keywords: ['Bandera'],
    },
    '🇨🇼': {
        name: 'bandera-cw',
        keywords: ['Bandera'],
    },
    '🇨🇽': {
        name: 'bandera-cx',
        keywords: ['Bandera'],
    },
    '🇨🇾': {
        name: 'bandera-cy',
        keywords: ['Bandera'],
    },
    '🇨🇿': {
        name: 'bandera-cz',
        keywords: ['Bandera'],
    },
    '🇩🇪': {
        name: 'de',
        keywords: ['Bandera'],
    },
    '🇩🇬': {
        name: 'bandera-dg',
        keywords: ['Bandera'],
    },
    '🇩🇯': {
        name: 'bandera-dj',
        keywords: ['Bandera'],
    },
    '🇩🇰': {
        name: 'bandera-dk',
        keywords: ['Bandera'],
    },
    '🇩🇲': {
        name: 'bandera-dm',
        keywords: ['Bandera'],
    },
    '🇩🇴': {
        name: 'bandera-do',
        keywords: ['Bandera'],
    },
    '🇩🇿': {
        name: 'bandera-dz',
        keywords: ['Bandera'],
    },
    '🇪🇦': {
        name: 'bandera-ea',
        keywords: ['Bandera'],
    },
    '🇪🇨': {
        name: 'bandera-ec',
        keywords: ['Bandera'],
    },
    '🇪🇪': {
        name: 'bandera-ee',
        keywords: ['Bandera'],
    },
    '🇪🇬': {
        name: 'bandera-eg',
        keywords: ['Bandera'],
    },
    '🇪🇭': {
        name: 'bandera-eh',
        keywords: ['Bandera'],
    },
    '🇪🇷': {
        name: 'bandera-er',
        keywords: ['Bandera'],
    },
    '🇪🇸': {
        name: 'es',
        keywords: ['Bandera'],
    },
    '🇪🇹': {
        name: 'bandera-et',
        keywords: ['Bandera'],
    },
    '🇪🇺': {
        name: 'bandera-eu',
        keywords: ['Bandera'],
    },
    '🇫🇮': {
        name: 'bandera-fi',
        keywords: ['Bandera'],
    },
    '🇫🇯': {
        name: 'bandera-fj',
        keywords: ['Bandera'],
    },
    '🇫🇰': {
        name: 'bandera-fk',
        keywords: ['Bandera'],
    },
    '🇫🇲': {
        name: 'bandera-fm',
        keywords: ['Bandera'],
    },
    '🇫🇴': {
        name: 'bandera-fo',
        keywords: ['Bandera'],
    },
    '🇫🇷': {
        name: 'fr',
        keywords: ['Bandera'],
    },
    '🇬🇦': {
        name: 'bandera-ga',
        keywords: ['Bandera'],
    },
    '🇬🇧': {
        name: 'gb',
        keywords: ['Bandera'],
    },
    '🇬🇩': {
        name: 'bandera-gd',
        keywords: ['Bandera'],
    },
    '🇬🇪': {
        name: 'bandera-ge',
        keywords: ['Bandera'],
    },
    '🇬🇫': {
        name: 'bandera-gf',
        keywords: ['Bandera'],
    },
    '🇬🇬': {
        name: 'bandera-gg',
        keywords: ['Bandera'],
    },
    '🇬🇭': {
        name: 'bandera-gh',
        keywords: ['Bandera'],
    },
    '🇬🇮': {
        name: 'bandera-gi',
        keywords: ['Bandera'],
    },
    '🇬🇱': {
        name: 'bandera-gl',
        keywords: ['Bandera'],
    },
    '🇬🇲': {
        name: 'bandera-gm',
        keywords: ['Bandera'],
    },
    '🇬🇳': {
        name: 'bandera-gn',
        keywords: ['Bandera'],
    },
    '🇬🇵': {
        name: 'bandera-gp',
        keywords: ['Bandera'],
    },
    '🇬🇶': {
        name: 'bandera-gq',
        keywords: ['Bandera'],
    },
    '🇬🇷': {
        name: 'bandera-gr',
        keywords: ['Bandera'],
    },
    '🇬🇸': {
        name: 'bandera-gs',
        keywords: ['Bandera'],
    },
    '🇬🇹': {
        name: 'bandera-gt',
        keywords: ['Bandera'],
    },
    '🇬🇺': {
        name: 'bandera-gu',
        keywords: ['Bandera'],
    },
    '🇬🇼': {
        name: 'bandera-gw',
        keywords: ['Bandera'],
    },
    '🇬🇾': {
        name: 'bandera-gy',
        keywords: ['Bandera'],
    },
    '🇭🇰': {
        name: 'bandera-hk',
        keywords: ['Bandera'],
    },
    '🇭🇲': {
        name: 'bandera-hm',
        keywords: ['Bandera'],
    },
    '🇭🇳': {
        name: 'bandera-hn',
        keywords: ['Bandera'],
    },
    '🇭🇷': {
        name: 'bandera-hr',
        keywords: ['Bandera'],
    },
    '🇭🇹': {
        name: 'bandera-ht',
        keywords: ['Bandera'],
    },
    '🇭🇺': {
        name: 'bandera-hu',
        keywords: ['Bandera'],
    },
    '🇮🇨': {
        name: 'bandera-ic',
        keywords: ['Bandera'],
    },
    '🇮🇩': {
        name: 'bandera-id',
        keywords: ['Bandera'],
    },
    '🇮🇪': {
        name: 'bandera-ie',
        keywords: ['Bandera'],
    },
    '🇮🇱': {
        name: 'bandera-il',
        keywords: ['Bandera'],
    },
    '🇮🇲': {
        name: 'bandera-im',
        keywords: ['Bandera'],
    },
    '🇮🇳': {
        name: 'bandera-in',
        keywords: ['Bandera'],
    },
    '🇮🇴': {
        name: 'bandera-io',
        keywords: ['Bandera'],
    },
    '🇮🇶': {
        name: 'bandera-iq',
        keywords: ['Bandera'],
    },
    '🇮🇷': {
        name: 'bandera-ir',
        keywords: ['Bandera'],
    },
    '🇮🇸': {
        name: 'bandera-is',
        keywords: ['Bandera'],
    },
    '🇮🇹': {
        name: 'it',
        keywords: ['Bandera'],
    },
    '🇯🇪': {
        name: 'bandera-je',
        keywords: ['Bandera'],
    },
    '🇯🇲': {
        name: 'bandera-jm',
        keywords: ['Bandera'],
    },
    '🇯🇴': {
        name: 'bandera-jo',
        keywords: ['Bandera'],
    },
    '🇯🇵': {
        name: 'jp',
        keywords: ['Bandera'],
    },
    '🇰🇪': {
        name: 'bandera-ke',
        keywords: ['Bandera'],
    },
    '🇰🇬': {
        name: 'bandera-kg',
        keywords: ['Bandera'],
    },
    '🇰🇭': {
        name: 'bandera-kh',
        keywords: ['Bandera'],
    },
    '🇰🇮': {
        name: 'bandera-kl',
        keywords: ['Bandera'],
    },
    '🇰🇲': {
        name: 'bandera-km',
        keywords: ['Bandera'],
    },
    '🇰🇳': {
        name: 'bandera-kn',
        keywords: ['Bandera'],
    },
    '🇰🇵': {
        name: 'bandera-kp',
        keywords: ['Bandera'],
    },
    '🇰🇷': {
        name: 'kr',
        keywords: ['Bandera'],
    },
    '🇰🇼': {
        name: 'bandera-kw',
        keywords: ['Bandera'],
    },
    '🇰🇾': {
        name: 'bandera-ky',
        keywords: ['Bandera'],
    },
    '🇰🇿': {
        name: 'bandera-kz',
        keywords: ['Bandera'],
    },
    '🇱🇦': {
        name: 'bandera-la',
        keywords: ['Bandera'],
    },
    '🇱🇧': {
        name: 'bandera-lb',
        keywords: ['Bandera'],
    },
    '🇱🇨': {
        name: 'bandera-lc',
        keywords: ['Bandera'],
    },
    '🇱🇮': {
        name: 'bandera-li',
        keywords: ['Bandera'],
    },
    '🇱🇰': {
        name: 'bandera-lk',
        keywords: ['Bandera'],
    },
    '🇱🇷': {
        name: 'bandera-lr',
        keywords: ['Bandera'],
    },
    '🇱🇸': {
        name: 'bandera-ls',
        keywords: ['Bandera'],
    },
    '🇱🇹': {
        name: 'bandera-lt',
        keywords: ['Bandera'],
    },
    '🇱🇺': {
        name: 'bandera-lu',
        keywords: ['Bandera'],
    },
    '🇱🇻': {
        name: 'bandera-lv',
        keywords: ['Bandera'],
    },
    '🇱🇾': {
        name: 'bandera-ly',
        keywords: ['Bandera'],
    },
    '🇲🇦': {
        name: 'bandera-ma',
        keywords: ['Bandera'],
    },
    '🇲🇨': {
        name: 'bandera-mc',
        keywords: ['Bandera'],
    },
    '🇲🇩': {
        name: 'bandera-md',
        keywords: ['Bandera'],
    },
    '🇲🇪': {
        name: 'bandera-me',
        keywords: ['Bandera'],
    },
    '🇲🇫': {
        name: 'bandera-mf',
        keywords: ['Bandera'],
    },
    '🇲🇬': {
        name: 'bandera-mg',
        keywords: ['Bandera'],
    },
    '🇲🇭': {
        name: 'bandera-mh',
        keywords: ['Bandera'],
    },
    '🇲🇰': {
        name: 'bandera-mk',
        keywords: ['Bandera'],
    },
    '🇲🇱': {
        name: 'bandera-ml',
        keywords: ['Bandera'],
    },
    '🇲🇲': {
        name: 'bandera-mm',
        keywords: ['Bandera'],
    },
    '🇲🇳': {
        name: 'bandera-mn',
        keywords: ['Bandera'],
    },
    '🇲🇴': {
        name: 'bandera-mo',
        keywords: ['Bandera'],
    },
    '🇲🇵': {
        name: 'bandera-mp',
        keywords: ['Bandera'],
    },
    '🇲🇶': {
        name: 'bandera-mq',
        keywords: ['Bandera'],
    },
    '🇲🇷': {
        name: 'bandera-mr',
        keywords: ['Bandera'],
    },
    '🇲🇸': {
        name: 'bandera-ms',
        keywords: ['Bandera'],
    },
    '🇲🇹': {
        name: 'bandera-mt',
        keywords: ['Bandera'],
    },
    '🇲🇺': {
        name: 'bandera-mu',
        keywords: ['Bandera'],
    },
    '🇲🇻': {
        name: 'bandera-mv',
        keywords: ['Bandera'],
    },
    '🇲🇼': {
        name: 'bandera-mw',
        keywords: ['Bandera'],
    },
    '🇲🇽': {
        name: 'bandera-mx',
        keywords: ['Bandera'],
    },
    '🇲🇾': {
        name: 'bandera-my',
        keywords: ['Bandera'],
    },
    '🇲🇿': {
        name: 'bandera-mz',
        keywords: ['Bandera'],
    },
    '🇳🇦': {
        name: 'bandera-na',
        keywords: ['Bandera'],
    },
    '🇳🇨': {
        name: 'bandera-nc',
        keywords: ['Bandera'],
    },
    '🇳🇪': {
        name: 'bandera-ne',
        keywords: ['Bandera'],
    },
    '🇳🇫': {
        name: 'bandera-nf',
        keywords: ['Bandera'],
    },
    '🇳🇬': {
        name: 'bandera-ng',
        keywords: ['Bandera'],
    },
    '🇳🇮': {
        name: 'bandera-ni',
        keywords: ['Bandera'],
    },
    '🇳🇱': {
        name: 'bandera-nl',
        keywords: ['Bandera'],
    },
    '🇳🇴': {
        name: 'bandera-no',
        keywords: ['Bandera'],
    },
    '🇳🇵': {
        name: 'bandera-np',
        keywords: ['Bandera'],
    },
    '🇳🇷': {
        name: 'bandera-nr',
        keywords: ['Bandera'],
    },
    '🇳🇺': {
        name: 'bandera-nu',
        keywords: ['Bandera'],
    },
    '🇳🇿': {
        name: 'bandera-nz',
        keywords: ['Bandera'],
    },
    '🇴🇲': {
        name: 'bandera-om',
        keywords: ['Bandera'],
    },
    '🇵🇦': {
        name: 'bandera-pa',
        keywords: ['Bandera'],
    },
    '🇵🇪': {
        name: 'bandera-pe',
        keywords: ['Bandera'],
    },
    '🇵🇫': {
        name: 'bandera-pf',
        keywords: ['Bandera'],
    },
    '🇵🇬': {
        name: 'bandera-pg',
        keywords: ['Bandera'],
    },
    '🇵🇭': {
        name: 'bandera-ph',
        keywords: ['Bandera'],
    },
    '🇵🇰': {
        name: 'bandera-pk',
        keywords: ['Bandera'],
    },
    '🇵🇱': {
        name: 'bandera-pl',
        keywords: ['Bandera'],
    },
    '🇵🇲': {
        name: 'bandera-pm',
        keywords: ['Bandera'],
    },
    '🇵🇳': {
        name: 'bandera-pn',
        keywords: ['Bandera'],
    },
    '🇵🇷': {
        name: 'bandera-pr',
        keywords: ['Bandera'],
    },
    '🇵🇸': {
        name: 'bandera-ps',
        keywords: ['Bandera'],
    },
    '🇵🇹': {
        name: 'bandera-pt',
        keywords: ['Bandera'],
    },
    '🇵🇼': {
        name: 'bandera-pw',
        keywords: ['Bandera'],
    },
    '🇵🇾': {
        name: 'bandera-py',
        keywords: ['Bandera'],
    },
    '🇶🇦': {
        name: 'bandera-qa',
        keywords: ['Bandera'],
    },
    '🇷🇪': {
        name: 'bandera-re',
        keywords: ['Bandera'],
    },
    '🇷🇴': {
        name: 'bandera-ro',
        keywords: ['Bandera'],
    },
    '🇷🇸': {
        name: 'bandera-rs',
        keywords: ['Bandera'],
    },
    '🇷🇺': {
        name: 'ru',
        keywords: ['Bandera'],
    },
    '🇷🇼': {
        name: 'bandera-rw',
        keywords: ['Bandera'],
    },
    '🇸🇦': {
        name: 'bandera-sa',
        keywords: ['Bandera'],
    },
    '🇸🇧': {
        name: 'bandera-sb',
        keywords: ['Bandera'],
    },
    '🇸🇨': {
        name: 'bandera-sc',
        keywords: ['Bandera'],
    },
    '🇸🇩': {
        name: 'bandera-sd',
        keywords: ['Bandera'],
    },
    '🇸🇪': {
        name: 'bandera-se',
        keywords: ['Bandera'],
    },
    '🇸🇬': {
        name: 'bandera-sg',
        keywords: ['Bandera'],
    },
    '🇸🇭': {
        name: 'bandera-sh',
        keywords: ['Bandera'],
    },
    '🇸🇮': {
        name: 'bandera-si',
        keywords: ['Bandera'],
    },
    '🇸🇯': {
        name: 'bandera-sj',
        keywords: ['Bandera'],
    },
    '🇸🇰': {
        name: 'bandera-sk',
        keywords: ['Bandera'],
    },
    '🇸🇱': {
        name: 'bandera-sl',
        keywords: ['Bandera'],
    },
    '🇸🇲': {
        name: 'bandera-sm',
        keywords: ['Bandera'],
    },
    '🇸🇳': {
        name: 'bandera-sn',
        keywords: ['Bandera'],
    },
    '🇸🇴': {
        name: 'bandera-so',
        keywords: ['Bandera'],
    },
    '🇸🇷': {
        name: 'bandera-sr',
        keywords: ['Bandera'],
    },
    '🇸🇸': {
        name: 'bandera-ss',
        keywords: ['Bandera'],
    },
    '🇸🇹': {
        name: 'bandera-st',
        keywords: ['Bandera'],
    },
    '🇸🇻': {
        name: 'bandera-sv',
        keywords: ['Bandera'],
    },
    '🇸🇽': {
        name: 'bandera-sx',
        keywords: ['Bandera'],
    },
    '🇸🇾': {
        name: 'bandera-sy',
        keywords: ['Bandera'],
    },
    '🇸🇿': {
        name: 'bandera-sz',
        keywords: ['Bandera'],
    },
    '🇹🇦': {
        name: 'bandera-ta',
        keywords: ['Bandera'],
    },
    '🇹🇨': {
        name: 'bandera-tc',
        keywords: ['Bandera'],
    },
    '🇹🇩': {
        name: 'bandera-td',
        keywords: ['Bandera'],
    },
    '🇹🇫': {
        name: 'bandera-tf',
        keywords: ['Bandera'],
    },
    '🇹🇬': {
        name: 'bandera-tg',
        keywords: ['Bandera'],
    },
    '🇹🇭': {
        name: 'bandera-th',
        keywords: ['Bandera'],
    },
    '🇹🇯': {
        name: 'bandera-tj',
        keywords: ['Bandera'],
    },
    '🇹🇰': {
        name: 'bandera-tk',
        keywords: ['Bandera'],
    },
    '🇹🇱': {
        name: 'bandera-tl',
        keywords: ['Bandera'],
    },
    '🇹🇲': {
        name: 'bandera-tm',
        keywords: ['Bandera'],
    },
    '🇹🇳': {
        name: 'bandera-tn',
        keywords: ['Bandera'],
    },
    '🇹🇴': {
        name: 'bandera-to',
        keywords: ['Bandera'],
    },
    '🇹🇷': {
        name: 'bandera-tr',
        keywords: ['Bandera'],
    },
    '🇹🇹': {
        name: 'bandera-tt',
        keywords: ['Bandera'],
    },
    '🇹🇻': {
        name: 'bandera-tv',
        keywords: ['Bandera'],
    },
    '🇹🇼': {
        name: 'bandera-tw',
        keywords: ['Bandera'],
    },
    '🇹🇿': {
        name: 'bandera-tz',
        keywords: ['Bandera'],
    },
    '🇺🇦': {
        name: 'bandera-ua',
        keywords: ['Bandera'],
    },
    '🇺🇬': {
        name: 'bandera-ug',
        keywords: ['Bandera'],
    },
    '🇺🇲': {
        name: 'bandera-um',
        keywords: ['Bandera'],
    },
    '🇺🇳': {
        name: 'bandera-onu',
        keywords: ['Bandera'],
    },
    '🇺🇸': {
        name: 'us',
        keywords: ['Bandera'],
    },
    '🇺🇾': {
        name: 'bandera-uy',
        keywords: ['Bandera'],
    },
    '🇺🇿': {
        name: 'bandera-uz',
        keywords: ['Bandera'],
    },
    '🇻🇦': {
        name: 'bandera-va',
        keywords: ['Bandera'],
    },
    '🇻🇨': {
        name: 'bandera-vc',
        keywords: ['Bandera'],
    },
    '🇻🇪': {
        name: 'bandera-ve',
        keywords: ['Bandera'],
    },
    '🇻🇬': {
        name: 'bandera-vg',
        keywords: ['Bandera'],
    },
    '🇻🇮': {
        name: 'bandera-vi',
        keywords: ['Bandera'],
    },
    '🇻🇳': {
        name: 'bandera-vn',
        keywords: ['Bandera'],
    },
    '🇻🇺': {
        name: 'bandera-vu',
        keywords: ['Bandera'],
    },
    '🇼🇫': {
        name: 'bandera-wf',
        keywords: ['Bandera'],
    },
    '🇼🇸': {
        name: 'bandera-ws',
        keywords: ['Bandera'],
    },
    '🇽🇰': {
        name: 'bandera-xk',
        keywords: ['Bandera'],
    },
    '🇾🇪': {
        name: 'bandera-ye',
        keywords: ['Bandera'],
    },
    '🇾🇹': {
        name: 'bandera-yt',
        keywords: ['Bandera'],
    },
    '🇿🇦': {
        name: 'bandera-za',
        keywords: ['Bandera'],
    },
    '🇿🇲': {
        name: 'bandera-zm',
        keywords: ['Bandera'],
    },
    '🇿🇼': {
        name: 'bandera-zw',
        keywords: ['Bandera'],
    },
    '🏴󠁧󠁢󠁥󠁮󠁧󠁿': {
        name: 'bandera-inglaterra',
        keywords: ['Bandera'],
    },
    '🏴󠁧󠁢󠁳󠁣󠁴󠁿': {
        name: 'bandera-escocia',
        keywords: ['Bandera'],
    },
    '🏴󠁧󠁢󠁷󠁬󠁳󠁿': {
        name: 'bandera-gales',
        keywords: ['Bandera'],
    },
};

export default esEmojis;
